const tokens = {
  "animations.slide-in-start": {
    "value": "slide-in-start 0.45s cubic-bezier(0.76, 0, 0.24, 1)",
    "variable": "var(--jtIYwf)"
  },
  "animations.slide-in-end": {
    "value": "slide-in-end 0.45s cubic-bezier(0.76, 0, 0.24, 1)",
    "variable": "var(--kqDtGI)"
  },
  "breakpoints.sm": {
    "value": "20em",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "30em",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "48em",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "64em",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.xxl": {
    "value": "80em",
    "variable": "var(--dymagS)"
  },
  "sizes.breakpoint-sm": {
    "value": "20em",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "30em",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "48em",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "64em",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-xxl": {
    "value": "80em",
    "variable": "var(--bfIHqC)"
  },
  "sizes.listingInfoCard.width": {
    "value": "var(--himBAv)",
    "variable": "var(--himBAv)"
  },
  "sizes.chrome.desktopHeader": {
    "value": "6.125rem",
    "variable": "var(--hSJtwy)"
  },
  "sizes.locationSuggestion.heading": {
    "value": "var(--hOxqih)",
    "variable": "var(--jxOjTw)"
  },
  "sizes.locationSuggestion.row": {
    "value": "calc(var(--hOxqih) + var(--dmLIIl))",
    "variable": "var(--bOdpRC)"
  },
  "spacing.chrome.gutter": {
    "value": "1rem",
    "variable": "var(--kbyczR)"
  },
  "spacing.mediaModal.mobileDockClearance": {
    "value": "9rem",
    "variable": "var(--hZxZJS)"
  },
  "spacing.chrome.-gutter": {
    "value": "calc(var(--kbyczR) * -1)",
    "variable": "var(--kbyczR)"
  },
  "spacing.mediaModal.-mobileDockClearance": {
    "value": "calc(var(--hZxZJS) * -1)",
    "variable": "var(--hZxZJS)"
  },
  "spacing.-25": {
    "value": "var(--ieWSsg)",
    "variable": "var(--ieWSsg)"
  },
  "spacing.-50": {
    "value": "var(--kKbbUK)",
    "variable": "var(--kKbbUK)"
  },
  "spacing.-100": {
    "value": "var(--bIgSVm)",
    "variable": "var(--bIgSVm)"
  },
  "spacing.-150": {
    "value": "var(--hmVCZH)",
    "variable": "var(--hmVCZH)"
  },
  "spacing.-200": {
    "value": "var(--cJysOB)",
    "variable": "var(--cJysOB)"
  },
  "spacing.-250": {
    "value": "var(--bIrbJs)",
    "variable": "var(--bIrbJs)"
  },
  "spacing.-300": {
    "value": "var(--GHwVU)",
    "variable": "var(--GHwVU)"
  },
  "spacing.-350": {
    "value": "var(--gmJDqV)",
    "variable": "var(--gmJDqV)"
  },
  "spacing.-400": {
    "value": "var(--gqmheD)",
    "variable": "var(--gqmheD)"
  },
  "spacing.-500": {
    "value": "var(--envllW)",
    "variable": "var(--envllW)"
  },
  "spacing.-600": {
    "value": "var(--foMLfl)",
    "variable": "var(--foMLfl)"
  },
  "spacing.-700": {
    "value": "var(--dlVPmE)",
    "variable": "var(--dlVPmE)"
  },
  "spacing.-800": {
    "value": "var(--dUcYJv)",
    "variable": "var(--dUcYJv)"
  },
  "spacing.-900": {
    "value": "var(--bRmcQO)",
    "variable": "var(--bRmcQO)"
  },
  "spacing.-1000": {
    "value": "var(--iUTQca)",
    "variable": "var(--iUTQca)"
  },
  "spacing.-1100": {
    "value": "var(--drMEwr)",
    "variable": "var(--drMEwr)"
  },
  "spacing.-1200": {
    "value": "var(--bkFxjg)",
    "variable": "var(--bkFxjg)"
  },
  "spacing.-1300": {
    "value": "var(--gWTVct)",
    "variable": "var(--gWTVct)"
  },
  "spacing.-1400": {
    "value": "var(--iNucni)",
    "variable": "var(--iNucni)"
  },
  "spacing.-1500": {
    "value": "var(--dkmQHz)",
    "variable": "var(--dkmQHz)"
  },
  "spacing.-1600": {
    "value": "var(--bdfJuo)",
    "variable": "var(--bdfJuo)"
  },
  "spacing.-1800": {
    "value": "var(--dofCJK)",
    "variable": "var(--dofCJK)"
  },
  "spacing.-2400": {
    "value": "var(--jOLCgx)",
    "variable": "var(--jOLCgx)"
  },
  "spacing.-negative-25": {
    "value": "var(--cKgcde)",
    "variable": "var(--cKgcde)"
  },
  "spacing.-zero": {
    "value": "var(--LDKR)",
    "variable": "var(--LDKR)"
  },
  "spacing.Accordion.Panel.padding.-top": {
    "value": "var(--bZoLmy)",
    "variable": "var(--bZoLmy)"
  },
  "spacing.AdornedInput.sm.padding.-vert": {
    "value": "var(--kwodqp)",
    "variable": "var(--kwodqp)"
  },
  "spacing.AdornedInput.md.padding.-vert": {
    "value": "var(--hZgzVm)",
    "variable": "var(--hZgzVm)"
  },
  "spacing.Alert.gap.message.-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Alert.CloseButton.margin.-top": {
    "value": "var(--gmvJmF)",
    "variable": "var(--gmvJmF)"
  },
  "spacing.Alert.CloseButton.margin.-right": {
    "value": "var(--hCMzIC)",
    "variable": "var(--hCMzIC)"
  },
  "spacing.Avatar.Badge.padding.sm.-default": {
    "value": "var(--iDvLBT)",
    "variable": "var(--iDvLBT)"
  },
  "spacing.Avatar.Badge.padding.md.-default": {
    "value": "var(--gSeFVY)",
    "variable": "var(--gSeFVY)"
  },
  "spacing.Avatar.Badge.padding.md.-bare": {
    "value": "var(--koIlbn)",
    "variable": "var(--koIlbn)"
  },
  "spacing.Avatar.Badge.padding.lg.-default": {
    "value": "var(--vMQFG)",
    "variable": "var(--vMQFG)"
  },
  "spacing.Avatar.Badge.padding.lg.-bare": {
    "value": "var(--KhwPF)",
    "variable": "var(--KhwPF)"
  },
  "spacing.Banner.CloseButton.margin.-top": {
    "value": "var(--SaYWL)",
    "variable": "var(--SaYWL)"
  },
  "spacing.Banner.CloseButton.margin.-right": {
    "value": "var(--hsjrNs)",
    "variable": "var(--hsjrNs)"
  },
  "spacing.ButtonGroup.gap.-vert": {
    "value": "var(--hdUbmd)",
    "variable": "var(--hdUbmd)"
  },
  "spacing.ButtonGroup.textButton.padding.-horz": {
    "value": "var(--hXLxzu)",
    "variable": "var(--hXLxzu)"
  },
  "spacing.ButtonGroup.textButton.padding.-vert": {
    "value": "var(--gihyzU)",
    "variable": "var(--gihyzU)"
  },
  "spacing.Button.xs.padding.-horz": {
    "value": "var(--evDSnJ)",
    "variable": "var(--evDSnJ)"
  },
  "spacing.Button.xs.padding.-vert": {
    "value": "var(--krIemT)",
    "variable": "var(--krIemT)"
  },
  "spacing.Button.sm.padding.bare.-horz": {
    "value": "var(--ldipmR)",
    "variable": "var(--ldipmR)"
  },
  "spacing.Button.sm.padding.-vert": {
    "value": "var(--eoWFjK)",
    "variable": "var(--eoWFjK)"
  },
  "spacing.Button.md.padding.bare.-horz": {
    "value": "var(--hHWvke)",
    "variable": "var(--hHWvke)"
  },
  "spacing.Button.md.padding.-vert": {
    "value": "var(--hUZAHR)",
    "variable": "var(--hUZAHR)"
  },
  "spacing.Button.lg.padding.bare.-horz": {
    "value": "var(--kxVnxc)",
    "variable": "var(--kxVnxc)"
  },
  "spacing.Carousel.Heading.gap.-betweenNav": {
    "value": "var(--brfXwr)",
    "variable": "var(--brfXwr)"
  },
  "spacing.Chip.padding.-horz": {
    "value": "var(--fTmwWf)",
    "variable": "var(--fTmwWf)"
  },
  "spacing.Chip.padding.-vert": {
    "value": "var(--dgnWVZ)",
    "variable": "var(--dgnWVZ)"
  },
  "spacing.Chip.gap.-inputChip-trailing": {
    "value": "var(--dLTNDs)",
    "variable": "var(--dLTNDs)"
  },
  "spacing.Chip.Close.-padding": {
    "value": "var(--jdixam)",
    "variable": "var(--jdixam)"
  },
  "spacing.CloseButton.-padding": {
    "value": "var(--hIkYOv)",
    "variable": "var(--hIkYOv)"
  },
  "spacing.CloseButton.-margin": {
    "value": "var(--ioAyOA)",
    "variable": "var(--ioAyOA)"
  },
  "spacing.DateInput.sm.padding.-vert": {
    "value": "var(--eiKHUu)",
    "variable": "var(--eiKHUu)"
  },
  "spacing.DateInput.md.gap.-input-toAdornment": {
    "value": "var(--dZYgxr)",
    "variable": "var(--dZYgxr)"
  },
  "spacing.DateInput.md.padding.-vert": {
    "value": "var(--iTcIJp)",
    "variable": "var(--iTcIJp)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.-inner": {
    "value": "var(--buLcuL)",
    "variable": "var(--buLcuL)"
  },
  "spacing.FormField.HelperArea.gap.-text-toCharCount": {
    "value": "var(--gKblKh)",
    "variable": "var(--gKblKh)"
  },
  "spacing.IconButton.xs.-padding": {
    "value": "var(--gCvLoM)",
    "variable": "var(--gCvLoM)"
  },
  "spacing.IconButton.sm.-padding": {
    "value": "var(--gCGMel)",
    "variable": "var(--gCGMel)"
  },
  "spacing.IconButton.md.-padding": {
    "value": "var(--exmvqC)",
    "variable": "var(--exmvqC)"
  },
  "spacing.Input.sm.padding.-vert": {
    "value": "var(--pVTga)",
    "variable": "var(--pVTga)"
  },
  "spacing.Input.md.padding.-vert": {
    "value": "var(--jeiKV)",
    "variable": "var(--jeiKV)"
  },
  "spacing.LabeledControl.padding.vert.-label": {
    "value": "var(--jjDwWg)",
    "variable": "var(--jjDwWg)"
  },
  "spacing.LabeledControl.padding.vert.switch.-md": {
    "value": "var(--IfNwo)",
    "variable": "var(--IfNwo)"
  },
  "spacing.LabeledControl.padding.vert.switch.-lg": {
    "value": "var(--jgSjDG)",
    "variable": "var(--jgSjDG)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-horz": {
    "value": "var(--jUawSX)",
    "variable": "var(--jUawSX)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-vert": {
    "value": "var(--lgwPIJ)",
    "variable": "var(--lgwPIJ)"
  },
  "spacing.Page.padding.horz.-desktop": {
    "value": "var(--hnYpHx)",
    "variable": "var(--hnYpHx)"
  },
  "spacing.Page.padding.horz.-tablet": {
    "value": "var(--iFMWbV)",
    "variable": "var(--iFMWbV)"
  },
  "spacing.Page.padding.horz.-mobile": {
    "value": "var(--geTjSP)",
    "variable": "var(--geTjSP)"
  },
  "spacing.Page.Breadcrumb.margin.top.-desktop": {
    "value": "var(--ifRZDY)",
    "variable": "var(--ifRZDY)"
  },
  "spacing.Page.Breadcrumb.margin.top.-tablet": {
    "value": "var(--keLiNY)",
    "variable": "var(--keLiNY)"
  },
  "spacing.Page.Breadcrumb.margin.top.-mobile": {
    "value": "var(--ejkCRy)",
    "variable": "var(--ejkCRy)"
  },
  "spacing.Page.Content.margin.vert.-desktop": {
    "value": "var(--hMBFQY)",
    "variable": "var(--hMBFQY)"
  },
  "spacing.Page.Content.margin.vert.-tablet": {
    "value": "var(--gIawWs)",
    "variable": "var(--gIawWs)"
  },
  "spacing.Page.Content.margin.vert.-mobile": {
    "value": "var(--eNPPne)",
    "variable": "var(--eNPPne)"
  },
  "spacing.Page.Header.margin.bottom.-desktop": {
    "value": "var(--kAkcVA)",
    "variable": "var(--kAkcVA)"
  },
  "spacing.Page.Header.margin.bottom.-tablet": {
    "value": "var(--bzYExs)",
    "variable": "var(--bzYExs)"
  },
  "spacing.Page.Header.margin.bottom.-mobile": {
    "value": "var(--fsQubG)",
    "variable": "var(--fsQubG)"
  },
  "spacing.Page.Header.margin.top.-desktop": {
    "value": "var(--ifTgwQ)",
    "variable": "var(--ifTgwQ)"
  },
  "spacing.Page.Header.margin.top.-tablet": {
    "value": "var(--hQAGNU)",
    "variable": "var(--hQAGNU)"
  },
  "spacing.Page.Header.margin.top.-mobile": {
    "value": "var(--eeatXS)",
    "variable": "var(--eeatXS)"
  },
  "spacing.Pagination.JumpItem.padding.-vert": {
    "value": "var(--cQtiUd)",
    "variable": "var(--cQtiUd)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.-default": {
    "value": "var(--bTLfsn)",
    "variable": "var(--bTLfsn)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toIcon": {
    "value": "var(--hDVbwX)",
    "variable": "var(--hDVbwX)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-horz": {
    "value": "var(--gnCbqQ)",
    "variable": "var(--gnCbqQ)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-top": {
    "value": "var(--bsXpWo)",
    "variable": "var(--bsXpWo)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-bottom": {
    "value": "var(--iKVqPg)",
    "variable": "var(--iKVqPg)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.-default": {
    "value": "var(--bdBQll)",
    "variable": "var(--bdBQll)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toIcon": {
    "value": "var(--hnhnEZ)",
    "variable": "var(--hnhnEZ)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-horz": {
    "value": "var(--bblBne)",
    "variable": "var(--bblBne)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-top": {
    "value": "var(--fppvLi)",
    "variable": "var(--fppvLi)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-bottom": {
    "value": "var(--cRlyXe)",
    "variable": "var(--cRlyXe)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.-default": {
    "value": "var(--daEFPI)",
    "variable": "var(--daEFPI)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-horz": {
    "value": "var(--cTilsH)",
    "variable": "var(--cTilsH)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-top": {
    "value": "var(--eEJIpr)",
    "variable": "var(--eEJIpr)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-bottom": {
    "value": "var(--ZnlKz)",
    "variable": "var(--ZnlKz)"
  },
  "spacing.PropertyCard.FlexArea.padding.-horz": {
    "value": "var(--gDXDFn)",
    "variable": "var(--gDXDFn)"
  },
  "spacing.PropertyCard.FlexArea.padding.-vert": {
    "value": "var(--iBIBiJ)",
    "variable": "var(--iBIBiJ)"
  },
  "spacing.Range.Root.margin.-vert": {
    "value": "var(--ebimgE)",
    "variable": "var(--ebimgE)"
  },
  "spacing.Range.Handle.margin.-top": {
    "value": "var(--ckWLMC)",
    "variable": "var(--ckWLMC)"
  },
  "spacing.ShowHide.gap.-label-toIcon": {
    "value": "var(--jjEfAp)",
    "variable": "var(--jjEfAp)"
  },
  "spacing.ShowHide.gap.-button-toContent": {
    "value": "var(--ekXPFz)",
    "variable": "var(--ekXPFz)"
  },
  "spacing.Switch.Handle.lg.position.-top": {
    "value": "var(--bnQnIW)",
    "variable": "var(--bnQnIW)"
  },
  "spacing.Tabs.padding.-vert": {
    "value": "var(--khVvNT)",
    "variable": "var(--khVvNT)"
  },
  "spacing.Textarea.padding.-vert": {
    "value": "var(--kVwiEp)",
    "variable": "var(--kVwiEp)"
  },
  "spacing.Toast.CloseButton.margin.-top": {
    "value": "var(--gGJMCC)",
    "variable": "var(--gGJMCC)"
  },
  "spacing.Toast.CloseButton.margin.-right": {
    "value": "var(--euRCSx)",
    "variable": "var(--euRCSx)"
  },
  "spacing.ToggleButton.sm.padding.-vert": {
    "value": "var(--jNnzUs)",
    "variable": "var(--jNnzUs)"
  },
  "spacing.ToggleButton.md.padding.-vert": {
    "value": "var(--dKVsMv)",
    "variable": "var(--dKVsMv)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-top": {
    "value": "var(--hJHynY)",
    "variable": "var(--hJHynY)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-right": {
    "value": "var(--cZWSCT)",
    "variable": "var(--cZWSCT)"
  },
  "spacing.Upsell.CloseButton.margin.-top": {
    "value": "var(--wsvUA)",
    "variable": "var(--wsvUA)"
  },
  "spacing.Upsell.CloseButton.margin.-right": {
    "value": "var(--bpUfxn)",
    "variable": "var(--bpUfxn)"
  },
  "spacing.device.margin.-mobile": {
    "value": "var(--dPWswx)",
    "variable": "var(--dPWswx)"
  },
  "spacing.device.margin.-tablet": {
    "value": "var(--cVXwjX)",
    "variable": "var(--cVXwjX)"
  },
  "spacing.device.margin.-desktop": {
    "value": "var(--jMivYf)",
    "variable": "var(--jMivYf)"
  },
  "spacing.-tightest": {
    "value": "var(--gOoWtX)",
    "variable": "var(--gOoWtX)"
  },
  "spacing.-tighter": {
    "value": "var(--hLkrWi)",
    "variable": "var(--hLkrWi)"
  },
  "spacing.-tight": {
    "value": "var(--jKknzl)",
    "variable": "var(--jKknzl)"
  },
  "spacing.-default": {
    "value": "var(--hRrfDo)",
    "variable": "var(--hRrfDo)"
  },
  "spacing.-loose": {
    "value": "var(--dmLIIl)",
    "variable": "var(--dmLIIl)"
  },
  "spacing.-looser": {
    "value": "var(--bqtQgP)",
    "variable": "var(--bqtQgP)"
  },
  "spacing.-none": {
    "value": "var(--jWXhYR)",
    "variable": "var(--jWXhYR)"
  },
  "spacing.-conjoined-offsetBorder": {
    "value": "var(--gYvjwC)",
    "variable": "var(--gYvjwC)"
  },
  "spacing.layout.-tightest": {
    "value": "var(--gilTII)",
    "variable": "var(--gilTII)"
  },
  "spacing.layout.-tighter": {
    "value": "var(--icAmQN)",
    "variable": "var(--icAmQN)"
  },
  "spacing.layout.-tight": {
    "value": "var(--btpFxC)",
    "variable": "var(--btpFxC)"
  },
  "spacing.layout.-default": {
    "value": "var(--bArDtj)",
    "variable": "var(--bArDtj)"
  },
  "spacing.layout.-loose": {
    "value": "var(--fgohXG)",
    "variable": "var(--fgohXG)"
  },
  "spacing.layout.-looser": {
    "value": "var(--fpICwE)",
    "variable": "var(--fpICwE)"
  },
  "spacing.layout.-loosest": {
    "value": "var(--fxUeRh)",
    "variable": "var(--fxUeRh)"
  },
  "spacing.layout.vast.-default": {
    "value": "var(--dGXRfu)",
    "variable": "var(--dGXRfu)"
  },
  "spacing.layout.vast.-loose": {
    "value": "var(--lfGjAb)",
    "variable": "var(--lfGjAb)"
  },
  "spacing.layout.vast.-looser": {
    "value": "var(--ibzIPx)",
    "variable": "var(--ibzIPx)"
  },
  "spacing.micro.-tight": {
    "value": "var(--gYfDtm)",
    "variable": "var(--gYfDtm)"
  },
  "spacing.micro.-default": {
    "value": "var(--kbxbWf)",
    "variable": "var(--kbxbWf)"
  },
  "spacing.-xxs": {
    "value": "var(--eooIFU)",
    "variable": "var(--eooIFU)"
  },
  "spacing.-xs": {
    "value": "var(--icrUDE)",
    "variable": "var(--icrUDE)"
  },
  "spacing.-sm": {
    "value": "var(--jolVMp)",
    "variable": "var(--jolVMp)"
  },
  "spacing.-md": {
    "value": "var(--eEeglK)",
    "variable": "var(--eEeglK)"
  },
  "spacing.-lg": {
    "value": "var(--fFUZAQ)",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.-xl": {
    "value": "var(--gvVjyT)",
    "variable": "var(--gvVjyT)"
  },
  "spacing.Accordion.Header.gap.-between-tags": {
    "value": "var(--fRjuod)",
    "variable": "var(--fRjuod)"
  },
  "spacing.Accordion.Header.padding.-vert": {
    "value": "var(--eyrvPl)",
    "variable": "var(--eyrvPl)"
  },
  "spacing.Alert.gap.-message-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Input.sm.gap.-input-toAdornment": {
    "value": "var(--hzyLYM)",
    "variable": "var(--hzyLYM)"
  },
  "spacing.Input.md.gap.-input-toAdornment": {
    "value": "var(--dJoDHL)",
    "variable": "var(--dJoDHL)"
  },
  "spacing.Input.lg.gap.-input-toAdornment": {
    "value": "var(--gmgJmR)",
    "variable": "var(--gmgJmR)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toSupportRows": {
    "value": "var(--fqMqrq)",
    "variable": "var(--fqMqrq)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toSupportRows": {
    "value": "var(--jZLUXs)",
    "variable": "var(--jZLUXs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.-dataArea1-toSupportRows": {
    "value": "var(--gFynLZ)",
    "variable": "var(--gFynLZ)"
  },
  "spacing.Modal.Header.padding.-right": {
    "value": "var(--gfrCur)",
    "variable": "var(--gfrCur)"
  },
  "spacing.Modal.Header.padding.-left": {
    "value": "var(--cZODTM)",
    "variable": "var(--cZODTM)"
  },
  "spacing.Modal.Header.padding.-vert": {
    "value": "var(--eIeyvq)",
    "variable": "var(--eIeyvq)"
  },
  "spacing.Modal.Footer.padding.-vert": {
    "value": "var(--kQXvXk)",
    "variable": "var(--kQXvXk)"
  },
  "colors.aqua.50": {
    "value": "var(--ijOKtU)",
    "variable": "var(--ijOKtU)"
  },
  "colors.aqua.100": {
    "value": "var(--iVuGjk)",
    "variable": "var(--iVuGjk)"
  },
  "colors.aqua.200": {
    "value": "var(--gYRMgf)",
    "variable": "var(--gYRMgf)"
  },
  "colors.aqua.300": {
    "value": "var(--ILIhq)",
    "variable": "var(--ILIhq)"
  },
  "colors.aqua.400": {
    "value": "var(--ksjdvN)",
    "variable": "var(--ksjdvN)"
  },
  "colors.aqua.500": {
    "value": "var(--eccZwY)",
    "variable": "var(--eccZwY)"
  },
  "colors.aqua.600": {
    "value": "var(--cfAftT)",
    "variable": "var(--cfAftT)"
  },
  "colors.aqua.700": {
    "value": "var(--hePKUa)",
    "variable": "var(--hePKUa)"
  },
  "colors.aqua.800": {
    "value": "var(--gCqBEp)",
    "variable": "var(--gCqBEp)"
  },
  "colors.aqua.900": {
    "value": "var(--mkxFA)",
    "variable": "var(--mkxFA)"
  },
  "colors.aqua.950": {
    "value": "var(--jxpOQR)",
    "variable": "var(--jxpOQR)"
  },
  "colors.black": {
    "value": "var(--qLIrn)",
    "variable": "var(--qLIrn)"
  },
  "colors.blue.50": {
    "value": "var(--glmLoi)",
    "variable": "var(--glmLoi)"
  },
  "colors.blue.100": {
    "value": "var(--bYrJpO)",
    "variable": "var(--bYrJpO)"
  },
  "colors.blue.200": {
    "value": "var(--hoTvPd)",
    "variable": "var(--hoTvPd)"
  },
  "colors.blue.300": {
    "value": "var(--bMEoOM)",
    "variable": "var(--bMEoOM)"
  },
  "colors.blue.375": {
    "value": "var(--fpxnpO)",
    "variable": "var(--fpxnpO)"
  },
  "colors.blue.400": {
    "value": "var(--hIEEwj)",
    "variable": "var(--hIEEwj)"
  },
  "colors.blue.500": {
    "value": "var(--cgpxvS)",
    "variable": "var(--cgpxvS)"
  },
  "colors.blue.600": {
    "value": "var(--hwRjVh)",
    "variable": "var(--hwRjVh)"
  },
  "colors.blue.700": {
    "value": "var(--bUCcUQ)",
    "variable": "var(--bUCcUQ)"
  },
  "colors.blue.800": {
    "value": "var(--golFsv)",
    "variable": "var(--golFsv)"
  },
  "colors.blue.900": {
    "value": "var(--LWyse)",
    "variable": "var(--LWyse)"
  },
  "colors.blue.950": {
    "value": "var(--eJQij)",
    "variable": "var(--eJQij)"
  },
  "colors.legacy.coolGray.100": {
    "value": "var(--jUnxAi)",
    "variable": "var(--jUnxAi)"
  },
  "colors.legacy.coolGray.200": {
    "value": "var(--fTPNJx)",
    "variable": "var(--fTPNJx)"
  },
  "colors.legacy.coolGray.300": {
    "value": "var(--oVyBg)",
    "variable": "var(--oVyBg)"
  },
  "colors.legacy.coolGray.400": {
    "value": "var(--icsKyf)",
    "variable": "var(--icsKyf)"
  },
  "colors.legacy.coolGray.500": {
    "value": "var(--cxyvpO)",
    "variable": "var(--cxyvpO)"
  },
  "colors.legacy.coolGray.600": {
    "value": "var(--jMwuXZ)",
    "variable": "var(--jMwuXZ)"
  },
  "colors.legacy.orangeRed.100": {
    "value": "var(--goNItf)",
    "variable": "var(--goNItf)"
  },
  "colors.legacy.orangeRed.200": {
    "value": "var(--gjjzuI)",
    "variable": "var(--gjjzuI)"
  },
  "colors.legacy.orangeRed.300": {
    "value": "var(--cWjaDF)",
    "variable": "var(--cWjaDF)"
  },
  "colors.legacy.orangeRed.400": {
    "value": "var(--bkmuRi)",
    "variable": "var(--bkmuRi)"
  },
  "colors.legacy.orangeRed.500": {
    "value": "var(--VSStP)",
    "variable": "var(--VSStP)"
  },
  "colors.legacy.orangeRed.600": {
    "value": "var(--QoJvs)",
    "variable": "var(--QoJvs)"
  },
  "colors.dataViz.blue.100": {
    "value": "var(--jBlxLO)",
    "variable": "var(--jBlxLO)"
  },
  "colors.dataViz.blue.200": {
    "value": "var(--TvFdt)",
    "variable": "var(--TvFdt)"
  },
  "colors.dataViz.blue.300": {
    "value": "var(--iarnbA)",
    "variable": "var(--iarnbA)"
  },
  "colors.dataViz.blue.400": {
    "value": "var(--ejTXXv)",
    "variable": "var(--ejTXXv)"
  },
  "colors.dataViz.blue.500": {
    "value": "var(--btWwG)",
    "variable": "var(--btWwG)"
  },
  "colors.dataViz.blue.600": {
    "value": "var(--cIZNnh)",
    "variable": "var(--cIZNnh)"
  },
  "colors.dataViz.blue.700": {
    "value": "var(--jPVvlo)",
    "variable": "var(--jPVvlo)"
  },
  "colors.dataViz.blue.800": {
    "value": "var(--fOAwoD)",
    "variable": "var(--fOAwoD)"
  },
  "colors.dataViz.blue.900": {
    "value": "var(--bGauNO)",
    "variable": "var(--bGauNO)"
  },
  "colors.dataViz.blue.1000": {
    "value": "var(--fJixCS)",
    "variable": "var(--fJixCS)"
  },
  "colors.dataViz.blue.1100": {
    "value": "var(--gamwbz)",
    "variable": "var(--gamwbz)"
  },
  "colors.dataViz.blue.1200": {
    "value": "var(--gUVoPA)",
    "variable": "var(--gUVoPA)"
  },
  "colors.dataViz.gray.100": {
    "value": "var(--cNpHCV)",
    "variable": "var(--cNpHCV)"
  },
  "colors.dataViz.gray.200": {
    "value": "var(--jcjcam)",
    "variable": "var(--jcjcam)"
  },
  "colors.dataViz.gray.300": {
    "value": "var(--jehHKn)",
    "variable": "var(--jehHKn)"
  },
  "colors.dataViz.gray.400": {
    "value": "var(--hRHJIs)",
    "variable": "var(--hRHJIs)"
  },
  "colors.dataViz.gray.500": {
    "value": "var(--hTGpst)",
    "variable": "var(--hTGpst)"
  },
  "colors.dataViz.gray.600": {
    "value": "var(--cTeaqO)",
    "variable": "var(--cTeaqO)"
  },
  "colors.dataViz.gray.700": {
    "value": "var(--cVcGaP)",
    "variable": "var(--cVcGaP)"
  },
  "colors.dataViz.gray.800": {
    "value": "var(--eKjpOw)",
    "variable": "var(--eKjpOw)"
  },
  "colors.dataViz.gray.900": {
    "value": "var(--eMhVyx)",
    "variable": "var(--eMhVyx)"
  },
  "colors.dataViz.gray.1000": {
    "value": "var(--kqhtAh)",
    "variable": "var(--kqhtAh)"
  },
  "colors.dataViz.gray.1100": {
    "value": "var(--dbbUsw)",
    "variable": "var(--dbbUsw)"
  },
  "colors.dataViz.gray.1200": {
    "value": "var(--hiIdRr)",
    "variable": "var(--hiIdRr)"
  },
  "colors.dataViz.grayGreen.100": {
    "value": "var(--bNytBO)",
    "variable": "var(--bNytBO)"
  },
  "colors.dataViz.grayGreen.200": {
    "value": "var(--gLqjux)",
    "variable": "var(--gLqjux)"
  },
  "colors.dataViz.grayGreen.300": {
    "value": "var(--cNJtuw)",
    "variable": "var(--cNJtuw)"
  },
  "colors.dataViz.grayGreen.400": {
    "value": "var(--eFfyxf)",
    "variable": "var(--eFfyxf)"
  },
  "colors.dataViz.grayGreen.500": {
    "value": "var(--ijoYJu)",
    "variable": "var(--ijoYJu)"
  },
  "colors.dataViz.grayGreen.600": {
    "value": "var(--bRLfdh)",
    "variable": "var(--bRLfdh)"
  },
  "colors.dataViz.grayGreen.700": {
    "value": "var(--jjzYCc)",
    "variable": "var(--jjzYCc)"
  },
  "colors.dataViz.grayGreen.800": {
    "value": "var(--YAyDz)",
    "variable": "var(--YAyDz)"
  },
  "colors.dataViz.grayGreen.900": {
    "value": "var(--eCJYPO)",
    "variable": "var(--eCJYPO)"
  },
  "colors.dataViz.grayGreen.1000": {
    "value": "var(--kXmpgC)",
    "variable": "var(--kXmpgC)"
  },
  "colors.dataViz.grayGreen.1100": {
    "value": "var(--dUFIPr)",
    "variable": "var(--dUFIPr)"
  },
  "colors.dataViz.grayGreen.1200": {
    "value": "var(--iMOUgU)",
    "variable": "var(--iMOUgU)"
  },
  "colors.dataViz.grayOrange.100": {
    "value": "var(--gZGeVZ)",
    "variable": "var(--gZGeVZ)"
  },
  "colors.dataViz.grayOrange.200": {
    "value": "var(--fHfEmS)",
    "variable": "var(--fHfEmS)"
  },
  "colors.dataViz.grayOrange.300": {
    "value": "var(--jPqgkv)",
    "variable": "var(--jPqgkv)"
  },
  "colors.dataViz.grayOrange.400": {
    "value": "var(--kYsrTg)",
    "variable": "var(--kYsrTg)"
  },
  "colors.dataViz.grayOrange.500": {
    "value": "var(--dRhkrN)",
    "variable": "var(--dRhkrN)"
  },
  "colors.dataViz.grayOrange.600": {
    "value": "var(--cyGJIG)",
    "variable": "var(--cyGJIG)"
  },
  "colors.dataViz.grayOrange.700": {
    "value": "var(--gGRlGj)",
    "variable": "var(--gGRlGj)"
  },
  "colors.dataViz.grayOrange.800": {
    "value": "var(--OxvwU)",
    "variable": "var(--OxvwU)"
  },
  "colors.dataViz.grayOrange.900": {
    "value": "var(--eWHXux)",
    "variable": "var(--eWHXux)"
  },
  "colors.dataViz.grayOrange.1000": {
    "value": "var(--gElyOp)",
    "variable": "var(--gElyOp)"
  },
  "colors.dataViz.grayOrange.1100": {
    "value": "var(--hCFMBY)",
    "variable": "var(--hCFMBY)"
  },
  "colors.dataViz.grayOrange.1200": {
    "value": "var(--eIIChb)",
    "variable": "var(--eIIChb)"
  },
  "colors.dataViz.green.100": {
    "value": "var(--hCxkGz)",
    "variable": "var(--hCxkGz)"
  },
  "colors.dataViz.green.200": {
    "value": "var(--hICTZU)",
    "variable": "var(--hICTZU)"
  },
  "colors.dataViz.green.300": {
    "value": "var(--gkdztp)",
    "variable": "var(--gkdztp)"
  },
  "colors.dataViz.green.400": {
    "value": "var(--lhTSwK)",
    "variable": "var(--lhTSwK)"
  },
  "colors.dataViz.green.500": {
    "value": "var(--iNMbAL)",
    "variable": "var(--iNMbAL)"
  },
  "colors.dataViz.green.600": {
    "value": "var(--iTRKUg)",
    "variable": "var(--iTRKUg)"
  },
  "colors.dataViz.green.700": {
    "value": "var(--hvsqnB)",
    "variable": "var(--hvsqnB)"
  },
  "colors.dataViz.green.800": {
    "value": "var(--fKSRoi)",
    "variable": "var(--fKSRoi)"
  },
  "colors.dataViz.green.900": {
    "value": "var(--dqLasj)",
    "variable": "var(--dqLasj)"
  },
  "colors.dataViz.green.1000": {
    "value": "var(--lnMKwX)",
    "variable": "var(--lnMKwX)"
  },
  "colors.dataViz.green.1100": {
    "value": "var(--jQgFbe)",
    "variable": "var(--jQgFbe)"
  },
  "colors.dataViz.green.1200": {
    "value": "var(--laFlwd)",
    "variable": "var(--laFlwd)"
  },
  "colors.dataViz.orange.100": {
    "value": "var(--dQNvjU)",
    "variable": "var(--dQNvjU)"
  },
  "colors.dataViz.orange.200": {
    "value": "var(--bOexEj)",
    "variable": "var(--bOexEj)"
  },
  "colors.dataViz.orange.300": {
    "value": "var(--eIvfKW)",
    "variable": "var(--eIvfKW)"
  },
  "colors.dataViz.orange.400": {
    "value": "var(--fSoDgp)",
    "variable": "var(--fSoDgp)"
  },
  "colors.dataViz.orange.500": {
    "value": "var(--iMFlnc)",
    "variable": "var(--iMFlnc)"
  },
  "colors.dataViz.orange.600": {
    "value": "var(--gJWnHr)",
    "variable": "var(--gJWnHr)"
  },
  "colors.dataViz.orange.700": {
    "value": "var(--jEmVOe)",
    "variable": "var(--jEmVOe)"
  },
  "colors.dataViz.orange.800": {
    "value": "var(--boRErh)",
    "variable": "var(--boRErh)"
  },
  "colors.dataViz.orange.900": {
    "value": "var(--ejimxU)",
    "variable": "var(--ejimxU)"
  },
  "colors.dataViz.orange.1000": {
    "value": "var(--bnsvsk)",
    "variable": "var(--bnsvsk)"
  },
  "colors.dataViz.orange.1100": {
    "value": "var(--bDkddx)",
    "variable": "var(--bDkddx)"
  },
  "colors.dataViz.orange.1200": {
    "value": "var(--dFEZVe)",
    "variable": "var(--dFEZVe)"
  },
  "colors.dataViz.orangeBlue.100": {
    "value": "var(--ihHcVG)",
    "variable": "var(--ihHcVG)"
  },
  "colors.dataViz.orangeBlue.200": {
    "value": "var(--ioomTR)",
    "variable": "var(--ioomTR)"
  },
  "colors.dataViz.orangeBlue.300": {
    "value": "var(--iPBMhc)",
    "variable": "var(--iPBMhc)"
  },
  "colors.dataViz.orangeBlue.400": {
    "value": "var(--hSekvL)",
    "variable": "var(--hSekvL)"
  },
  "colors.dataViz.orangeBlue.500": {
    "value": "var(--itrJIW)",
    "variable": "var(--itrJIW)"
  },
  "colors.dataViz.orangeBlue.600": {
    "value": "var(--izYTHh)",
    "variable": "var(--izYTHh)"
  },
  "colors.dataViz.orangeBlue.700": {
    "value": "var(--jbmsUs)",
    "variable": "var(--jbmsUs)"
  },
  "colors.dataViz.orangeBlue.800": {
    "value": "var(--knLuZP)",
    "variable": "var(--knLuZP)"
  },
  "colors.dataViz.orangeBlue.900": {
    "value": "var(--kOYUna)",
    "variable": "var(--kOYUna)"
  },
  "colors.dataViz.orangeBlue.1000": {
    "value": "var(--jumHke)",
    "variable": "var(--jumHke)"
  },
  "colors.dataViz.orangeBlue.1100": {
    "value": "var(--ecrGT)",
    "variable": "var(--ecrGT)"
  },
  "colors.dataViz.orangeBlue.1200": {
    "value": "var(--cUYbRs)",
    "variable": "var(--cUYbRs)"
  },
  "colors.dataViz.orangeRed.100": {
    "value": "var(--iaqTMz)",
    "variable": "var(--iaqTMz)"
  },
  "colors.dataViz.orangeRed.200": {
    "value": "var(--kGZfQQ)",
    "variable": "var(--kGZfQQ)"
  },
  "colors.dataViz.orangeRed.300": {
    "value": "var(--ifpBKJ)",
    "variable": "var(--ifpBKJ)"
  },
  "colors.dataViz.orangeRed.400": {
    "value": "var(--heFFqu)",
    "variable": "var(--heFFqu)"
  },
  "colors.dataViz.orangeRed.500": {
    "value": "var(--btfmwT)",
    "variable": "var(--btfmwT)"
  },
  "colors.dataViz.orangeRed.600": {
    "value": "var(--dZNyBk)",
    "variable": "var(--dZNyBk)"
  },
  "colors.dataViz.orangeRed.700": {
    "value": "var(--bydUvd)",
    "variable": "var(--bydUvd)"
  },
  "colors.dataViz.orangeRed.800": {
    "value": "var(--jTxPEG)",
    "variable": "var(--jTxPEG)"
  },
  "colors.dataViz.orangeRed.900": {
    "value": "var(--ehXwLf)",
    "variable": "var(--ehXwLf)"
  },
  "colors.dataViz.orangeRed.1000": {
    "value": "var(--bDweyr)",
    "variable": "var(--bDweyr)"
  },
  "colors.dataViz.orangeRed.1100": {
    "value": "var(--iumwIO)",
    "variable": "var(--iumwIO)"
  },
  "colors.dataViz.orangeRed.1200": {
    "value": "var(--yFytx)",
    "variable": "var(--yFytx)"
  },
  "colors.dataViz.purple.100": {
    "value": "var(--gzXRge)",
    "variable": "var(--gzXRge)"
  },
  "colors.dataViz.purple.200": {
    "value": "var(--fMbzwN)",
    "variable": "var(--fMbzwN)"
  },
  "colors.dataViz.purple.300": {
    "value": "var(--iHUDZc)",
    "variable": "var(--iHUDZc)"
  },
  "colors.dataViz.purple.400": {
    "value": "var(--izugIH)",
    "variable": "var(--izugIH)"
  },
  "colors.dataViz.purple.500": {
    "value": "var(--fRBMa)",
    "variable": "var(--fRBMa)"
  },
  "colors.dataViz.purple.600": {
    "value": "var(--kHqTBF)",
    "variable": "var(--kHqTBF)"
  },
  "colors.dataViz.purple.700": {
    "value": "var(--cnOoEY)",
    "variable": "var(--cnOoEY)"
  },
  "colors.dataViz.purple.800": {
    "value": "var(--fQhbSL)",
    "variable": "var(--fQhbSL)"
  },
  "colors.dataViz.purple.900": {
    "value": "var(--iMagva)",
    "variable": "var(--iMagva)"
  },
  "colors.dataViz.purple.1000": {
    "value": "var(--cgwyge)",
    "variable": "var(--cgwyge)"
  },
  "colors.dataViz.purple.1100": {
    "value": "var(--eEkdin)",
    "variable": "var(--eEkdin)"
  },
  "colors.dataViz.purple.1200": {
    "value": "var(--cGKjvQ)",
    "variable": "var(--cGKjvQ)"
  },
  "colors.gray.50": {
    "value": "var(--dcmCJN)",
    "variable": "var(--dcmCJN)"
  },
  "colors.gray.100": {
    "value": "var(--ePJGsV)",
    "variable": "var(--ePJGsV)"
  },
  "colors.gray.200": {
    "value": "var(--dnVpUm)",
    "variable": "var(--dnVpUm)"
  },
  "colors.gray.300": {
    "value": "var(--bMJKSL)",
    "variable": "var(--bMJKSL)"
  },
  "colors.gray.400": {
    "value": "var(--jSiOQk)",
    "variable": "var(--jSiOQk)"
  },
  "colors.gray.500": {
    "value": "var(--iqXjOJ)",
    "variable": "var(--iqXjOJ)"
  },
  "colors.gray.600": {
    "value": "var(--gPiTqa)",
    "variable": "var(--gPiTqa)"
  },
  "colors.gray.700": {
    "value": "var(--fnXooz)",
    "variable": "var(--fnXooz)"
  },
  "colors.gray.800": {
    "value": "var(--fKIyfA)",
    "variable": "var(--fKIyfA)"
  },
  "colors.gray.900": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--ejwTdZ)"
  },
  "colors.gray.950": {
    "value": "var(--jympbw)",
    "variable": "var(--jympbw)"
  },
  "colors.green.50": {
    "value": "var(--hXozqf)",
    "variable": "var(--hXozqf)"
  },
  "colors.green.100": {
    "value": "var(--iDDIAz)",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.200": {
    "value": "var(--khfuXU)",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "var(--hypAVx)",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "var(--wGfza)",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "var(--jdlUVz)",
    "variable": "var(--jdlUVz)"
  },
  "colors.green.600": {
    "value": "var(--kGNHsU)",
    "variable": "var(--kGNHsU)"
  },
  "colors.green.700": {
    "value": "var(--hXXNqx)",
    "variable": "var(--hXXNqx)"
  },
  "colors.green.800": {
    "value": "var(--bAQeLK)",
    "variable": "var(--bAQeLK)"
  },
  "colors.green.900": {
    "value": "var(--khvUij)",
    "variable": "var(--khvUij)"
  },
  "colors.green.950": {
    "value": "var(--cbdKOS)",
    "variable": "var(--cbdKOS)"
  },
  "colors.orange.50": {
    "value": "var(--NQTLQ)",
    "variable": "var(--NQTLQ)"
  },
  "colors.orange.100": {
    "value": "var(--JsfmQ)",
    "variable": "var(--JsfmQ)"
  },
  "colors.orange.200": {
    "value": "var(--gBjjlD)",
    "variable": "var(--gBjjlD)"
  },
  "colors.orange.300": {
    "value": "var(--QMCLK)",
    "variable": "var(--QMCLK)"
  },
  "colors.orange.400": {
    "value": "var(--ijESlZ)",
    "variable": "var(--ijESlZ)"
  },
  "colors.orange.500": {
    "value": "var(--czilMg)",
    "variable": "var(--czilMg)"
  },
  "colors.orange.600": {
    "value": "var(--iqZpKT)",
    "variable": "var(--iqZpKT)"
  },
  "colors.orange.700": {
    "value": "var(--cGCJla)",
    "variable": "var(--cGCJla)"
  },
  "colors.orange.800": {
    "value": "var(--dUhLNN)",
    "variable": "var(--dUhLNN)"
  },
  "colors.orange.900": {
    "value": "var(--jzgOMQ)",
    "variable": "var(--jzgOMQ)"
  },
  "colors.orange.950": {
    "value": "var(--igBpVl)",
    "variable": "var(--igBpVl)"
  },
  "colors.purple.50": {
    "value": "var(--ksTgfC)",
    "variable": "var(--ksTgfC)"
  },
  "colors.purple.100": {
    "value": "var(--iCdJRO)",
    "variable": "var(--iCdJRO)"
  },
  "colors.purple.200": {
    "value": "var(--dWAXWh)",
    "variable": "var(--dWAXWh)"
  },
  "colors.purple.300": {
    "value": "var(--jcWlLI)",
    "variable": "var(--jcWlLI)"
  },
  "colors.purple.400": {
    "value": "var(--eLlnzT)",
    "variable": "var(--eLlnzT)"
  },
  "colors.purple.500": {
    "value": "var(--jRGBpu)",
    "variable": "var(--jRGBpu)"
  },
  "colors.purple.600": {
    "value": "var(--fmdPtN)",
    "variable": "var(--fmdPtN)"
  },
  "colors.purple.700": {
    "value": "var(--kszdjo)",
    "variable": "var(--kszdjo)"
  },
  "colors.purple.800": {
    "value": "var(--kMigIv)",
    "variable": "var(--kMigIv)"
  },
  "colors.purple.900": {
    "value": "var(--eDhKZa)",
    "variable": "var(--eDhKZa)"
  },
  "colors.purple.950": {
    "value": "var(--eadxYH)",
    "variable": "var(--eadxYH)"
  },
  "colors.red.50": {
    "value": "var(--bINrJX)",
    "variable": "var(--bINrJX)"
  },
  "colors.red.100": {
    "value": "var(--fKgVwH)",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "var(--bLdQLg)",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "var(--fMUQaR)",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "var(--hwCQam)",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "var(--iYfRb)",
    "variable": "var(--iYfRb)"
  },
  "colors.red.600": {
    "value": "var(--hzqKEw)",
    "variable": "var(--hzqKEw)"
  },
  "colors.red.700": {
    "value": "var(--lMavl)",
    "variable": "var(--lMavl)"
  },
  "colors.red.800": {
    "value": "var(--bLDcWa)",
    "variable": "var(--bLDcWa)"
  },
  "colors.red.900": {
    "value": "var(--fNuclL)",
    "variable": "var(--fNuclL)"
  },
  "colors.red.950": {
    "value": "var(--jHDsLG)",
    "variable": "var(--jHDsLG)"
  },
  "colors.teal.50": {
    "value": "var(--jqQOis)",
    "variable": "var(--jqQOis)"
  },
  "colors.teal.100": {
    "value": "var(--hsCMHs)",
    "variable": "var(--hsCMHs)"
  },
  "colors.teal.200": {
    "value": "var(--jcJhxj)",
    "variable": "var(--jcJhxj)"
  },
  "colors.teal.300": {
    "value": "var(--czjDVi)",
    "variable": "var(--czjDVi)"
  },
  "colors.teal.400": {
    "value": "var(--kfgCt)",
    "variable": "var(--kfgCt)"
  },
  "colors.teal.500": {
    "value": "var(--eWbmzo)",
    "variable": "var(--eWbmzo)"
  },
  "colors.teal.600": {
    "value": "var(--gGhHpf)",
    "variable": "var(--gGhHpf)"
  },
  "colors.teal.700": {
    "value": "var(--cIdNe)",
    "variable": "var(--cIdNe)"
  },
  "colors.teal.800": {
    "value": "var(--catTvB)",
    "variable": "var(--catTvB)"
  },
  "colors.teal.900": {
    "value": "var(--gMpZsw)",
    "variable": "var(--gMpZsw)"
  },
  "colors.teal.950": {
    "value": "var(--bnTNlF)",
    "variable": "var(--bnTNlF)"
  },
  "colors.transparent.invisible": {
    "value": "var(--hULkOe)",
    "variable": "var(--hULkOe)"
  },
  "colors.transparent.black-0": {
    "value": "var(--dDQaeN)",
    "variable": "var(--dDQaeN)"
  },
  "colors.transparent.black-15": {
    "value": "var(--iGwhMB)",
    "variable": "var(--iGwhMB)"
  },
  "colors.transparent.black-20": {
    "value": "var(--fDSgRj)",
    "variable": "var(--fDSgRj)"
  },
  "colors.transparent.black-30": {
    "value": "var(--eDinTq)",
    "variable": "var(--eDinTq)"
  },
  "colors.transparent.black-60": {
    "value": "var(--YFCur)",
    "variable": "var(--YFCur)"
  },
  "colors.transparent.black-75": {
    "value": "var(--bWsqLb)",
    "variable": "var(--bWsqLb)"
  },
  "colors.transparent.white-0": {
    "value": "var(--iMRenZ)",
    "variable": "var(--iMRenZ)"
  },
  "colors.transparent.white-30": {
    "value": "var(--fTIDTW)",
    "variable": "var(--fTIDTW)"
  },
  "colors.transparent.white-40": {
    "value": "var(--crXcZh)",
    "variable": "var(--crXcZh)"
  },
  "colors.transparent.white-60": {
    "value": "var(--bMpXYj)",
    "variable": "var(--bMpXYj)"
  },
  "colors.transparent.white-80": {
    "value": "var(--kclypd)",
    "variable": "var(--kclypd)"
  },
  "colors.transparent.gray.50-0": {
    "value": "var(--dQAkQT)",
    "variable": "var(--dQAkQT)"
  },
  "colors.transparent.gray.100-0": {
    "value": "var(--diQjxL)",
    "variable": "var(--diQjxL)"
  },
  "colors.transparent.gray.200-0": {
    "value": "var(--hEUfIQ)",
    "variable": "var(--hEUfIQ)"
  },
  "colors.transparent.gray.300-0": {
    "value": "var(--beMgBh)",
    "variable": "var(--beMgBh)"
  },
  "colors.transparent.gray.400-0": {
    "value": "var(--fBtvnW)",
    "variable": "var(--fBtvnW)"
  },
  "colors.transparent.gray.400-20": {
    "value": "var(--iiJlk)",
    "variable": "var(--iiJlk)"
  },
  "colors.transparent.gray.400-30": {
    "value": "var(--bAxmdB)",
    "variable": "var(--bAxmdB)"
  },
  "colors.transparent.gray.500-0": {
    "value": "var(--eABFuL)",
    "variable": "var(--eABFuL)"
  },
  "colors.transparent.gray.500-20": {
    "value": "var(--eXwtCx)",
    "variable": "var(--eXwtCx)"
  },
  "colors.transparent.gray.500-30": {
    "value": "var(--dhhMXI)",
    "variable": "var(--dhhMXI)"
  },
  "colors.transparent.gray.600-0": {
    "value": "var(--iWFBFQ)",
    "variable": "var(--iWFBFQ)"
  },
  "colors.transparent.gray.600-20": {
    "value": "var(--icsmsm)",
    "variable": "var(--icsmsm)"
  },
  "colors.transparent.gray.600-30": {
    "value": "var(--juGPkD)",
    "variable": "var(--juGPkD)"
  },
  "colors.transparent.gray.600-40": {
    "value": "var(--gWLFzU)",
    "variable": "var(--gWLFzU)"
  },
  "colors.transparent.gray.600-60": {
    "value": "var(--hmpHia)",
    "variable": "var(--hmpHia)"
  },
  "colors.transparent.gray.700-0": {
    "value": "var(--cwxCyh)",
    "variable": "var(--cwxCyh)"
  },
  "colors.transparent.gray.700-80": {
    "value": "var(--fhTSjR)",
    "variable": "var(--fhTSjR)"
  },
  "colors.transparent.gray.800-0": {
    "value": "var(--jinnxS)",
    "variable": "var(--jinnxS)"
  },
  "colors.transparent.gray.900-0": {
    "value": "var(--ihvxEH)",
    "variable": "var(--ihvxEH)"
  },
  "colors.transparent.gray.900-80": {
    "value": "var(--VHlcz)",
    "variable": "var(--VHlcz)"
  },
  "colors.transparent.gray.950-20": {
    "value": "var(--jeRNVI)",
    "variable": "var(--jeRNVI)"
  },
  "colors.transparent.gray.950-30": {
    "value": "var(--OTFxd)",
    "variable": "var(--OTFxd)"
  },
  "colors.white": {
    "value": "var(--RiClf)",
    "variable": "var(--RiClf)"
  },
  "colors.yellow.50": {
    "value": "var(--cLFWMs)",
    "variable": "var(--cLFWMs)"
  },
  "colors.yellow.100": {
    "value": "var(--kxGpio)",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "var(--cbZZGT)",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "var(--fwcFBW)",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "var(--hUTJsd)",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "var(--loWpng)",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "var(--cTpZLL)",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "var(--gnsFGO)",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "var(--ByZWN)",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "var(--dVBFRQ)",
    "variable": "var(--dVBFRQ)"
  },
  "colors.yellow.950": {
    "value": "var(--iLqZUR)",
    "variable": "var(--iLqZUR)"
  },
  "borderWidths.25": {
    "value": "var(--cglXXs)",
    "variable": "var(--cglXXs)"
  },
  "borderWidths.50": {
    "value": "var(--heXhMm)",
    "variable": "var(--heXhMm)"
  },
  "borderWidths.100": {
    "value": "var(--eyojOW)",
    "variable": "var(--eyojOW)"
  },
  "borderWidths.150": {
    "value": "var(--eGyQvb)",
    "variable": "var(--eGyQvb)"
  },
  "borderWidths.zero": {
    "value": "var(--hHSOTV)",
    "variable": "var(--hHSOTV)"
  },
  "radii.50": {
    "value": "var(--cbuAfw)",
    "variable": "var(--cbuAfw)"
  },
  "radii.100": {
    "value": "var(--gDEwJY)",
    "variable": "var(--gDEwJY)"
  },
  "radii.150": {
    "value": "var(--jFCAyl)",
    "variable": "var(--jFCAyl)"
  },
  "radii.200": {
    "value": "var(--ksYUhH)",
    "variable": "var(--ksYUhH)"
  },
  "radii.300": {
    "value": "var(--ccPOou)",
    "variable": "var(--ccPOou)"
  },
  "radii.400": {
    "value": "var(--cgcEXx)",
    "variable": "var(--cgcEXx)"
  },
  "radii.500": {
    "value": "var(--ffpiDg)",
    "variable": "var(--ffpiDg)"
  },
  "radii.600": {
    "value": "var(--iUJGaP)",
    "variable": "var(--iUJGaP)"
  },
  "radii.700": {
    "value": "var(--EAAhC)",
    "variable": "var(--EAAhC)"
  },
  "radii.zero": {
    "value": "var(--gMOumn)",
    "variable": "var(--gMOumn)"
  },
  "radii.capsule": {
    "value": "var(--cmmfRw)",
    "variable": "var(--cmmfRw)"
  },
  "radii.ellipse": {
    "value": "var(--fKwbFz)",
    "variable": "var(--fKwbFz)"
  },
  "spacing.25": {
    "value": "var(--ieWSsg)",
    "variable": "var(--ieWSsg)"
  },
  "spacing.50": {
    "value": "var(--kKbbUK)",
    "variable": "var(--kKbbUK)"
  },
  "spacing.100": {
    "value": "var(--bIgSVm)",
    "variable": "var(--bIgSVm)"
  },
  "spacing.150": {
    "value": "var(--hmVCZH)",
    "variable": "var(--hmVCZH)"
  },
  "spacing.200": {
    "value": "var(--cJysOB)",
    "variable": "var(--cJysOB)"
  },
  "spacing.250": {
    "value": "var(--bIrbJs)",
    "variable": "var(--bIrbJs)"
  },
  "spacing.300": {
    "value": "var(--GHwVU)",
    "variable": "var(--GHwVU)"
  },
  "spacing.350": {
    "value": "var(--gmJDqV)",
    "variable": "var(--gmJDqV)"
  },
  "spacing.400": {
    "value": "var(--gqmheD)",
    "variable": "var(--gqmheD)"
  },
  "spacing.500": {
    "value": "var(--envllW)",
    "variable": "var(--envllW)"
  },
  "spacing.600": {
    "value": "var(--foMLfl)",
    "variable": "var(--foMLfl)"
  },
  "spacing.700": {
    "value": "var(--dlVPmE)",
    "variable": "var(--dlVPmE)"
  },
  "spacing.800": {
    "value": "var(--dUcYJv)",
    "variable": "var(--dUcYJv)"
  },
  "spacing.900": {
    "value": "var(--bRmcQO)",
    "variable": "var(--bRmcQO)"
  },
  "spacing.1000": {
    "value": "var(--iUTQca)",
    "variable": "var(--iUTQca)"
  },
  "spacing.1100": {
    "value": "var(--drMEwr)",
    "variable": "var(--drMEwr)"
  },
  "spacing.1200": {
    "value": "var(--bkFxjg)",
    "variable": "var(--bkFxjg)"
  },
  "spacing.1300": {
    "value": "var(--gWTVct)",
    "variable": "var(--gWTVct)"
  },
  "spacing.1400": {
    "value": "var(--iNucni)",
    "variable": "var(--iNucni)"
  },
  "spacing.1500": {
    "value": "var(--dkmQHz)",
    "variable": "var(--dkmQHz)"
  },
  "spacing.1600": {
    "value": "var(--bdfJuo)",
    "variable": "var(--bdfJuo)"
  },
  "spacing.1800": {
    "value": "var(--dofCJK)",
    "variable": "var(--dofCJK)"
  },
  "spacing.2400": {
    "value": "var(--jOLCgx)",
    "variable": "var(--jOLCgx)"
  },
  "spacing.negative-25": {
    "value": "var(--cKgcde)",
    "variable": "var(--cKgcde)"
  },
  "spacing.zero": {
    "value": "var(--LDKR)",
    "variable": "var(--LDKR)"
  },
  "sizes.25": {
    "value": "var(--eadANn)",
    "variable": "var(--eadANn)"
  },
  "sizes.50": {
    "value": "var(--ceVROR)",
    "variable": "var(--ceVROR)"
  },
  "sizes.75": {
    "value": "var(--dDrAge)",
    "variable": "var(--dDrAge)"
  },
  "sizes.100": {
    "value": "var(--gBYfPl)",
    "variable": "var(--gBYfPl)"
  },
  "sizes.150": {
    "value": "var(--jDUkyk)",
    "variable": "var(--jDUkyk)"
  },
  "sizes.200": {
    "value": "var(--krYoSC)",
    "variable": "var(--krYoSC)"
  },
  "sizes.250": {
    "value": "var(--gYOBBD)",
    "variable": "var(--gYOBBD)"
  },
  "sizes.300": {
    "value": "var(--cbPiZr)",
    "variable": "var(--cbPiZr)"
  },
  "sizes.350": {
    "value": "var(--fdLnIq)",
    "variable": "var(--fdLnIq)"
  },
  "sizes.400": {
    "value": "var(--ceuoXw)",
    "variable": "var(--ceuoXw)"
  },
  "sizes.500": {
    "value": "var(--fdGSDh)",
    "variable": "var(--fdGSDh)"
  },
  "sizes.600": {
    "value": "var(--iTHbGy)",
    "variable": "var(--iTHbGy)"
  },
  "sizes.700": {
    "value": "var(--DxVNn)",
    "variable": "var(--DxVNn)"
  },
  "sizes.750": {
    "value": "var(--gCcAUu)",
    "variable": "var(--gCcAUu)"
  },
  "sizes.800": {
    "value": "var(--gzqenc)",
    "variable": "var(--gzqenc)"
  },
  "sizes.900": {
    "value": "var(--jyCHSN)",
    "variable": "var(--jyCHSN)"
  },
  "sizes.1000": {
    "value": "var(--kKXdOV)",
    "variable": "var(--kKXdOV)"
  },
  "sizes.1100": {
    "value": "var(--jwTOvA)",
    "variable": "var(--jwTOvA)"
  },
  "sizes.1200": {
    "value": "var(--jsyCsv)",
    "variable": "var(--jsyCsv)"
  },
  "sizes.1300": {
    "value": "var(--ievmZa)",
    "variable": "var(--ievmZa)"
  },
  "sizes.1400": {
    "value": "var(--dLAOst)",
    "variable": "var(--dLAOst)"
  },
  "sizes.1500": {
    "value": "var(--cxxyYY)",
    "variable": "var(--cxxyYY)"
  },
  "sizes.1600": {
    "value": "var(--ctcmVT)",
    "variable": "var(--ctcmVT)"
  },
  "sizes.1700": {
    "value": "var(--beYXCy)",
    "variable": "var(--beYXCy)"
  },
  "sizes.1800": {
    "value": "var(--ceUrpB)",
    "variable": "var(--ceUrpB)"
  },
  "sizes.1900": {
    "value": "var(--QRbWg)",
    "variable": "var(--QRbWg)"
  },
  "sizes.2000": {
    "value": "var(--dlBDtq)",
    "variable": "var(--dlBDtq)"
  },
  "sizes.2100": {
    "value": "var(--gROfyT)",
    "variable": "var(--gROfyT)"
  },
  "sizes.2200": {
    "value": "var(--kfhgfA)",
    "variable": "var(--kfhgfA)"
  },
  "sizes.2300": {
    "value": "var(--cvXYMh)",
    "variable": "var(--cvXYMh)"
  },
  "sizes.2400": {
    "value": "var(--hBAXvK)",
    "variable": "var(--hBAXvK)"
  },
  "sizes.2500": {
    "value": "var(--lhNzBn)",
    "variable": "var(--lhNzBn)"
  },
  "sizes.2600": {
    "value": "var(--dfKQIY)",
    "variable": "var(--dfKQIY)"
  },
  "sizes.3600": {
    "value": "var(--gUyCVV)",
    "variable": "var(--gUyCVV)"
  },
  "sizes.4000": {
    "value": "var(--gntmXg)",
    "variable": "var(--gntmXg)"
  },
  "sizes.5000": {
    "value": "var(--jmFQCR)",
    "variable": "var(--jmFQCR)"
  },
  "sizes.zero": {
    "value": "var(--gPKapW)",
    "variable": "var(--gPKapW)"
  },
  "sizes.effect.blur.25": {
    "value": "var(--kPVzYV)",
    "variable": "var(--kPVzYV)"
  },
  "sizes.effect.blur.50": {
    "value": "var(--ecLvoD)",
    "variable": "var(--ecLvoD)"
  },
  "sizes.effect.blur.100": {
    "value": "var(--iBpESb)",
    "variable": "var(--iBpESb)"
  },
  "sizes.effect.blur.200": {
    "value": "var(--bkgKKc)",
    "variable": "var(--bkgKKc)"
  },
  "sizes.effect.blur.300": {
    "value": "var(--hByeKd)",
    "variable": "var(--hByeKd)"
  },
  "sizes.effect.blur.400": {
    "value": "var(--bjDpPq)",
    "variable": "var(--bjDpPq)"
  },
  "sizes.effect.blur.500": {
    "value": "var(--hAUJPr)",
    "variable": "var(--hAUJPr)"
  },
  "sizes.effect.blur.750": {
    "value": "var(--jivFhw)",
    "variable": "var(--jivFhw)"
  },
  "sizes.effect.offset.50": {
    "value": "var(--blFaXT)",
    "variable": "var(--blFaXT)"
  },
  "sizes.effect.offset.100": {
    "value": "var(--tfAVj)",
    "variable": "var(--tfAVj)"
  },
  "sizes.effect.offset.150": {
    "value": "var(--kglSMy)",
    "variable": "var(--kglSMy)"
  },
  "sizes.effect.offset.200": {
    "value": "var(--eLLTaM)",
    "variable": "var(--eLLTaM)"
  },
  "sizes.effect.offset.400": {
    "value": "var(--ktCmqW)",
    "variable": "var(--ktCmqW)"
  },
  "sizes.effect.offset.none": {
    "value": "var(--fmMddI)",
    "variable": "var(--fmMddI)"
  },
  "sizes.effect.spread.25": {
    "value": "var(--ewmNGV)",
    "variable": "var(--ewmNGV)"
  },
  "sizes.effect.spread.75": {
    "value": "var(--BEmzg)",
    "variable": "var(--BEmzg)"
  },
  "sizes.effect.spread.100": {
    "value": "var(--jeDcoX)",
    "variable": "var(--jeDcoX)"
  },
  "sizes.effect.spread.none": {
    "value": "var(--cbsCCc)",
    "variable": "var(--cbsCCc)"
  },
  "shadows.none": {
    "value": "var(--dkKAZB)",
    "variable": "var(--dkKAZB)"
  },
  "shadows.focus": {
    "value": "var(--daWseH)",
    "variable": "var(--daWseH)"
  },
  "shadows.sm": {
    "value": "var(--cDhNnp)",
    "variable": "var(--cDhNnp)"
  },
  "shadows.smHeavy": {
    "value": "var(--hvBWAy)",
    "variable": "var(--hvBWAy)"
  },
  "shadows.md": {
    "value": "var(--jMKUKK)",
    "variable": "var(--jMKUKK)"
  },
  "shadows.lg": {
    "value": "var(--kNVcRA)",
    "variable": "var(--kNVcRA)"
  },
  "opacity.8": {
    "value": "var(--gYXNUb)",
    "variable": "var(--gYXNUb)"
  },
  "opacity.10": {
    "value": "var(--fnEHeW)",
    "variable": "var(--fnEHeW)"
  },
  "opacity.12": {
    "value": "var(--mDXyI)",
    "variable": "var(--mDXyI)"
  },
  "opacity.15": {
    "value": "var(--cAPzRP)",
    "variable": "var(--cAPzRP)"
  },
  "opacity.20": {
    "value": "var(--fmanxx)",
    "variable": "var(--fmanxx)"
  },
  "opacity.30": {
    "value": "var(--ctIjcA)",
    "variable": "var(--ctIjcA)"
  },
  "opacity.32": {
    "value": "var(--kJOBwO)",
    "variable": "var(--kJOBwO)"
  },
  "opacity.40": {
    "value": "var(--cstQiv)",
    "variable": "var(--cstQiv)"
  },
  "opacity.50": {
    "value": "var(--kPxvmu)",
    "variable": "var(--kPxvmu)"
  },
  "opacity.60": {
    "value": "var(--kNTbEV)",
    "variable": "var(--kNTbEV)"
  },
  "opacity.70": {
    "value": "var(--hVAXjY)",
    "variable": "var(--hVAXjY)"
  },
  "opacity.75": {
    "value": "var(--ftiAQl)",
    "variable": "var(--ftiAQl)"
  },
  "opacity.80": {
    "value": "var(--eAwrXv)",
    "variable": "var(--eAwrXv)"
  },
  "opacity.100": {
    "value": "var(--gujXsi)",
    "variable": "var(--gujXsi)"
  },
  "opacity.zero": {
    "value": "var(--ksLLuZ)",
    "variable": "var(--ksLLuZ)"
  },
  "fonts.brand": {
    "value": "var(--khATbp)",
    "variable": "var(--khATbp)"
  },
  "fonts.ui": {
    "value": "var(--lcluZy)",
    "variable": "var(--lcluZy)"
  },
  "lineHeights.400": {
    "value": "var(--jDitYg)",
    "variable": "var(--jDitYg)"
  },
  "lineHeights.600": {
    "value": "var(--evCOgK)",
    "variable": "var(--evCOgK)"
  },
  "lineHeights.800": {
    "value": "var(--dbimSI)",
    "variable": "var(--dbimSI)"
  },
  "lineHeights.1000": {
    "value": "var(--Rnkil)",
    "variable": "var(--Rnkil)"
  },
  "lineHeights.1200": {
    "value": "var(--gXoecH)",
    "variable": "var(--gXoecH)"
  },
  "lineHeights.1400": {
    "value": "var(--jMbXuV)",
    "variable": "var(--jMbXuV)"
  },
  "lineHeights.1600": {
    "value": "var(--eCHhQv)",
    "variable": "var(--eCHhQv)"
  },
  "lineHeights.1800": {
    "value": "var(--dRwEut)",
    "variable": "var(--dRwEut)"
  },
  "fontWeights.regular": {
    "value": "var(--TgeWs)",
    "variable": "var(--TgeWs)"
  },
  "fontWeights.bold": {
    "value": "var(--ghWdwL)",
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.heavy": {
    "value": "var(--fCTlhV)",
    "variable": "var(--fCTlhV)"
  },
  "fontWeights.heading": {
    "value": "var(--hntMky)",
    "variable": "var(--hntMky)"
  },
  "fontWeights.emphasis": {
    "value": "var(--jGnMpK)",
    "variable": "var(--jGnMpK)"
  },
  "fontWeights.default": {
    "value": "var(--AYfyZ)",
    "variable": "var(--AYfyZ)"
  },
  "fontWeights.responsive.default.mobile": {
    "value": "var(--kfkHTR)",
    "variable": "var(--kfkHTR)"
  },
  "fontWeights.responsive.default.tablet": {
    "value": "var(--iQPysT)",
    "variable": "var(--iQPysT)"
  },
  "fontWeights.responsive.default.desktop": {
    "value": "var(--bXmfwf)",
    "variable": "var(--bXmfwf)"
  },
  "fontWeights.responsive.emphasis.mobile": {
    "value": "var(--kropzO)",
    "variable": "var(--kropzO)"
  },
  "fontWeights.responsive.emphasis.tablet": {
    "value": "var(--fTcXDY)",
    "variable": "var(--fTcXDY)"
  },
  "fontWeights.responsive.emphasis.desktop": {
    "value": "var(--gqNCNs)",
    "variable": "var(--gqNCNs)"
  },
  "fontWeights.responsive.heading.mobile": {
    "value": "var(--lbYge)",
    "variable": "var(--lbYge)"
  },
  "fontWeights.responsive.heading.tablet": {
    "value": "var(--kNLDlk)",
    "variable": "var(--kNLDlk)"
  },
  "fontWeights.responsive.heading.desktop": {
    "value": "var(--gqJGiU)",
    "variable": "var(--gqJGiU)"
  },
  "fontSizes.250": {
    "value": "var(--rAUoI)",
    "variable": "var(--rAUoI)"
  },
  "fontSizes.300": {
    "value": "var(--dwPDDk)",
    "variable": "var(--dwPDDk)"
  },
  "fontSizes.350": {
    "value": "var(--hqmFgZ)",
    "variable": "var(--hqmFgZ)"
  },
  "fontSizes.400": {
    "value": "var(--MCGrf)",
    "variable": "var(--MCGrf)"
  },
  "fontSizes.450": {
    "value": "var(--kntzZW)",
    "variable": "var(--kntzZW)"
  },
  "fontSizes.500": {
    "value": "var(--gBaQWy)",
    "variable": "var(--gBaQWy)"
  },
  "fontSizes.600": {
    "value": "var(--fezXBV)",
    "variable": "var(--fezXBV)"
  },
  "fontSizes.700": {
    "value": "var(--kUlBrw)",
    "variable": "var(--kUlBrw)"
  },
  "fontSizes.800": {
    "value": "var(--lhvPTb)",
    "variable": "var(--lhvPTb)"
  },
  "fontSizes.900": {
    "value": "var(--fGyqZy)",
    "variable": "var(--fGyqZy)"
  },
  "fontSizes.1000": {
    "value": "var(--dAXelW)",
    "variable": "var(--dAXelW)"
  },
  "fontSizes.1100": {
    "value": "var(--hHbVzj)",
    "variable": "var(--hHbVzj)"
  },
  "fontSizes.1200": {
    "value": "var(--jAYdUM)",
    "variable": "var(--jAYdUM)"
  },
  "fontSizes.1500": {
    "value": "var(--huufPL)",
    "variable": "var(--huufPL)"
  },
  "letterSpacings.none": {
    "value": "var(--haSKcM)",
    "variable": "var(--haSKcM)"
  },
  "letterSpacings.default": {
    "value": "var(--jkEUmF)",
    "variable": "var(--jkEUmF)"
  },
  "zIndex.loadingMask": {
    "value": "var(--cQzMgg)",
    "variable": "var(--cQzMgg)"
  },
  "zIndex.combobox": {
    "value": "var(--elZHlj)",
    "variable": "var(--elZHlj)"
  },
  "zIndex.datePicker": {
    "value": "var(--jYDUSU)",
    "variable": "var(--jYDUSU)"
  },
  "zIndex.dropdown": {
    "value": "var(--TWcuN)",
    "variable": "var(--TWcuN)"
  },
  "zIndex.menu": {
    "value": "var(--eNmByV)",
    "variable": "var(--eNmByV)"
  },
  "zIndex.modal": {
    "value": "var(--dIktSh)",
    "variable": "var(--dIktSh)"
  },
  "zIndex.popover": {
    "value": "var(--beAiOT)",
    "variable": "var(--beAiOT)"
  },
  "zIndex.tooltip": {
    "value": "var(--hVmPBT)",
    "variable": "var(--hVmPBT)"
  },
  "zIndex.toast": {
    "value": "var(--BtcyX)",
    "variable": "var(--BtcyX)"
  },
  "colors.dataViz.categorical.brand.fg.onA": {
    "value": "var(--dpzPTt)",
    "variable": "var(--dpzPTt)"
  },
  "colors.dataViz.categorical.brand.fg.onB": {
    "value": "var(--kJNdKe)",
    "variable": "var(--kJNdKe)"
  },
  "colors.dataViz.categorical.brand.fg.onC": {
    "value": "var(--eWRtLr)",
    "variable": "var(--eWRtLr)"
  },
  "colors.dataViz.categorical.brand.fg.onD": {
    "value": "var(--eqlhcQ)",
    "variable": "var(--eqlhcQ)"
  },
  "colors.dataViz.categorical.brand.fg.onE": {
    "value": "var(--boknCd)",
    "variable": "var(--boknCd)"
  },
  "colors.dataViz.categorical.brand.fg.onF": {
    "value": "var(--iIxBsO)",
    "variable": "var(--iIxBsO)"
  },
  "colors.dataViz.categorical.brand.fg.onG": {
    "value": "var(--cVBRub)",
    "variable": "var(--cVBRub)"
  },
  "colors.dataViz.categorical.brand.fg.onH": {
    "value": "var(--jCuABY)",
    "variable": "var(--jCuABY)"
  },
  "colors.dataViz.categorical.brand.fg.onA-hero": {
    "value": "var(--jDrwSQ)",
    "variable": "var(--jDrwSQ)"
  },
  "colors.dataViz.categorical.brand.fg.onB-hero": {
    "value": "var(--dLliEH)",
    "variable": "var(--dLliEH)"
  },
  "colors.dataViz.categorical.brand.fg.onC-hero": {
    "value": "var(--gUBzKy)",
    "variable": "var(--gUBzKy)"
  },
  "colors.dataViz.categorical.brand.fg.onD-hero": {
    "value": "var(--ivqIep)",
    "variable": "var(--ivqIep)"
  },
  "colors.dataViz.categorical.brand.fg.onE-hero": {
    "value": "var(--plpLk)",
    "variable": "var(--plpLk)"
  },
  "colors.dataViz.categorical.brand.fg.onF-hero": {
    "value": "var(--fMAKVX)",
    "variable": "var(--fMAKVX)"
  },
  "colors.dataViz.categorical.brand.fg.onG-hero": {
    "value": "var(--iVRcbO)",
    "variable": "var(--iVRcbO)"
  },
  "colors.dataViz.categorical.brand.fg.onH-hero": {
    "value": "var(--djhoFh)",
    "variable": "var(--djhoFh)"
  },
  "colors.dataViz.categorical.brand.A": {
    "value": "var(--kkNOcI)",
    "variable": "var(--kkNOcI)"
  },
  "colors.dataViz.categorical.brand.B": {
    "value": "var(--cbceFD)",
    "variable": "var(--cbceFD)"
  },
  "colors.dataViz.categorical.brand.C": {
    "value": "var(--cWICgq)",
    "variable": "var(--cWICgq)"
  },
  "colors.dataViz.categorical.brand.D": {
    "value": "var(--bBXRcx)",
    "variable": "var(--bBXRcx)"
  },
  "colors.dataViz.categorical.brand.E": {
    "value": "var(--hUkJNY)",
    "variable": "var(--hUkJNY)"
  },
  "colors.dataViz.categorical.brand.F": {
    "value": "var(--kZUJPP)",
    "variable": "var(--kZUJPP)"
  },
  "colors.dataViz.categorical.brand.G": {
    "value": "var(--GfxRG)",
    "variable": "var(--GfxRG)"
  },
  "colors.dataViz.categorical.brand.H": {
    "value": "var(--fdSkiJ)",
    "variable": "var(--fdSkiJ)"
  },
  "colors.dataViz.categorical.insight.fg.onA": {
    "value": "var(--kYoUkY)",
    "variable": "var(--kYoUkY)"
  },
  "colors.dataViz.categorical.insight.fg.onB": {
    "value": "var(--UWmEb)",
    "variable": "var(--UWmEb)"
  },
  "colors.dataViz.categorical.insight.fg.onC": {
    "value": "var(--gKHgtC)",
    "variable": "var(--gKHgtC)"
  },
  "colors.dataViz.categorical.insight.fg.onD": {
    "value": "var(--dGqgcx)",
    "variable": "var(--dGqgcx)"
  },
  "colors.dataViz.categorical.insight.fg.onE": {
    "value": "var(--gBFLao)",
    "variable": "var(--gBFLao)"
  },
  "colors.dataViz.categorical.insight.fg.onF": {
    "value": "var(--hNIMSn)",
    "variable": "var(--hNIMSn)"
  },
  "colors.dataViz.categorical.insight.fg.onG": {
    "value": "var(--cnXXiS)",
    "variable": "var(--cnXXiS)"
  },
  "colors.dataViz.categorical.insight.fg.onH": {
    "value": "var(--ecblAB)",
    "variable": "var(--ecblAB)"
  },
  "colors.dataViz.categorical.insight.fg.onA-hero": {
    "value": "var(--knPNZB)",
    "variable": "var(--knPNZB)"
  },
  "colors.dataViz.categorical.insight.fg.onB-hero": {
    "value": "var(--czRFJy)",
    "variable": "var(--czRFJy)"
  },
  "colors.dataViz.categorical.insight.fg.onC-hero": {
    "value": "var(--jXoNED)",
    "variable": "var(--jXoNED)"
  },
  "colors.dataViz.categorical.insight.fg.onD-hero": {
    "value": "var(--hnbPpg)",
    "variable": "var(--hnbPpg)"
  },
  "colors.dataViz.categorical.insight.fg.onE-hero": {
    "value": "var(--dvdnLp)",
    "variable": "var(--dvdnLp)"
  },
  "colors.dataViz.categorical.insight.fg.onF-hero": {
    "value": "var(--gWAOUi)",
    "variable": "var(--gWAOUi)"
  },
  "colors.dataViz.categorical.insight.fg.onG-hero": {
    "value": "var(--deCnqr)",
    "variable": "var(--deCnqr)"
  },
  "colors.dataViz.categorical.insight.fg.onH-hero": {
    "value": "var(--gRqJRc)",
    "variable": "var(--gRqJRc)"
  },
  "colors.dataViz.categorical.insight.A": {
    "value": "var(--kfItfJ)",
    "variable": "var(--kfItfJ)"
  },
  "colors.dataViz.categorical.insight.B": {
    "value": "var(--eVCGYm)",
    "variable": "var(--eVCGYm)"
  },
  "colors.dataViz.categorical.insight.C": {
    "value": "var(--ilheGv)",
    "variable": "var(--ilheGv)"
  },
  "colors.dataViz.categorical.insight.D": {
    "value": "var(--bsyVac)",
    "variable": "var(--bsyVac)"
  },
  "colors.dataViz.categorical.insight.E": {
    "value": "var(--gzbKAl)",
    "variable": "var(--gzbKAl)"
  },
  "colors.dataViz.categorical.insight.F": {
    "value": "var(--boVYsO)",
    "variable": "var(--boVYsO)"
  },
  "colors.dataViz.categorical.insight.G": {
    "value": "var(--eEAwaX)",
    "variable": "var(--eEAwaX)"
  },
  "colors.dataViz.categorical.insight.H": {
    "value": "var(--gFPKPQ)",
    "variable": "var(--gFPKPQ)"
  },
  "colors.dataViz.categorical.inspire.fg.onA": {
    "value": "var(--UNUXs)",
    "variable": "var(--UNUXs)"
  },
  "colors.dataViz.categorical.inspire.fg.onB": {
    "value": "var(--iRbkJP)",
    "variable": "var(--iRbkJP)"
  },
  "colors.dataViz.categorical.inspire.fg.onC": {
    "value": "var(--cBkYwm)",
    "variable": "var(--cBkYwm)"
  },
  "colors.dataViz.categorical.inspire.fg.onD": {
    "value": "var(--kepmSZ)",
    "variable": "var(--kepmSZ)"
  },
  "colors.dataViz.categorical.inspire.fg.onE": {
    "value": "var(--hBmodM)",
    "variable": "var(--hBmodM)"
  },
  "colors.dataViz.categorical.inspire.fg.onF": {
    "value": "var(--eidUrn)",
    "variable": "var(--eidUrn)"
  },
  "colors.dataViz.categorical.inspire.fg.onG": {
    "value": "var(--jhJrCG)",
    "variable": "var(--jhJrCG)"
  },
  "colors.dataViz.categorical.inspire.fg.onH": {
    "value": "var(--PpDwN)",
    "variable": "var(--PpDwN)"
  },
  "colors.dataViz.categorical.inspire.fg.onA-hero": {
    "value": "var(--ezEUTx)",
    "variable": "var(--ezEUTx)"
  },
  "colors.dataViz.categorical.inspire.fg.onB-hero": {
    "value": "var(--fDHiPe)",
    "variable": "var(--fDHiPe)"
  },
  "colors.dataViz.categorical.inspire.fg.onC-hero": {
    "value": "var(--jdYgOz)",
    "variable": "var(--jdYgOz)"
  },
  "colors.dataViz.categorical.inspire.fg.onD-hero": {
    "value": "var(--fIlnmE)",
    "variable": "var(--fIlnmE)"
  },
  "colors.dataViz.categorical.inspire.fg.onE-hero": {
    "value": "var(--jiCllZ)",
    "variable": "var(--jiCllZ)"
  },
  "colors.dataViz.categorical.inspire.fg.onF-hero": {
    "value": "var(--kmEzhG)",
    "variable": "var(--kmEzhG)"
  },
  "colors.dataViz.categorical.inspire.fg.onG-hero": {
    "value": "var(--cxzNIf)",
    "variable": "var(--cxzNIf)"
  },
  "colors.dataViz.categorical.inspire.fg.onH-hero": {
    "value": "var(--dHPnjU)",
    "variable": "var(--dHPnjU)"
  },
  "colors.dataViz.categorical.inspire.A": {
    "value": "var(--gGIDUd)",
    "variable": "var(--gGIDUd)"
  },
  "colors.dataViz.categorical.inspire.B": {
    "value": "var(--gFgksa)",
    "variable": "var(--gFgksa)"
  },
  "colors.dataViz.categorical.inspire.C": {
    "value": "var(--hoUgtT)",
    "variable": "var(--hoUgtT)"
  },
  "colors.dataViz.categorical.inspire.D": {
    "value": "var(--ivAnnA)",
    "variable": "var(--ivAnnA)"
  },
  "colors.dataViz.categorical.inspire.E": {
    "value": "var(--dmqcwx)",
    "variable": "var(--dmqcwx)"
  },
  "colors.dataViz.categorical.inspire.F": {
    "value": "var(--dkNIUu)",
    "variable": "var(--dkNIUu)"
  },
  "colors.dataViz.categorical.inspire.G": {
    "value": "var(--dUBEWn)",
    "variable": "var(--dUBEWn)"
  },
  "colors.dataViz.categorical.inspire.H": {
    "value": "var(--OKyZM)",
    "variable": "var(--OKyZM)"
  },
  "colors.dataViz.categorical.trust.fg.onA": {
    "value": "var(--fvpyfe)",
    "variable": "var(--fvpyfe)"
  },
  "colors.dataViz.categorical.trust.fg.onB": {
    "value": "var(--caUkeB)",
    "variable": "var(--caUkeB)"
  },
  "colors.dataViz.categorical.trust.fg.onC": {
    "value": "var(--hmnZUc)",
    "variable": "var(--hmnZUc)"
  },
  "colors.dataViz.categorical.trust.fg.onD": {
    "value": "var(--YedFr)",
    "variable": "var(--YedFr)"
  },
  "colors.dataViz.categorical.trust.fg.onE": {
    "value": "var(--iUsJSS)",
    "variable": "var(--iUsJSS)"
  },
  "colors.dataViz.categorical.trust.fg.onF": {
    "value": "var(--fzXvSp)",
    "variable": "var(--fzXvSp)"
  },
  "colors.dataViz.categorical.trust.fg.onG": {
    "value": "var(--kLrlHQ)",
    "variable": "var(--kLrlHQ)"
  },
  "colors.dataViz.categorical.trust.fg.onH": {
    "value": "var(--brZgjn)",
    "variable": "var(--brZgjn)"
  },
  "colors.dataViz.categorical.trust.fg.onA-hero": {
    "value": "var(--difhCv)",
    "variable": "var(--difhCv)"
  },
  "colors.dataViz.categorical.trust.fg.onB-hero": {
    "value": "var(--fueZPY)",
    "variable": "var(--fueZPY)"
  },
  "colors.dataViz.categorical.trust.fg.onC-hero": {
    "value": "var(--fsRWkV)",
    "variable": "var(--fsRWkV)"
  },
  "colors.dataViz.categorical.trust.fg.onD-hero": {
    "value": "var(--kZKISG)",
    "variable": "var(--kZKISG)"
  },
  "colors.dataViz.categorical.trust.fg.onE-hero": {
    "value": "var(--kYxFnD)",
    "variable": "var(--kYxFnD)"
  },
  "colors.dataViz.categorical.trust.fg.onF-hero": {
    "value": "var(--bVbOck)",
    "variable": "var(--bVbOck)"
  },
  "colors.dataViz.categorical.trust.fg.onG-hero": {
    "value": "var(--bTOKxh)",
    "variable": "var(--bTOKxh)"
  },
  "colors.dataViz.categorical.trust.fg.onH-hero": {
    "value": "var(--kFPGoK)",
    "variable": "var(--kFPGoK)"
  },
  "colors.dataViz.categorical.trust.A": {
    "value": "var(--hALhPb)",
    "variable": "var(--hALhPb)"
  },
  "colors.dataViz.categorical.trust.B": {
    "value": "var(--ipADXI)",
    "variable": "var(--ipADXI)"
  },
  "colors.dataViz.categorical.trust.C": {
    "value": "var(--eSHSnJ)",
    "variable": "var(--eSHSnJ)"
  },
  "colors.dataViz.categorical.trust.D": {
    "value": "var(--eXPlCa)",
    "variable": "var(--eXPlCa)"
  },
  "colors.dataViz.categorical.trust.E": {
    "value": "var(--kZkYUj)",
    "variable": "var(--kZkYUj)"
  },
  "colors.dataViz.categorical.trust.F": {
    "value": "var(--yELDU)",
    "variable": "var(--yELDU)"
  },
  "colors.dataViz.categorical.trust.G": {
    "value": "var(--irhJsR)",
    "variable": "var(--irhJsR)"
  },
  "colors.dataViz.categorical.trust.H": {
    "value": "var(--ccCmeC)",
    "variable": "var(--ccCmeC)"
  },
  "colors.dataViz.divergent.brand.fg.onA": {
    "value": "var(--cNyRuD)",
    "variable": "var(--cNyRuD)"
  },
  "colors.dataViz.divergent.brand.fg.onB": {
    "value": "var(--fdwqhY)",
    "variable": "var(--fdwqhY)"
  },
  "colors.dataViz.divergent.brand.fg.onC": {
    "value": "var(--jYPpYh)",
    "variable": "var(--jYPpYh)"
  },
  "colors.dataViz.divergent.brand.fg.onD": {
    "value": "var(--eqrxZm)",
    "variable": "var(--eqrxZm)"
  },
  "colors.dataViz.divergent.brand.fg.onE": {
    "value": "var(--chMajf)",
    "variable": "var(--chMajf)"
  },
  "colors.dataViz.divergent.brand.fg.onF": {
    "value": "var(--exJyWA)",
    "variable": "var(--exJyWA)"
  },
  "colors.dataViz.divergent.brand.fg.onG": {
    "value": "var(--jtcyMJ)",
    "variable": "var(--jtcyMJ)"
  },
  "colors.dataViz.divergent.brand.fg.onH": {
    "value": "var(--bLtEjG)",
    "variable": "var(--bLtEjG)"
  },
  "colors.dataViz.divergent.brand.fg.onI": {
    "value": "var(--kSjPSv)",
    "variable": "var(--kSjPSv)"
  },
  "colors.dataViz.divergent.brand.fg.onJ": {
    "value": "var(--bSLFgU)",
    "variable": "var(--bSLFgU)"
  },
  "colors.dataViz.divergent.brand.fg.onK": {
    "value": "var(--gOeEXd)",
    "variable": "var(--gOeEXd)"
  },
  "colors.dataViz.divergent.brand.fg.onA-hero": {
    "value": "var(--kKWIxu)",
    "variable": "var(--kKWIxu)"
  },
  "colors.dataViz.divergent.brand.fg.onB-hero": {
    "value": "var(--gbqvAl)",
    "variable": "var(--gbqvAl)"
  },
  "colors.dataViz.divergent.brand.fg.onC-hero": {
    "value": "var(--hKWaFw)",
    "variable": "var(--hKWaFw)"
  },
  "colors.dataViz.divergent.brand.fg.onD-hero": {
    "value": "var(--jHdUDH)",
    "variable": "var(--jHdUDH)"
  },
  "colors.dataViz.divergent.brand.fg.onE-hero": {
    "value": "var(--bnQjW)",
    "variable": "var(--bnQjW)"
  },
  "colors.dataViz.divergent.brand.fg.onF-hero": {
    "value": "var(--gHdmLJ)",
    "variable": "var(--gHdmLJ)"
  },
  "colors.dataViz.divergent.brand.fg.onG-hero": {
    "value": "var(--iqIRQU)",
    "variable": "var(--iqIRQU)"
  },
  "colors.dataViz.divergent.brand.fg.onH-hero": {
    "value": "var(--WGeUr)",
    "variable": "var(--WGeUr)"
  },
  "colors.dataViz.divergent.brand.fg.onI-hero": {
    "value": "var(--cGlJZC)",
    "variable": "var(--cGlJZC)"
  },
  "colors.dataViz.divergent.brand.fg.onJ-hero": {
    "value": "var(--jmbgBp)",
    "variable": "var(--jmbgBp)"
  },
  "colors.dataViz.divergent.brand.fg.onK-hero": {
    "value": "var(--kVGLGA)",
    "variable": "var(--kVGLGA)"
  },
  "colors.dataViz.divergent.brand.A": {
    "value": "var(--UwtWG)",
    "variable": "var(--UwtWG)"
  },
  "colors.dataViz.divergent.brand.B": {
    "value": "var(--fGauit)",
    "variable": "var(--fGauit)"
  },
  "colors.dataViz.divergent.brand.C": {
    "value": "var(--kfJAvU)",
    "variable": "var(--kfJAvU)"
  },
  "colors.dataViz.divergent.brand.D": {
    "value": "var(--hozbHX)",
    "variable": "var(--hozbHX)"
  },
  "colors.dataViz.divergent.brand.E": {
    "value": "var(--eJbALW)",
    "variable": "var(--eJbALW)"
  },
  "colors.dataViz.divergent.brand.F": {
    "value": "var(--juFAXJ)",
    "variable": "var(--juFAXJ)"
  },
  "colors.dataViz.divergent.brand.G": {
    "value": "var(--cESXMo)",
    "variable": "var(--cESXMo)"
  },
  "colors.dataViz.divergent.brand.H": {
    "value": "var(--dpruiz)",
    "variable": "var(--dpruiz)"
  },
  "colors.dataViz.divergent.brand.I": {
    "value": "var(--JTTmy)",
    "variable": "var(--JTTmy)"
  },
  "colors.dataViz.divergent.brand.J": {
    "value": "var(--fvxTyl)",
    "variable": "var(--fvxTyl)"
  },
  "colors.dataViz.divergent.brand.K": {
    "value": "var(--jVgZLM)",
    "variable": "var(--jVgZLM)"
  },
  "colors.dataViz.divergent.insight.fg.onA": {
    "value": "var(--kFYrCa)",
    "variable": "var(--kFYrCa)"
  },
  "colors.dataViz.divergent.insight.fg.onB": {
    "value": "var(--kHYFhN)",
    "variable": "var(--kHYFhN)"
  },
  "colors.dataViz.divergent.insight.fg.onC": {
    "value": "var(--dUbULE)",
    "variable": "var(--dUbULE)"
  },
  "colors.dataViz.divergent.insight.fg.onD": {
    "value": "var(--jYMymv)",
    "variable": "var(--jYMymv)"
  },
  "colors.dataViz.divergent.insight.fg.onE": {
    "value": "var(--fHMIaK)",
    "variable": "var(--fHMIaK)"
  },
  "colors.dataViz.divergent.insight.fg.onF": {
    "value": "var(--fJMVGx)",
    "variable": "var(--fJMVGx)"
  },
  "colors.dataViz.divergent.insight.fg.onG": {
    "value": "var(--kllUJk)",
    "variable": "var(--kllUJk)"
  },
  "colors.dataViz.divergent.insight.fg.onH": {
    "value": "var(--gBzHsr)",
    "variable": "var(--gBzHsr)"
  },
  "colors.dataViz.divergent.insight.fg.onI": {
    "value": "var(--ckzRgG)",
    "variable": "var(--ckzRgG)"
  },
  "colors.dataViz.divergent.insight.fg.onJ": {
    "value": "var(--cmAeMt)",
    "variable": "var(--cmAeMt)"
  },
  "colors.dataViz.divergent.insight.fg.onK": {
    "value": "var(--gNZdPg)",
    "variable": "var(--gNZdPg)"
  },
  "colors.dataViz.divergent.insight.fg.onA-hero": {
    "value": "var(--DmKTz)",
    "variable": "var(--DmKTz)"
  },
  "colors.dataViz.divergent.insight.fg.onB-hero": {
    "value": "var(--fpGTqU)",
    "variable": "var(--fpGTqU)"
  },
  "colors.dataViz.divergent.insight.fg.onC-hero": {
    "value": "var(--krQRWp)",
    "variable": "var(--krQRWp)"
  },
  "colors.dataViz.divergent.insight.fg.onD-hero": {
    "value": "var(--zovPu)",
    "variable": "var(--zovPu)"
  },
  "colors.dataViz.divergent.insight.fg.onE-hero": {
    "value": "var(--fByuuP)",
    "variable": "var(--fByuuP)"
  },
  "colors.dataViz.divergent.insight.fg.onF-hero": {
    "value": "var(--knSCSk)",
    "variable": "var(--knSCSk)"
  },
  "colors.dataViz.divergent.insight.fg.onG-hero": {
    "value": "var(--eaGRYJ)",
    "variable": "var(--eaGRYJ)"
  },
  "colors.dataViz.divergent.insight.fg.onH-hero": {
    "value": "var(--dWBmJy)",
    "variable": "var(--dWBmJy)"
  },
  "colors.dataViz.divergent.insight.fg.onI-hero": {
    "value": "var(--iYLloT)",
    "variable": "var(--iYLloT)"
  },
  "colors.dataViz.divergent.insight.fg.onJ-hero": {
    "value": "var(--cvJKns)",
    "variable": "var(--cvJKns)"
  },
  "colors.dataViz.divergent.insight.fg.onK-hero": {
    "value": "var(--hxTISN)",
    "variable": "var(--hxTISN)"
  },
  "colors.dataViz.divergent.insight.A": {
    "value": "var(--emWNJb)",
    "variable": "var(--emWNJb)"
  },
  "colors.dataViz.divergent.insight.B": {
    "value": "var(--dNSKJs)",
    "variable": "var(--dNSKJs)"
  },
  "colors.dataViz.divergent.insight.C": {
    "value": "var(--fOSgWV)",
    "variable": "var(--fOSgWV)"
  },
  "colors.dataViz.divergent.insight.D": {
    "value": "var(--hSrwSy)",
    "variable": "var(--hSrwSy)"
  },
  "colors.dataViz.divergent.insight.E": {
    "value": "var(--eTpQEr)",
    "variable": "var(--eTpQEr)"
  },
  "colors.dataViz.divergent.insight.F": {
    "value": "var(--eulNEI)",
    "variable": "var(--eulNEI)"
  },
  "colors.dataViz.divergent.insight.G": {
    "value": "var(--gvljSl)",
    "variable": "var(--gvljSl)"
  },
  "colors.dataViz.divergent.insight.H": {
    "value": "var(--iOmqTa)",
    "variable": "var(--iOmqTa)"
  },
  "colors.dataViz.divergent.insight.I": {
    "value": "var(--fPkKET)",
    "variable": "var(--fPkKET)"
  },
  "colors.dataViz.divergent.insight.J": {
    "value": "var(--fqgHFk)",
    "variable": "var(--fqgHFk)"
  },
  "colors.dataViz.divergent.insight.K": {
    "value": "var(--hrgdSN)",
    "variable": "var(--hrgdSN)"
  },
  "colors.dataViz.divergent.inspire.fg.onA": {
    "value": "var(--dQChNG)",
    "variable": "var(--dQChNG)"
  },
  "colors.dataViz.divergent.inspire.fg.onB": {
    "value": "var(--fLMgEh)",
    "variable": "var(--fLMgEh)"
  },
  "colors.dataViz.divergent.inspire.fg.onC": {
    "value": "var(--dKhQps)",
    "variable": "var(--dKhQps)"
  },
  "colors.dataViz.divergent.inspire.fg.onD": {
    "value": "var(--kPQaNn)",
    "variable": "var(--kPQaNn)"
  },
  "colors.dataViz.divergent.inspire.fg.onE": {
    "value": "var(--cBFChm)",
    "variable": "var(--cBFChm)"
  },
  "colors.dataViz.divergent.inspire.fg.onF": {
    "value": "var(--ewPAXN)",
    "variable": "var(--ewPAXN)"
  },
  "colors.dataViz.divergent.inspire.fg.onG": {
    "value": "var(--cvlkIY)",
    "variable": "var(--cvlkIY)"
  },
  "colors.dataViz.divergent.inspire.fg.onH": {
    "value": "var(--cBffKv)",
    "variable": "var(--cBffKv)"
  },
  "colors.dataViz.divergent.inspire.fg.onI": {
    "value": "var(--fCqqDq)",
    "variable": "var(--fCqqDq)"
  },
  "colors.dataViz.divergent.inspire.fg.onJ": {
    "value": "var(--hxAptR)",
    "variable": "var(--hxAptR)"
  },
  "colors.dataViz.divergent.inspire.fg.onK": {
    "value": "var(--fvVZfc)",
    "variable": "var(--fvVZfc)"
  },
  "colors.dataViz.divergent.inspire.fg.onA-hero": {
    "value": "var(--bhMwgP)",
    "variable": "var(--bhMwgP)"
  },
  "colors.dataViz.divergent.inspire.fg.onB-hero": {
    "value": "var(--dqqtmI)",
    "variable": "var(--dqqtmI)"
  },
  "colors.dataViz.divergent.inspire.fg.onC-hero": {
    "value": "var(--ZJihx)",
    "variable": "var(--ZJihx)"
  },
  "colors.dataViz.divergent.inspire.fg.onD-hero": {
    "value": "var(--eNqmSu)",
    "variable": "var(--eNqmSu)"
  },
  "colors.dataViz.divergent.inspire.fg.onE-hero": {
    "value": "var(--cwJbNj)",
    "variable": "var(--cwJbNj)"
  },
  "colors.dataViz.divergent.inspire.fg.onF-hero": {
    "value": "var(--eFmYTc)",
    "variable": "var(--eFmYTc)"
  },
  "colors.dataViz.divergent.inspire.fg.onG-hero": {
    "value": "var(--coFNNR)",
    "variable": "var(--coFNNR)"
  },
  "colors.dataViz.divergent.inspire.fg.onH-hero": {
    "value": "var(--bMFywq)",
    "variable": "var(--bMFywq)"
  },
  "colors.dataViz.divergent.inspire.fg.onI-hero": {
    "value": "var(--kLtWQb)",
    "variable": "var(--kLtWQb)"
  },
  "colors.dataViz.divergent.inspire.fg.onJ-hero": {
    "value": "var(--bECkwY)",
    "variable": "var(--bECkwY)"
  },
  "colors.dataViz.divergent.inspire.fg.onK-hero": {
    "value": "var(--kDqIQJ)",
    "variable": "var(--kDqIQJ)"
  },
  "colors.dataViz.divergent.inspire.A": {
    "value": "var(--dVRpWb)",
    "variable": "var(--dVRpWb)"
  },
  "colors.dataViz.divergent.inspire.B": {
    "value": "var(--blfBrU)",
    "variable": "var(--blfBrU)"
  },
  "colors.dataViz.divergent.inspire.C": {
    "value": "var(--dqTPPp)",
    "variable": "var(--dqTPPp)"
  },
  "colors.dataViz.divergent.inspire.D": {
    "value": "var(--hStiQm)",
    "variable": "var(--hStiQm)"
  },
  "colors.dataViz.divergent.inspire.E": {
    "value": "var(--SVoWv)",
    "variable": "var(--SVoWv)"
  },
  "colors.dataViz.divergent.inspire.F": {
    "value": "var(--jxFjRk)",
    "variable": "var(--jxFjRk)"
  },
  "colors.dataViz.divergent.inspire.G": {
    "value": "var(--nXOPJ)",
    "variable": "var(--nXOPJ)"
  },
  "colors.dataViz.divergent.inspire.H": {
    "value": "var(--cqqxAG)",
    "variable": "var(--cqqxAG)"
  },
  "colors.dataViz.divergent.inspire.I": {
    "value": "var(--gGonfL)",
    "variable": "var(--gGonfL)"
  },
  "colors.dataViz.divergent.inspire.J": {
    "value": "var(--dVCyBE)",
    "variable": "var(--dVCyBE)"
  },
  "colors.dataViz.divergent.inspire.K": {
    "value": "var(--gbqMYZ)",
    "variable": "var(--gbqMYZ)"
  },
  "colors.dataViz.sequential.brand.fg.onA": {
    "value": "var(--dIAcPm)",
    "variable": "var(--dIAcPm)"
  },
  "colors.dataViz.sequential.brand.fg.onB": {
    "value": "var(--ceIbsR)",
    "variable": "var(--ceIbsR)"
  },
  "colors.dataViz.sequential.brand.fg.onC": {
    "value": "var(--foaZVg)",
    "variable": "var(--foaZVg)"
  },
  "colors.dataViz.sequential.brand.fg.onD": {
    "value": "var(--xLzMD)",
    "variable": "var(--xLzMD)"
  },
  "colors.dataViz.sequential.brand.fg.onE": {
    "value": "var(--bLrrVO)",
    "variable": "var(--bLrrVO)"
  },
  "colors.dataViz.sequential.brand.fg.onF": {
    "value": "var(--hzqzt)",
    "variable": "var(--hzqzt)"
  },
  "colors.dataViz.sequential.brand.fg.onG": {
    "value": "var(--dqSpbI)",
    "variable": "var(--dqSpbI)"
  },
  "colors.dataViz.sequential.brand.fg.onH": {
    "value": "var(--itzYln)",
    "variable": "var(--itzYln)"
  },
  "colors.dataViz.sequential.brand.fg.onI": {
    "value": "var(--jHfQuy)",
    "variable": "var(--jHfQuy)"
  },
  "colors.dataViz.sequential.brand.fg.onJ": {
    "value": "var(--idnOYd)",
    "variable": "var(--idnOYd)"
  },
  "colors.dataViz.sequential.brand.fg.onA-hero": {
    "value": "var(--joMgwf)",
    "variable": "var(--joMgwf)"
  },
  "colors.dataViz.sequential.brand.fg.onB-hero": {
    "value": "var(--dcmNQg)",
    "variable": "var(--dcmNQg)"
  },
  "colors.dataViz.sequential.brand.fg.onC-hero": {
    "value": "var(--lpoGup)",
    "variable": "var(--lpoGup)"
  },
  "colors.dataViz.sequential.brand.fg.onD-hero": {
    "value": "var(--yilhC)",
    "variable": "var(--yilhC)"
  },
  "colors.dataViz.sequential.brand.fg.onE-hero": {
    "value": "var(--llURpD)",
    "variable": "var(--llURpD)"
  },
  "colors.dataViz.sequential.brand.fg.onF-hero": {
    "value": "var(--eZvyJE)",
    "variable": "var(--eZvyJE)"
  },
  "colors.dataViz.sequential.brand.fg.onG-hero": {
    "value": "var(--bXbHOR)",
    "variable": "var(--bXbHOR)"
  },
  "colors.dataViz.sequential.brand.fg.onH-hero": {
    "value": "var(--dRPwhO)",
    "variable": "var(--dRPwhO)"
  },
  "colors.dataViz.sequential.brand.fg.onI-hero": {
    "value": "var(--dqgsQT)",
    "variable": "var(--dqgsQT)"
  },
  "colors.dataViz.sequential.brand.fg.onJ-hero": {
    "value": "var(--itcJJQ)",
    "variable": "var(--itcJJQ)"
  },
  "colors.dataViz.sequential.brand.A": {
    "value": "var(--kGiSRX)",
    "variable": "var(--kGiSRX)"
  },
  "colors.dataViz.sequential.brand.B": {
    "value": "var(--dkNSaU)",
    "variable": "var(--dkNSaU)"
  },
  "colors.dataViz.sequential.brand.C": {
    "value": "var(--gkTIvl)",
    "variable": "var(--gkTIvl)"
  },
  "colors.dataViz.sequential.brand.D": {
    "value": "var(--jzVatm)",
    "variable": "var(--jzVatm)"
  },
  "colors.dataViz.sequential.brand.E": {
    "value": "var(--eloGTf)",
    "variable": "var(--eloGTf)"
  },
  "colors.dataViz.sequential.brand.F": {
    "value": "var(--ifppAY)",
    "variable": "var(--ifppAY)"
  },
  "colors.dataViz.sequential.brand.G": {
    "value": "var(--lfvfVp)",
    "variable": "var(--lfvfVp)"
  },
  "colors.dataViz.sequential.brand.H": {
    "value": "var(--kuXSVy)",
    "variable": "var(--kuXSVy)"
  },
  "colors.dataViz.sequential.brand.I": {
    "value": "var(--fgrzvr)",
    "variable": "var(--fgrzvr)"
  },
  "colors.dataViz.sequential.brand.J": {
    "value": "var(--jasidk)",
    "variable": "var(--jasidk)"
  },
  "colors.dataViz.sequential.insight.fg.onA": {
    "value": "var(--cnYKYv)",
    "variable": "var(--cnYKYv)"
  },
  "colors.dataViz.sequential.insight.fg.onB": {
    "value": "var(--gOjLDQ)",
    "variable": "var(--gOjLDQ)"
  },
  "colors.dataViz.sequential.insight.fg.onC": {
    "value": "var(--hKcZrB)",
    "variable": "var(--hKcZrB)"
  },
  "colors.dataViz.sequential.insight.fg.onD": {
    "value": "var(--eioaPe)",
    "variable": "var(--eioaPe)"
  },
  "colors.dataViz.sequential.insight.fg.onE": {
    "value": "var(--WNsVn)",
    "variable": "var(--WNsVn)"
  },
  "colors.dataViz.sequential.insight.fg.onF": {
    "value": "var(--fwYtAI)",
    "variable": "var(--fwYtAI)"
  },
  "colors.dataViz.sequential.insight.fg.onG": {
    "value": "var(--gsRHot)",
    "variable": "var(--gsRHot)"
  },
  "colors.dataViz.sequential.insight.fg.onH": {
    "value": "var(--jkCpi)",
    "variable": "var(--jkCpi)"
  },
  "colors.dataViz.sequential.insight.fg.onI": {
    "value": "var(--infDUn)",
    "variable": "var(--infDUn)"
  },
  "colors.dataViz.sequential.insight.fg.onJ": {
    "value": "var(--bxUVaM)",
    "variable": "var(--bxUVaM)"
  },
  "colors.dataViz.sequential.insight.fg.onA-hero": {
    "value": "var(--fyhzpe)",
    "variable": "var(--fyhzpe)"
  },
  "colors.dataViz.sequential.insight.fg.onB-hero": {
    "value": "var(--jCJyPV)",
    "variable": "var(--jCJyPV)"
  },
  "colors.dataViz.sequential.insight.fg.onC-hero": {
    "value": "var(--gHzEKY)",
    "variable": "var(--gHzEKY)"
  },
  "colors.dataViz.sequential.insight.fg.onD-hero": {
    "value": "var(--hjRXTr)",
    "variable": "var(--hjRXTr)"
  },
  "colors.dataViz.sequential.insight.fg.onE-hero": {
    "value": "var(--gPsRsm)",
    "variable": "var(--gPsRsm)"
  },
  "colors.dataViz.sequential.insight.fg.onF-hero": {
    "value": "var(--kTUQTd)",
    "variable": "var(--kTUQTd)"
  },
  "colors.dataViz.sequential.insight.fg.onG-hero": {
    "value": "var(--hYKWOg)",
    "variable": "var(--hYKWOg)"
  },
  "colors.dataViz.sequential.insight.fg.onH-hero": {
    "value": "var(--liVwtn)",
    "variable": "var(--liVwtn)"
  },
  "colors.dataViz.sequential.insight.fg.onI-hero": {
    "value": "var(--kOwpSi)",
    "variable": "var(--kOwpSi)"
  },
  "colors.dataViz.sequential.insight.fg.onJ-hero": {
    "value": "var(--dDCFUd)",
    "variable": "var(--dDCFUd)"
  },
  "colors.dataViz.sequential.insight.A": {
    "value": "var(--ivhYPC)",
    "variable": "var(--ivhYPC)"
  },
  "colors.dataViz.sequential.insight.B": {
    "value": "var(--laumlx)",
    "variable": "var(--laumlx)"
  },
  "colors.dataViz.sequential.insight.C": {
    "value": "var(--gcQGlw)",
    "variable": "var(--gcQGlw)"
  },
  "colors.dataViz.sequential.insight.D": {
    "value": "var(--fpEOGv)",
    "variable": "var(--fpEOGv)"
  },
  "colors.dataViz.sequential.insight.E": {
    "value": "var(--bYcQpO)",
    "variable": "var(--bYcQpO)"
  },
  "colors.dataViz.sequential.insight.F": {
    "value": "var(--eDpdLJ)",
    "variable": "var(--eDpdLJ)"
  },
  "colors.dataViz.sequential.insight.G": {
    "value": "var(--kVhhkE)",
    "variable": "var(--kVhhkE)"
  },
  "colors.dataViz.sequential.insight.H": {
    "value": "var(--fakaEb)",
    "variable": "var(--fakaEb)"
  },
  "colors.dataViz.sequential.insight.I": {
    "value": "var(--bIIcnu)",
    "variable": "var(--bIIcnu)"
  },
  "colors.dataViz.sequential.insight.J": {
    "value": "var(--enUpJp)",
    "variable": "var(--enUpJp)"
  },
  "colors.dataViz.sequential.inspire.fg.onA": {
    "value": "var(--jQIUbT)",
    "variable": "var(--jQIUbT)"
  },
  "colors.dataViz.sequential.inspire.fg.onB": {
    "value": "var(--bgVNvU)",
    "variable": "var(--bgVNvU)"
  },
  "colors.dataViz.sequential.inspire.fg.onC": {
    "value": "var(--ffYHjF)",
    "variable": "var(--ffYHjF)"
  },
  "colors.dataViz.sequential.inspire.fg.onD": {
    "value": "var(--hTxuK)",
    "variable": "var(--hTxuK)"
  },
  "colors.dataViz.sequential.inspire.fg.onE": {
    "value": "var(--ihgURP)",
    "variable": "var(--ihgURP)"
  },
  "colors.dataViz.sequential.inspire.fg.onF": {
    "value": "var(--kMPxKM)",
    "variable": "var(--kMPxKM)"
  },
  "colors.dataViz.sequential.inspire.fg.onG": {
    "value": "var(--dwwHZB)",
    "variable": "var(--dwwHZB)"
  },
  "colors.dataViz.sequential.inspire.fg.onH": {
    "value": "var(--bgDchC)",
    "variable": "var(--bgDchC)"
  },
  "colors.dataViz.sequential.inspire.fg.onI": {
    "value": "var(--jfQzEH)",
    "variable": "var(--jfQzEH)"
  },
  "colors.dataViz.sequential.inspire.fg.onJ": {
    "value": "var(--wdsYI)",
    "variable": "var(--wdsYI)"
  },
  "colors.dataViz.sequential.inspire.fg.onA-hero": {
    "value": "var(--eXEVLO)",
    "variable": "var(--eXEVLO)"
  },
  "colors.dataViz.sequential.inspire.fg.onB-hero": {
    "value": "var(--gIlZZ)",
    "variable": "var(--gIlZZ)"
  },
  "colors.dataViz.sequential.inspire.fg.onC-hero": {
    "value": "var(--zrLCE)",
    "variable": "var(--zrLCE)"
  },
  "colors.dataViz.sequential.inspire.fg.onD-hero": {
    "value": "var(--fsOZdT)",
    "variable": "var(--fsOZdT)"
  },
  "colors.dataViz.sequential.inspire.fg.onE-hero": {
    "value": "var(--gHgUVS)",
    "variable": "var(--gHgUVS)"
  },
  "colors.dataViz.sequential.inspire.fg.onF-hero": {
    "value": "var(--bQklkd)",
    "variable": "var(--bQklkd)"
  },
  "colors.dataViz.sequential.inspire.fg.onG-hero": {
    "value": "var(--ciTKMI)",
    "variable": "var(--ciTKMI)"
  },
  "colors.dataViz.sequential.inspire.fg.onH-hero": {
    "value": "var(--eufurb)",
    "variable": "var(--eufurb)"
  },
  "colors.dataViz.sequential.inspire.fg.onI-hero": {
    "value": "var(--fIxqja)",
    "variable": "var(--fIxqja)"
  },
  "colors.dataViz.sequential.inspire.fg.onJ-hero": {
    "value": "var(--RAGxl)",
    "variable": "var(--RAGxl)"
  },
  "colors.dataViz.sequential.inspire.A": {
    "value": "var(--jajRBa)",
    "variable": "var(--jajRBa)"
  },
  "colors.dataViz.sequential.inspire.B": {
    "value": "var(--eWufrR)",
    "variable": "var(--eWufrR)"
  },
  "colors.dataViz.sequential.inspire.C": {
    "value": "var(--NlWTk)",
    "variable": "var(--NlWTk)"
  },
  "colors.dataViz.sequential.inspire.D": {
    "value": "var(--csUgcH)",
    "variable": "var(--csUgcH)"
  },
  "colors.dataViz.sequential.inspire.E": {
    "value": "var(--cVvqii)",
    "variable": "var(--cVvqii)"
  },
  "colors.dataViz.sequential.inspire.F": {
    "value": "var(--khbnxV)",
    "variable": "var(--khbnxV)"
  },
  "colors.dataViz.sequential.inspire.G": {
    "value": "var(--fXTeZo)",
    "variable": "var(--fXTeZo)"
  },
  "colors.dataViz.sequential.inspire.H": {
    "value": "var(--ivhYmv)",
    "variable": "var(--ivhYmv)"
  },
  "colors.dataViz.sequential.inspire.I": {
    "value": "var(--iXJirW)",
    "variable": "var(--iXJirW)"
  },
  "colors.dataViz.sequential.inspire.J": {
    "value": "var(--eTTwiN)",
    "variable": "var(--eTTwiN)"
  },
  "colors.bg.accent.brand.hero": {
    "value": "var(--gDBYAt)",
    "variable": "var(--gDBYAt)"
  },
  "colors.bg.accent.brand.hero-fixed": {
    "value": "var(--dsaXGW)",
    "variable": "var(--dsaXGW)"
  },
  "colors.bg.accent.aqua.impact": {
    "value": "var(--lkGuVQ)",
    "variable": "var(--lkGuVQ)"
  },
  "colors.bg.accent.aqua.hero": {
    "value": "var(--dnncxy)",
    "variable": "var(--dnncxy)"
  },
  "colors.bg.accent.aqua.soft": {
    "value": "var(--fcFZWQ)",
    "variable": "var(--fcFZWQ)"
  },
  "colors.bg.accent.blue.impact": {
    "value": "var(--gPBAkK)",
    "variable": "var(--gPBAkK)"
  },
  "colors.bg.accent.blue.hero": {
    "value": "var(--kavidc)",
    "variable": "var(--kavidc)"
  },
  "colors.bg.accent.blue.soft": {
    "value": "var(--dfqUPS)",
    "variable": "var(--dfqUPS)"
  },
  "colors.bg.accent.gray.impact": {
    "value": "var(--kFXsVt)",
    "variable": "var(--kFXsVt)"
  },
  "colors.bg.accent.gray.hero": {
    "value": "var(--iRoujz)",
    "variable": "var(--iRoujz)"
  },
  "colors.bg.accent.gray.soft": {
    "value": "var(--kvAntN)",
    "variable": "var(--kvAntN)"
  },
  "colors.bg.accent.green.impact": {
    "value": "var(--stFxT)",
    "variable": "var(--stFxT)"
  },
  "colors.bg.accent.green.hero": {
    "value": "var(--JwkKR)",
    "variable": "var(--JwkKR)"
  },
  "colors.bg.accent.green.soft": {
    "value": "var(--eTgdAT)",
    "variable": "var(--eTgdAT)"
  },
  "colors.bg.accent.orange.impact": {
    "value": "var(--dlZzqY)",
    "variable": "var(--dlZzqY)"
  },
  "colors.bg.accent.orange.hero": {
    "value": "var(--ivYxzm)",
    "variable": "var(--ivYxzm)"
  },
  "colors.bg.accent.orange.soft": {
    "value": "var(--gdELHQ)",
    "variable": "var(--gdELHQ)"
  },
  "colors.bg.accent.purple.impact": {
    "value": "var(--cgfCyC)",
    "variable": "var(--cgfCyC)"
  },
  "colors.bg.accent.purple.hero": {
    "value": "var(--lkCvjk)",
    "variable": "var(--lkCvjk)"
  },
  "colors.bg.accent.purple.soft": {
    "value": "var(--bEFmea)",
    "variable": "var(--bEFmea)"
  },
  "colors.bg.accent.red.impact": {
    "value": "var(--grxhcP)",
    "variable": "var(--grxhcP)"
  },
  "colors.bg.accent.red.hero": {
    "value": "var(--hToBLF)",
    "variable": "var(--hToBLF)"
  },
  "colors.bg.accent.red.soft": {
    "value": "var(--jcFArz)",
    "variable": "var(--jcFArz)"
  },
  "colors.bg.accent.teal.impact": {
    "value": "var(--jDqrZI)",
    "variable": "var(--jDqrZI)"
  },
  "colors.bg.accent.teal.hero": {
    "value": "var(--bEdOXO)",
    "variable": "var(--bEdOXO)"
  },
  "colors.bg.accent.teal.soft": {
    "value": "var(--bzCNSc)",
    "variable": "var(--bzCNSc)"
  },
  "colors.bg.accent.yellow.impact": {
    "value": "var(--MasVk)",
    "variable": "var(--MasVk)"
  },
  "colors.bg.accent.yellow.hero": {
    "value": "var(--fLgwPW)",
    "variable": "var(--fLgwPW)"
  },
  "colors.bg.accent.yellow.soft": {
    "value": "var(--jagCMI)",
    "variable": "var(--jagCMI)"
  },
  "colors.bg.accent.yellow.soft-fixed": {
    "value": "var(--eTLBcP)",
    "variable": "var(--eTLBcP)"
  },
  "colors.bg.action.neutral.default": {
    "value": "var(--gCpeqo)",
    "variable": "var(--gCpeqo)"
  },
  "colors.bg.action.neutral.hover": {
    "value": "var(--euKceZ)",
    "variable": "var(--euKceZ)"
  },
  "colors.bg.action.neutral.pressed": {
    "value": "var(--kHimPp)",
    "variable": "var(--kHimPp)"
  },
  "colors.bg.action.neutral.selected.default": {
    "value": "var(--iCdqQI)",
    "variable": "var(--iCdqQI)"
  },
  "colors.bg.action.neutral.selected.hover": {
    "value": "var(--kNBsmx)",
    "variable": "var(--kNBsmx)"
  },
  "colors.bg.action.neutral.selected.pressed": {
    "value": "var(--daNAyN)",
    "variable": "var(--daNAyN)"
  },
  "colors.bg.action.neutral.alt.default": {
    "value": "var(--jaqcNU)",
    "variable": "var(--jaqcNU)"
  },
  "colors.bg.action.neutral.alt.hover": {
    "value": "var(--htSDcF)",
    "variable": "var(--htSDcF)"
  },
  "colors.bg.action.neutral.alt.pressed": {
    "value": "var(--hQFapl)",
    "variable": "var(--hQFapl)"
  },
  "colors.bg.action.neutral-fixed.default": {
    "value": "var(--iMmPfb)",
    "variable": "var(--iMmPfb)"
  },
  "colors.bg.action.neutral-fixed.hover": {
    "value": "var(--fccycq)",
    "variable": "var(--fccycq)"
  },
  "colors.bg.action.neutral-fixed.pressed": {
    "value": "var(--gPKDfK)",
    "variable": "var(--gPKDfK)"
  },
  "colors.bg.action.soft.default": {
    "value": "var(--fIeQrb)",
    "variable": "var(--fIeQrb)"
  },
  "colors.bg.action.soft.hover": {
    "value": "var(--iYEYga)",
    "variable": "var(--iYEYga)"
  },
  "colors.bg.action.soft.pressed": {
    "value": "var(--gFEzJS)",
    "variable": "var(--gFEzJS)"
  },
  "colors.bg.action.soft.selected.default": {
    "value": "var(--cGvlab)",
    "variable": "var(--cGvlab)"
  },
  "colors.bg.action.soft.selected.hover": {
    "value": "var(--kPNNlW)",
    "variable": "var(--kPNNlW)"
  },
  "colors.bg.action.soft.selected.pressed": {
    "value": "var(--boaiQu)",
    "variable": "var(--boaiQu)"
  },
  "colors.bg.action.hero.default": {
    "value": "var(--eBSYvh)",
    "variable": "var(--eBSYvh)"
  },
  "colors.bg.action.hero.hover": {
    "value": "var(--dZbANA)",
    "variable": "var(--dZbANA)"
  },
  "colors.bg.action.hero.pressed": {
    "value": "var(--bGbcrs)",
    "variable": "var(--bGbcrs)"
  },
  "colors.bg.action.hero.selected.default": {
    "value": "var(--iAEWsN)",
    "variable": "var(--iAEWsN)"
  },
  "colors.bg.action.hero.selected.hover": {
    "value": "var(--cnhQxw)",
    "variable": "var(--cnhQxw)"
  },
  "colors.bg.action.hero.selected.pressed": {
    "value": "var(--eaPVAQ)",
    "variable": "var(--eaPVAQ)"
  },
  "colors.bg.action.bare.neutral.default": {
    "value": "var(--fctnoV)",
    "variable": "var(--fctnoV)"
  },
  "colors.bg.action.bare.neutral.hover": {
    "value": "var(--jTivDM)",
    "variable": "var(--jTivDM)"
  },
  "colors.bg.action.bare.neutral.pressed": {
    "value": "var(--bKLPGk)",
    "variable": "var(--bKLPGk)"
  },
  "colors.bg.action.bare.neutral-fixed.default": {
    "value": "var(--hXIOdq)",
    "variable": "var(--hXIOdq)"
  },
  "colors.bg.action.bare.neutral-fixed.hover": {
    "value": "var(--ZieMP)",
    "variable": "var(--ZieMP)"
  },
  "colors.bg.action.bare.neutral-fixed.pressed": {
    "value": "var(--eFnnBv)",
    "variable": "var(--eFnnBv)"
  },
  "colors.bg.action.impact.neutral.default": {
    "value": "var(--kzOTWX)",
    "variable": "var(--kzOTWX)"
  },
  "colors.bg.action.impact.neutral.hover": {
    "value": "var(--jivfyC)",
    "variable": "var(--jivfyC)"
  },
  "colors.bg.action.impact.neutral.pressed": {
    "value": "var(--kRXVlG)",
    "variable": "var(--kRXVlG)"
  },
  "colors.bg.action.impact.soft.default": {
    "value": "var(--gFAQbM)",
    "variable": "var(--gFAQbM)"
  },
  "colors.bg.action.impact.soft.hover": {
    "value": "var(--fRgbwp)",
    "variable": "var(--fRgbwp)"
  },
  "colors.bg.action.impact.soft.pressed": {
    "value": "var(--gnSyIV)",
    "variable": "var(--gnSyIV)"
  },
  "colors.bg.action.impact.bare.default": {
    "value": "var(--jCDFWq)",
    "variable": "var(--jCDFWq)"
  },
  "colors.bg.action.impact.bare.hover": {
    "value": "var(--jjDyEv)",
    "variable": "var(--jjDyEv)"
  },
  "colors.bg.action.impact.bare.pressed": {
    "value": "var(--jGpVRb)",
    "variable": "var(--jGpVRb)"
  },
  "colors.bg.action.impact.bare.fixed.default": {
    "value": "var(--hnctYd)",
    "variable": "var(--hnctYd)"
  },
  "colors.bg.action.impact.bare.fixed.hover": {
    "value": "var(--kAjqUE)",
    "variable": "var(--kAjqUE)"
  },
  "colors.bg.action.impact.bare.fixed.pressed": {
    "value": "var(--dwdDnc)",
    "variable": "var(--dwdDnc)"
  },
  "colors.bg.action.critical.neutral.default": {
    "value": "var(--bEmNwG)",
    "variable": "var(--bEmNwG)"
  },
  "colors.bg.action.critical.neutral.hover": {
    "value": "var(--jyYqzX)",
    "variable": "var(--jyYqzX)"
  },
  "colors.bg.action.critical.neutral.pressed": {
    "value": "var(--bMkyMn)",
    "variable": "var(--bMkyMn)"
  },
  "colors.bg.action.critical.hero.default": {
    "value": "var(--fserrj)",
    "variable": "var(--fserrj)"
  },
  "colors.bg.action.critical.hero.hover": {
    "value": "var(--frMuLC)",
    "variable": "var(--frMuLC)"
  },
  "colors.bg.action.critical.hero.pressed": {
    "value": "var(--hfuzOW)",
    "variable": "var(--hfuzOW)"
  },
  "colors.bg.action.success.hero.default": {
    "value": "var(--eeUkOL)",
    "variable": "var(--eeUkOL)"
  },
  "colors.bg.action.success.hero.hover": {
    "value": "var(--dxqIMq)",
    "variable": "var(--dxqIMq)"
  },
  "colors.bg.action.success.hero.pressed": {
    "value": "var(--gEpMnK)",
    "variable": "var(--gEpMnK)"
  },
  "colors.bg.elevated.action.mediumShadow.default": {
    "value": "var(--khsNxh)",
    "variable": "var(--khsNxh)"
  },
  "colors.bg.elevated.action.mediumShadow.hover": {
    "value": "var(--iqGUcg)",
    "variable": "var(--iqGUcg)"
  },
  "colors.bg.elevated.action.mediumShadow.pressed": {
    "value": "var(--dksFAw)",
    "variable": "var(--dksFAw)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.default": {
    "value": "var(--hZNQdl)",
    "variable": "var(--hZNQdl)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.hover": {
    "value": "var(--jYRwDg)",
    "variable": "var(--jYRwDg)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.pressed": {
    "value": "var(--fQZeyQ)",
    "variable": "var(--fQZeyQ)"
  },
  "colors.bg.elevated.action.smallShadow.default": {
    "value": "var(--iUEoSr)",
    "variable": "var(--iUEoSr)"
  },
  "colors.bg.elevated.action.smallShadow.hover": {
    "value": "var(--jfcaWS)",
    "variable": "var(--jfcaWS)"
  },
  "colors.bg.elevated.action.smallShadow.pressed": {
    "value": "var(--fSNPmS)",
    "variable": "var(--fSNPmS)"
  },
  "colors.bg.elevated.action.smallShadow.selected.default": {
    "value": "var(--fmSlsT)",
    "variable": "var(--fmSlsT)"
  },
  "colors.bg.elevated.action.smallShadow.selected.hover": {
    "value": "var(--eAZgka)",
    "variable": "var(--eAZgka)"
  },
  "colors.bg.elevated.action.smallShadow.selected.pressed": {
    "value": "var(--hyHGIa)",
    "variable": "var(--hyHGIa)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.default": {
    "value": "var(--iVOWHo)",
    "variable": "var(--iVOWHo)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.hover": {
    "value": "var(--icbOLR)",
    "variable": "var(--icbOLR)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.pressed": {
    "value": "var(--iGdoxJ)",
    "variable": "var(--iGdoxJ)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.default": {
    "value": "var(--jfsvBA)",
    "variable": "var(--jfsvBA)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.hover": {
    "value": "var(--jjDRdF)",
    "variable": "var(--jjDRdF)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.pressed": {
    "value": "var(--MLSEt)",
    "variable": "var(--MLSEt)"
  },
  "colors.bg.elevated.sheet": {
    "value": "var(--uZSJM)",
    "variable": "var(--uZSJM)"
  },
  "colors.bg.elevated.mediumShadow": {
    "value": "var(--bUsszI)",
    "variable": "var(--bUsszI)"
  },
  "colors.bg.elevated.smallShadow": {
    "value": "var(--fbDFfG)",
    "variable": "var(--fbDFfG)"
  },
  "colors.bg.elevated.smallHeavyShadow": {
    "value": "var(--hShDcF)",
    "variable": "var(--hShDcF)"
  },
  "colors.bg.express.empower.impact": {
    "value": "var(--knzRmH)",
    "variable": "var(--knzRmH)"
  },
  "colors.bg.express.empower.hero": {
    "value": "var(--kfGjWd)",
    "variable": "var(--kfGjWd)"
  },
  "colors.bg.express.empower.soft": {
    "value": "var(--bqFisf)",
    "variable": "var(--bqFisf)"
  },
  "colors.bg.express.insight.impact": {
    "value": "var(--fGQKki)",
    "variable": "var(--fGQKki)"
  },
  "colors.bg.express.insight.hero": {
    "value": "var(--iWpLWY)",
    "variable": "var(--iWpLWY)"
  },
  "colors.bg.express.insight.soft": {
    "value": "var(--bGpRnO)",
    "variable": "var(--bGpRnO)"
  },
  "colors.bg.express.inspire.impact": {
    "value": "var(--jQitEK)",
    "variable": "var(--jQitEK)"
  },
  "colors.bg.express.inspire.hero": {
    "value": "var(--jMmLcg)",
    "variable": "var(--jMmLcg)"
  },
  "colors.bg.express.inspire.soft": {
    "value": "var(--muLci)",
    "variable": "var(--muLci)"
  },
  "colors.bg.express.trust.impact": {
    "value": "var(--hMjVIQ)",
    "variable": "var(--hMjVIQ)"
  },
  "colors.bg.express.trust.hero": {
    "value": "var(--iTUEsi)",
    "variable": "var(--iTUEsi)"
  },
  "colors.bg.express.trust.soft": {
    "value": "var(--kFmxVY)",
    "variable": "var(--kFmxVY)"
  },
  "colors.bg.feedback.critical.soft": {
    "value": "var(--jmFFQQ)",
    "variable": "var(--jmFFQQ)"
  },
  "colors.bg.feedback.critical.hero": {
    "value": "var(--fjjHVa)",
    "variable": "var(--fjjHVa)"
  },
  "colors.bg.feedback.critical.impact": {
    "value": "var(--KgkM)",
    "variable": "var(--KgkM)"
  },
  "colors.bg.feedback.info.soft": {
    "value": "var(--clPwKx)",
    "variable": "var(--clPwKx)"
  },
  "colors.bg.feedback.info.hero": {
    "value": "var(--hgBcBD)",
    "variable": "var(--hgBcBD)"
  },
  "colors.bg.feedback.info.impact": {
    "value": "var(--imCfjh)",
    "variable": "var(--imCfjh)"
  },
  "colors.bg.feedback.notify.impact": {
    "value": "var(--defGYE)",
    "variable": "var(--defGYE)"
  },
  "colors.bg.feedback.notify.hero": {
    "value": "var(--fJITIC)",
    "variable": "var(--fJITIC)"
  },
  "colors.bg.feedback.notify.hero-fixed": {
    "value": "var(--kOQPpZ)",
    "variable": "var(--kOQPpZ)"
  },
  "colors.bg.feedback.notify.soft": {
    "value": "var(--krkksI)",
    "variable": "var(--krkksI)"
  },
  "colors.bg.feedback.success.impact": {
    "value": "var(--caXmBQ)",
    "variable": "var(--caXmBQ)"
  },
  "colors.bg.feedback.success.hero": {
    "value": "var(--hzTwza)",
    "variable": "var(--hzTwza)"
  },
  "colors.bg.feedback.success.soft": {
    "value": "var(--chGNoc)",
    "variable": "var(--chGNoc)"
  },
  "colors.bg.feedback.warning.impact": {
    "value": "var(--dCuxpt)",
    "variable": "var(--dCuxpt)"
  },
  "colors.bg.feedback.warning.hero": {
    "value": "var(--eGOfbz)",
    "variable": "var(--eGOfbz)"
  },
  "colors.bg.feedback.warning.soft": {
    "value": "var(--inqYjV)",
    "variable": "var(--inqYjV)"
  },
  "colors.bg.invisible": {
    "value": "var(--lawEWN)",
    "variable": "var(--lawEWN)"
  },
  "colors.bg.impact": {
    "value": "var(--dUYSvi)",
    "variable": "var(--dUYSvi)"
  },
  "colors.bg.impact-fixed": {
    "value": "var(--bykxih)",
    "variable": "var(--bykxih)"
  },
  "colors.bg.impact-soft": {
    "value": "var(--pfyuF)",
    "variable": "var(--pfyuF)"
  },
  "colors.bg.impact-soft-fixed": {
    "value": "var(--fAfxbW)",
    "variable": "var(--fAfxbW)"
  },
  "colors.bg.impact-softer": {
    "value": "var(--ddWZne)",
    "variable": "var(--ddWZne)"
  },
  "colors.bg.impact-softest": {
    "value": "var(--eoTRNX)",
    "variable": "var(--eoTRNX)"
  },
  "colors.bg.neutral": {
    "value": "var(--euecPN)",
    "variable": "var(--euecPN)"
  },
  "colors.bg.neutral-fixed": {
    "value": "var(--kbSMSq)",
    "variable": "var(--kbSMSq)"
  },
  "colors.bg.soft": {
    "value": "var(--WbRFK)",
    "variable": "var(--WbRFK)"
  },
  "colors.bg.softer": {
    "value": "var(--lfQNoV)",
    "variable": "var(--lfQNoV)"
  },
  "colors.bg.softer-fixed": {
    "value": "var(--jWlrbO)",
    "variable": "var(--jWlrbO)"
  },
  "colors.bg.softest": {
    "value": "var(--dFJplw)",
    "variable": "var(--dFJplw)"
  },
  "colors.bg.softest-fixed": {
    "value": "var(--dLtdQb)",
    "variable": "var(--dLtdQb)"
  },
  "colors.bg.onElevated.softest": {
    "value": "var(--gCVIWa)",
    "variable": "var(--gCVIWa)"
  },
  "colors.bg.screen.neutral": {
    "value": "var(--dngnjw)",
    "variable": "var(--dngnjw)"
  },
  "colors.bg.screen.softest": {
    "value": "var(--keSXoB)",
    "variable": "var(--keSXoB)"
  },
  "colors.bg.screen.scrim": {
    "value": "var(--eAwCUX)",
    "variable": "var(--eAwCUX)"
  },
  "colors.bg.status.forSale.hero-fixed": {
    "value": "var(--eUGhSr)",
    "variable": "var(--eUGhSr)"
  },
  "colors.bg.status.forSale.hero-fixed-viewed": {
    "value": "var(--jvovwi)",
    "variable": "var(--jvovwi)"
  },
  "colors.bg.status.forSale.hero-fixed-selected": {
    "value": "var(--gvKVEn)",
    "variable": "var(--gvKVEn)"
  },
  "colors.bg.status.forRent.hero-fixed": {
    "value": "var(--gYCQaN)",
    "variable": "var(--gYCQaN)"
  },
  "colors.bg.status.forRent.hero-fixed-viewed": {
    "value": "var(--gclOuw)",
    "variable": "var(--gclOuw)"
  },
  "colors.bg.status.forRent.hero-fixed-selected": {
    "value": "var(--jXCVDp)",
    "variable": "var(--jXCVDp)"
  },
  "colors.bg.status.savedSearch.hero-fixed": {
    "value": "var(--eHoIqA)",
    "variable": "var(--eHoIqA)"
  },
  "colors.bg.status.savedSearch.hero-fixed-viewed": {
    "value": "var(--FWTwt)",
    "variable": "var(--FWTwt)"
  },
  "colors.bg.status.savedSearch.hero-fixed-selected": {
    "value": "var(--cnuLCE)",
    "variable": "var(--cnuLCE)"
  },
  "colors.bg.status.recentlySold.soft-fixed": {
    "value": "var(--jAdVav)",
    "variable": "var(--jAdVav)"
  },
  "colors.bg.status.recentlySold.soft-fixed-viewed": {
    "value": "var(--iWDKsC)",
    "variable": "var(--iWDKsC)"
  },
  "colors.bg.status.recentlySold.soft-fixed-selected": {
    "value": "var(--gQwFdv)",
    "variable": "var(--gQwFdv)"
  },
  "colors.bg.status.offMarket.hero-fixed": {
    "value": "var(--ktcSlE)",
    "variable": "var(--ktcSlE)"
  },
  "colors.bg.status.offMarket.hero-fixed-viewed": {
    "value": "var(--fDZPDh)",
    "variable": "var(--fDZPDh)"
  },
  "colors.bg.status.offMarket.hero-fixed-selected": {
    "value": "var(--iHSSZI)",
    "variable": "var(--iHSSZI)"
  },
  "colors.bg.status.zestimate.hero-fixed-selected": {
    "value": "var(--gWkTzv)",
    "variable": "var(--gWkTzv)"
  },
  "colors.bg.transparent.impact-fixed": {
    "value": "var(--bQxWIu)",
    "variable": "var(--bQxWIu)"
  },
  "colors.bg.transparent.impact-fixed-faint": {
    "value": "var(--eSOKiL)",
    "variable": "var(--eSOKiL)"
  },
  "colors.border.accent.brand.hero": {
    "value": "var(--entpEk)",
    "variable": "var(--entpEk)"
  },
  "colors.border.accent.brand.hero-fixed": {
    "value": "var(--hYTedn)",
    "variable": "var(--hYTedn)"
  },
  "colors.border.accent.aqua.strong": {
    "value": "var(--iyWRfA)",
    "variable": "var(--iyWRfA)"
  },
  "colors.border.accent.aqua.hero": {
    "value": "var(--kprtVr)",
    "variable": "var(--kprtVr)"
  },
  "colors.border.accent.blue.strong": {
    "value": "var(--cAWJGe)",
    "variable": "var(--cAWJGe)"
  },
  "colors.border.accent.blue.strong-fixed": {
    "value": "var(--gzxsZZ)",
    "variable": "var(--gzxsZZ)"
  },
  "colors.border.accent.blue.hero": {
    "value": "var(--kOqkNR)",
    "variable": "var(--kOqkNR)"
  },
  "colors.border.accent.gray.strong": {
    "value": "var(--QXvhl)",
    "variable": "var(--QXvhl)"
  },
  "colors.border.accent.gray.hero": {
    "value": "var(--bRvxSK)",
    "variable": "var(--bRvxSK)"
  },
  "colors.border.accent.green.strong": {
    "value": "var(--dzVYVL)",
    "variable": "var(--dzVYVL)"
  },
  "colors.border.accent.green.hero": {
    "value": "var(--pwSeI)",
    "variable": "var(--pwSeI)"
  },
  "colors.border.accent.orange.strong": {
    "value": "var(--gBmwfw)",
    "variable": "var(--gBmwfw)"
  },
  "colors.border.accent.orange.hero": {
    "value": "var(--bqlNiP)",
    "variable": "var(--bqlNiP)"
  },
  "colors.border.accent.purple.strong": {
    "value": "var(--kXTHme)",
    "variable": "var(--kXTHme)"
  },
  "colors.border.accent.purple.hero": {
    "value": "var(--ofHsp)",
    "variable": "var(--ofHsp)"
  },
  "colors.border.accent.red.strong": {
    "value": "var(--liuajf)",
    "variable": "var(--liuajf)"
  },
  "colors.border.accent.red.hero": {
    "value": "var(--eZFzkI)",
    "variable": "var(--eZFzkI)"
  },
  "colors.border.accent.teal.strong": {
    "value": "var(--dhuhdQ)",
    "variable": "var(--dhuhdQ)"
  },
  "colors.border.accent.teal.hero": {
    "value": "var(--fPCDWL)",
    "variable": "var(--fPCDWL)"
  },
  "colors.border.accent.yellow.strong": {
    "value": "var(--hYqfYw)",
    "variable": "var(--hYqfYw)"
  },
  "colors.border.accent.yellow.hero": {
    "value": "var(--tRymD)",
    "variable": "var(--tRymD)"
  },
  "colors.border.action.neutral.default": {
    "value": "var(--gMvPgF)",
    "variable": "var(--gMvPgF)"
  },
  "colors.border.action.neutral.hover": {
    "value": "var(--jFfgLM)",
    "variable": "var(--jFfgLM)"
  },
  "colors.border.action.neutral.pressed": {
    "value": "var(--kbRDYs)",
    "variable": "var(--kbRDYs)"
  },
  "colors.border.action.neutral-fixed.default": {
    "value": "var(--gplBby)",
    "variable": "var(--gplBby)"
  },
  "colors.border.action.neutral-fixed.hover": {
    "value": "var(--jxWVqH)",
    "variable": "var(--jxWVqH)"
  },
  "colors.border.action.neutral-fixed.pressed": {
    "value": "var(--ctRhJf)",
    "variable": "var(--ctRhJf)"
  },
  "colors.border.action.strong.default": {
    "value": "var(--ctRgCr)",
    "variable": "var(--ctRgCr)"
  },
  "colors.border.action.strong.hover": {
    "value": "var(--bCYtla)",
    "variable": "var(--bCYtla)"
  },
  "colors.border.action.strong.pressed": {
    "value": "var(--doIrvy)",
    "variable": "var(--doIrvy)"
  },
  "colors.border.action.hero.default": {
    "value": "var(--bfhuBg)",
    "variable": "var(--bfhuBg)"
  },
  "colors.border.action.hero.hover": {
    "value": "var(--ceVRjl)",
    "variable": "var(--ceVRjl)"
  },
  "colors.border.action.hero.pressed": {
    "value": "var(--eIOrEN)",
    "variable": "var(--eIOrEN)"
  },
  "colors.border.action.hero.selected.default": {
    "value": "var(--hpSeVA)",
    "variable": "var(--hpSeVA)"
  },
  "colors.border.action.hero.selected.hover": {
    "value": "var(--ISIId)",
    "variable": "var(--ISIId)"
  },
  "colors.border.action.hero.selected.pressed": {
    "value": "var(--eUiEzx)",
    "variable": "var(--eUiEzx)"
  },
  "colors.border.action.critical.strong.default": {
    "value": "var(--hFktpR)",
    "variable": "var(--hFktpR)"
  },
  "colors.border.action.critical.strong.hover": {
    "value": "var(--cHtOWk)",
    "variable": "var(--cHtOWk)"
  },
  "colors.border.action.critical.strong.pressed": {
    "value": "var(--jczBVo)",
    "variable": "var(--jczBVo)"
  },
  "colors.border.action.critical.hero.default": {
    "value": "var(--jNZtiu)",
    "variable": "var(--jNZtiu)"
  },
  "colors.border.action.critical.hero.hover": {
    "value": "var(--bFQgyj)",
    "variable": "var(--bFQgyj)"
  },
  "colors.border.action.critical.hero.pressed": {
    "value": "var(--fRgcpD)",
    "variable": "var(--fRgcpD)"
  },
  "colors.border.express.empower.strong": {
    "value": "var(--kvTyzL)",
    "variable": "var(--kvTyzL)"
  },
  "colors.border.express.empower.hero": {
    "value": "var(--eGrOHg)",
    "variable": "var(--eGrOHg)"
  },
  "colors.border.express.insight.strong": {
    "value": "var(--fUyxwa)",
    "variable": "var(--fUyxwa)"
  },
  "colors.border.express.insight.hero": {
    "value": "var(--bnMQMt)",
    "variable": "var(--bnMQMt)"
  },
  "colors.border.express.inspire.strong": {
    "value": "var(--eEqbOK)",
    "variable": "var(--eEqbOK)"
  },
  "colors.border.express.inspire.hero": {
    "value": "var(--fuubcF)",
    "variable": "var(--fuubcF)"
  },
  "colors.border.express.trust.strong": {
    "value": "var(--NifQI)",
    "variable": "var(--NifQI)"
  },
  "colors.border.express.trust.hero": {
    "value": "var(--kxCZYH)",
    "variable": "var(--kxCZYH)"
  },
  "colors.border.feedback.critical.strong": {
    "value": "var(--fNhnfI)",
    "variable": "var(--fNhnfI)"
  },
  "colors.border.feedback.critical.hero": {
    "value": "var(--hKUznb)",
    "variable": "var(--hKUznb)"
  },
  "colors.border.feedback.critical.hero-alt": {
    "value": "var(--bSLBar)",
    "variable": "var(--bSLBar)"
  },
  "colors.border.feedback.info.strong": {
    "value": "var(--hHkXzV)",
    "variable": "var(--hHkXzV)"
  },
  "colors.border.feedback.info.hero": {
    "value": "var(--hJHziG)",
    "variable": "var(--hJHziG)"
  },
  "colors.border.feedback.notify.strong": {
    "value": "var(--iSzGhs)",
    "variable": "var(--iSzGhs)"
  },
  "colors.border.feedback.notify.hero": {
    "value": "var(--yAgjj)",
    "variable": "var(--yAgjj)"
  },
  "colors.border.feedback.notify.hero-alt": {
    "value": "var(--gLuuiP)",
    "variable": "var(--gLuuiP)"
  },
  "colors.border.feedback.success.strong": {
    "value": "var(--loseyE)",
    "variable": "var(--loseyE)"
  },
  "colors.border.feedback.success.hero": {
    "value": "var(--jwnfpb)",
    "variable": "var(--jwnfpb)"
  },
  "colors.border.feedback.success.hero-alt": {
    "value": "var(--biprCP)",
    "variable": "var(--biprCP)"
  },
  "colors.border.feedback.warning.strong": {
    "value": "var(--liEMVR)",
    "variable": "var(--liEMVR)"
  },
  "colors.border.feedback.warning.hero": {
    "value": "var(--essVgm)",
    "variable": "var(--essVgm)"
  },
  "colors.border.invisible": {
    "value": "var(--kBABTA)",
    "variable": "var(--kBABTA)"
  },
  "colors.border.muted": {
    "value": "var(--hWIGgY)",
    "variable": "var(--hWIGgY)"
  },
  "colors.border.muted-alt": {
    "value": "var(--hLriMM)",
    "variable": "var(--hLriMM)"
  },
  "colors.border.neutral": {
    "value": "var(--jQCDo)",
    "variable": "var(--jQCDo)"
  },
  "colors.border.neutral-fixed": {
    "value": "var(--kKJPjL)",
    "variable": "var(--kKJPjL)"
  },
  "colors.border.subtle": {
    "value": "var(--jfPAjk)",
    "variable": "var(--jfPAjk)"
  },
  "colors.border.onHero.action.neutral.default": {
    "value": "var(--RBFdp)",
    "variable": "var(--RBFdp)"
  },
  "colors.border.onHero.action.neutral.hover": {
    "value": "var(--bViAso)",
    "variable": "var(--bViAso)"
  },
  "colors.border.onHero.action.neutral.pressed": {
    "value": "var(--fBnJgU)",
    "variable": "var(--fBnJgU)"
  },
  "colors.border.onHero.express.empower.hero": {
    "value": "var(--gGXYDI)",
    "variable": "var(--gGXYDI)"
  },
  "colors.border.onHero.express.insight.hero": {
    "value": "var(--eKqdjt)",
    "variable": "var(--eKqdjt)"
  },
  "colors.border.onHero.express.inspire.hero": {
    "value": "var(--kCVITN)",
    "variable": "var(--kCVITN)"
  },
  "colors.border.onHero.express.trust.hero": {
    "value": "var(--cmfRgD)",
    "variable": "var(--cmfRgD)"
  },
  "colors.border.onHero.neutral": {
    "value": "var(--eDnHZc)",
    "variable": "var(--eDnHZc)"
  },
  "colors.border.onHero.neutral-fixed": {
    "value": "var(--bfoauL)",
    "variable": "var(--bfoauL)"
  },
  "colors.border.onImpact.action.neutral.default": {
    "value": "var(--kXyzrf)",
    "variable": "var(--kXyzrf)"
  },
  "colors.border.onImpact.action.neutral.hover": {
    "value": "var(--iKiOGe)",
    "variable": "var(--iKiOGe)"
  },
  "colors.border.onImpact.action.neutral.pressed": {
    "value": "var(--fxUCWe)",
    "variable": "var(--fxUCWe)"
  },
  "colors.border.onImpact.action.hero.default": {
    "value": "var(--jlqQse)",
    "variable": "var(--jlqQse)"
  },
  "colors.border.onImpact.action.hero.hover": {
    "value": "var(--bpgCPn)",
    "variable": "var(--bpgCPn)"
  },
  "colors.border.onImpact.action.hero.pressed": {
    "value": "var(--fAwyGH)",
    "variable": "var(--fAwyGH)"
  },
  "colors.border.onImpact.action.critical.hero.default": {
    "value": "var(--loJQxE)",
    "variable": "var(--loJQxE)"
  },
  "colors.border.onImpact.action.critical.hero.hover": {
    "value": "var(--cvBzIV)",
    "variable": "var(--cvBzIV)"
  },
  "colors.border.onImpact.action.critical.hero.pressed": {
    "value": "var(--kjdhkV)",
    "variable": "var(--kjdhkV)"
  },
  "colors.border.onImpact.express.empower.hero": {
    "value": "var(--mKzEm)",
    "variable": "var(--mKzEm)"
  },
  "colors.border.onImpact.express.insight.hero": {
    "value": "var(--fLBwOf)",
    "variable": "var(--fLBwOf)"
  },
  "colors.border.onImpact.express.inspire.hero": {
    "value": "var(--tjKhn)",
    "variable": "var(--tjKhn)"
  },
  "colors.border.onImpact.express.trust.hero": {
    "value": "var(--gYUuPd)",
    "variable": "var(--gYUuPd)"
  },
  "colors.border.onImpact.feedback.critical.strong": {
    "value": "var(--eGWYFm)",
    "variable": "var(--eGWYFm)"
  },
  "colors.border.onImpact.feedback.critical.hero": {
    "value": "var(--iibPQd)",
    "variable": "var(--iibPQd)"
  },
  "colors.border.onImpact.feedback.critical.hero-alt": {
    "value": "var(--cRrGUx)",
    "variable": "var(--cRrGUx)"
  },
  "colors.border.onImpact.feedback.info.strong": {
    "value": "var(--fTzrWT)",
    "variable": "var(--fTzrWT)"
  },
  "colors.border.onImpact.feedback.info.hero": {
    "value": "var(--bdDAsw)",
    "variable": "var(--bdDAsw)"
  },
  "colors.border.onImpact.feedback.notify.strong": {
    "value": "var(--krjPGG)",
    "variable": "var(--krjPGG)"
  },
  "colors.border.onImpact.feedback.notify.hero": {
    "value": "var(--dfsssl)",
    "variable": "var(--dfsssl)"
  },
  "colors.border.onImpact.feedback.notify.hero-alt": {
    "value": "var(--kgbmEp)",
    "variable": "var(--kgbmEp)"
  },
  "colors.border.onImpact.feedback.success.strong": {
    "value": "var(--WzeKG)",
    "variable": "var(--WzeKG)"
  },
  "colors.border.onImpact.feedback.success.hero": {
    "value": "var(--dlMfUl)",
    "variable": "var(--dlMfUl)"
  },
  "colors.border.onImpact.feedback.success.hero-alt": {
    "value": "var(--iiLwLJ)",
    "variable": "var(--iiLwLJ)"
  },
  "colors.border.onImpact.feedback.warning.strong": {
    "value": "var(--kkgyhn)",
    "variable": "var(--kkgyhn)"
  },
  "colors.border.onImpact.feedback.warning.hero": {
    "value": "var(--denYxU)",
    "variable": "var(--denYxU)"
  },
  "colors.border.onImpact.neutral": {
    "value": "var(--idaNSC)",
    "variable": "var(--idaNSC)"
  },
  "colors.border.onImpact.neutral-fixed": {
    "value": "var(--bgwION)",
    "variable": "var(--bgwION)"
  },
  "colors.border.onImpact.subtle": {
    "value": "var(--kraPMO)",
    "variable": "var(--kraPMO)"
  },
  "colors.effect.elevation.sm": {
    "value": "var(--hlCWqO)",
    "variable": "var(--hlCWqO)"
  },
  "colors.effect.elevation.smHeavy": {
    "value": "var(--jiXVXh)",
    "variable": "var(--jiXVXh)"
  },
  "colors.effect.elevation.md": {
    "value": "var(--kGCNvR)",
    "variable": "var(--kGCNvR)"
  },
  "colors.effect.elevation.lg": {
    "value": "var(--escfUv)",
    "variable": "var(--escfUv)"
  },
  "colors.effect.elevation.invisible": {
    "value": "var(--eRFoKV)",
    "variable": "var(--eRFoKV)"
  },
  "colors.effect.elevation.focus-1": {
    "value": "var(--dmbpbc)",
    "variable": "var(--dmbpbc)"
  },
  "colors.effect.elevation.focus-2": {
    "value": "var(--Wiwvb)",
    "variable": "var(--Wiwvb)"
  },
  "colors.effect.elevation.focus-3": {
    "value": "var(--ivNzVi)",
    "variable": "var(--ivNzVi)"
  },
  "colors.icon.accent.brand.hero": {
    "value": "var(--JWxjX)",
    "variable": "var(--JWxjX)"
  },
  "colors.icon.accent.brand.hero-fixed": {
    "value": "var(--iYkOBs)",
    "variable": "var(--iYkOBs)"
  },
  "colors.icon.accent.aqua.strong": {
    "value": "var(--bOddUH)",
    "variable": "var(--bOddUH)"
  },
  "colors.icon.accent.aqua.hero": {
    "value": "var(--jTQoak)",
    "variable": "var(--jTQoak)"
  },
  "colors.icon.accent.blue.strong": {
    "value": "var(--grLsAR)",
    "variable": "var(--grLsAR)"
  },
  "colors.icon.accent.blue.strong-fixed": {
    "value": "var(--keUecG)",
    "variable": "var(--keUecG)"
  },
  "colors.icon.accent.blue.hero": {
    "value": "var(--XqODS)",
    "variable": "var(--XqODS)"
  },
  "colors.icon.accent.gray.strong": {
    "value": "var(--ecYupu)",
    "variable": "var(--ecYupu)"
  },
  "colors.icon.accent.gray.hero": {
    "value": "var(--ekAGth)",
    "variable": "var(--ekAGth)"
  },
  "colors.icon.accent.green.strong": {
    "value": "var(--ksyHyg)",
    "variable": "var(--ksyHyg)"
  },
  "colors.icon.accent.green.hero": {
    "value": "var(--gNEpUn)",
    "variable": "var(--gNEpUn)"
  },
  "colors.icon.accent.orange.strong": {
    "value": "var(--czjxKD)",
    "variable": "var(--czjxKD)"
  },
  "colors.icon.accent.orange.hero": {
    "value": "var(--dpYWqE)",
    "variable": "var(--dpYWqE)"
  },
  "colors.icon.accent.purple.strong": {
    "value": "var(--fNSIYB)",
    "variable": "var(--fNSIYB)"
  },
  "colors.icon.accent.purple.hero": {
    "value": "var(--fNXhGW)",
    "variable": "var(--fNXhGW)"
  },
  "colors.icon.accent.red.strong": {
    "value": "var(--DRmuU)",
    "variable": "var(--DRmuU)"
  },
  "colors.icon.accent.red.hero": {
    "value": "var(--gkNslb)",
    "variable": "var(--gkNslb)"
  },
  "colors.icon.accent.teal.strong": {
    "value": "var(--hqnRgP)",
    "variable": "var(--hqnRgP)"
  },
  "colors.icon.accent.teal.hero": {
    "value": "var(--kruCHE)",
    "variable": "var(--kruCHE)"
  },
  "colors.icon.accent.yellow.strong": {
    "value": "var(--iYUReP)",
    "variable": "var(--iYUReP)"
  },
  "colors.icon.accent.yellow.hero": {
    "value": "var(--hScRNo)",
    "variable": "var(--hScRNo)"
  },
  "colors.icon.action.neutral.default": {
    "value": "var(--ggvolK)",
    "variable": "var(--ggvolK)"
  },
  "colors.icon.action.neutral.hover": {
    "value": "var(--bzEJdH)",
    "variable": "var(--bzEJdH)"
  },
  "colors.icon.action.neutral.pressed": {
    "value": "var(--hsVItX)",
    "variable": "var(--hsVItX)"
  },
  "colors.icon.action.neutral-fixed.default": {
    "value": "var(--jmhMnx)",
    "variable": "var(--jmhMnx)"
  },
  "colors.icon.action.neutral-fixed.hover": {
    "value": "var(--gjotPY)",
    "variable": "var(--gjotPY)"
  },
  "colors.icon.action.neutral-fixed.pressed": {
    "value": "var(--fnyykU)",
    "variable": "var(--fnyykU)"
  },
  "colors.icon.action.hero.default": {
    "value": "var(--ecHnwD)",
    "variable": "var(--ecHnwD)"
  },
  "colors.icon.action.hero.hover": {
    "value": "var(--jHJVjK)",
    "variable": "var(--jHJVjK)"
  },
  "colors.icon.action.hero.pressed": {
    "value": "var(--jhVWAG)",
    "variable": "var(--jhVWAG)"
  },
  "colors.icon.action.hero.selected.default": {
    "value": "var(--hiQhhL)",
    "variable": "var(--hiQhhL)"
  },
  "colors.icon.action.hero.selected.hover": {
    "value": "var(--iMbHwK)",
    "variable": "var(--iMbHwK)"
  },
  "colors.icon.action.hero.selected.pressed": {
    "value": "var(--hQlLRG)",
    "variable": "var(--hQlLRG)"
  },
  "colors.icon.action.strong.default": {
    "value": "var(--bncwPs)",
    "variable": "var(--bncwPs)"
  },
  "colors.icon.action.strong.hover": {
    "value": "var(--lcLglV)",
    "variable": "var(--lcLglV)"
  },
  "colors.icon.action.strong.pressed": {
    "value": "var(--crhXiB)",
    "variable": "var(--crhXiB)"
  },
  "colors.icon.action.critical.strong.default": {
    "value": "var(--gLrAFu)",
    "variable": "var(--gLrAFu)"
  },
  "colors.icon.action.critical.strong.hover": {
    "value": "var(--gIWQtX)",
    "variable": "var(--gIWQtX)"
  },
  "colors.icon.action.critical.strong.pressed": {
    "value": "var(--kUmMlr)",
    "variable": "var(--kUmMlr)"
  },
  "colors.icon.action.critical.hero.default": {
    "value": "var(--hZvdxN)",
    "variable": "var(--hZvdxN)"
  },
  "colors.icon.action.critical.hero.hover": {
    "value": "var(--knpzog)",
    "variable": "var(--knpzog)"
  },
  "colors.icon.action.critical.hero.pressed": {
    "value": "var(--jrzDJc)",
    "variable": "var(--jrzDJc)"
  },
  "colors.icon.action.success.hero.default": {
    "value": "var(--bZqaTh)",
    "variable": "var(--bZqaTh)"
  },
  "colors.icon.action.success.hero.hover": {
    "value": "var(--gnCMCw)",
    "variable": "var(--gnCMCw)"
  },
  "colors.icon.action.success.hero.pressed": {
    "value": "var(--hXfCpA)",
    "variable": "var(--hXfCpA)"
  },
  "colors.icon.action.disabled": {
    "value": "var(--bItWqd)",
    "variable": "var(--bItWqd)"
  },
  "colors.icon.action.disabled-muted": {
    "value": "var(--gjpKVx)",
    "variable": "var(--gjpKVx)"
  },
  "colors.icon.action.disabled-alt": {
    "value": "var(--kMPCTt)",
    "variable": "var(--kMPCTt)"
  },
  "colors.icon.express.empower.strong": {
    "value": "var(--bYphio)",
    "variable": "var(--bYphio)"
  },
  "colors.icon.express.empower.hero": {
    "value": "var(--cEzlOn)",
    "variable": "var(--cEzlOn)"
  },
  "colors.icon.express.insight.strong": {
    "value": "var(--iqDbuV)",
    "variable": "var(--iqDbuV)"
  },
  "colors.icon.express.insight.hero": {
    "value": "var(--feJzSm)",
    "variable": "var(--feJzSm)"
  },
  "colors.icon.express.inspire.strong": {
    "value": "var(--dWAmQR)",
    "variable": "var(--dWAmQR)"
  },
  "colors.icon.express.inspire.hero": {
    "value": "var(--hLzlaa)",
    "variable": "var(--hLzlaa)"
  },
  "colors.icon.express.trust.strong": {
    "value": "var(--eboyBH)",
    "variable": "var(--eboyBH)"
  },
  "colors.icon.express.trust.hero": {
    "value": "var(--hqGIbk)",
    "variable": "var(--hqGIbk)"
  },
  "colors.icon.feedback.critical.strong": {
    "value": "var(--dUucpL)",
    "variable": "var(--dUucpL)"
  },
  "colors.icon.feedback.critical.hero": {
    "value": "var(--jbBerE)",
    "variable": "var(--jbBerE)"
  },
  "colors.icon.feedback.critical.hero-alt": {
    "value": "var(--htiptA)",
    "variable": "var(--htiptA)"
  },
  "colors.icon.feedback.info.strong": {
    "value": "var(--hkoYDW)",
    "variable": "var(--hkoYDW)"
  },
  "colors.icon.feedback.info.hero": {
    "value": "var(--dlLkYV)",
    "variable": "var(--dlLkYV)"
  },
  "colors.icon.feedback.notify.strong": {
    "value": "var(--dDDyIX)",
    "variable": "var(--dDDyIX)"
  },
  "colors.icon.feedback.notify.hero": {
    "value": "var(--jaWsXg)",
    "variable": "var(--jaWsXg)"
  },
  "colors.icon.feedback.notify.hero-alt": {
    "value": "var(--eSdHdc)",
    "variable": "var(--eSdHdc)"
  },
  "colors.icon.feedback.success.strong": {
    "value": "var(--bIYyej)",
    "variable": "var(--bIYyej)"
  },
  "colors.icon.feedback.success.hero": {
    "value": "var(--fNAGKQ)",
    "variable": "var(--fNAGKQ)"
  },
  "colors.icon.feedback.success.hero-alt": {
    "value": "var(--jCGIlY)",
    "variable": "var(--jCGIlY)"
  },
  "colors.icon.feedback.warning.strong": {
    "value": "var(--ivUSiq)",
    "variable": "var(--ivUSiq)"
  },
  "colors.icon.feedback.warning.hero": {
    "value": "var(--bRiyvp)",
    "variable": "var(--bRiyvp)"
  },
  "colors.icon.neutral": {
    "value": "var(--iyEiTX)",
    "variable": "var(--iyEiTX)"
  },
  "colors.icon.neutral-fixed": {
    "value": "var(--fwteVI)",
    "variable": "var(--fwteVI)"
  },
  "colors.icon.muted": {
    "value": "var(--dIqxun)",
    "variable": "var(--dIqxun)"
  },
  "colors.icon.subtle": {
    "value": "var(--crumIX)",
    "variable": "var(--crumIX)"
  },
  "colors.icon.invisible": {
    "value": "var(--cLqmYH)",
    "variable": "var(--cLqmYH)"
  },
  "colors.icon.link.default": {
    "value": "var(--kCzsJQ)",
    "variable": "var(--kCzsJQ)"
  },
  "colors.icon.link.hover": {
    "value": "var(--glnmMt)",
    "variable": "var(--glnmMt)"
  },
  "colors.icon.link.pressed": {
    "value": "var(--jiiXzN)",
    "variable": "var(--jiiXzN)"
  },
  "colors.icon.link.last-visited": {
    "value": "var(--bvwsAs)",
    "variable": "var(--bvwsAs)"
  },
  "colors.icon.status.favorite.strong": {
    "value": "var(--bwIZlN)",
    "variable": "var(--bwIZlN)"
  },
  "colors.icon.status.favorite.hero": {
    "value": "var(--dPVMEy)",
    "variable": "var(--dPVMEy)"
  },
  "colors.icon.status.forSale.hero": {
    "value": "var(--gHxvkS)",
    "variable": "var(--gHxvkS)"
  },
  "colors.icon.status.forRent.hero": {
    "value": "var(--lgsgrE)",
    "variable": "var(--lgsgrE)"
  },
  "colors.icon.status.recentlySold.hero": {
    "value": "var(--kIuJNs)",
    "variable": "var(--kIuJNs)"
  },
  "colors.icon.status.offMarket.hero": {
    "value": "var(--hRnpyF)",
    "variable": "var(--hRnpyF)"
  },
  "colors.icon.transparent.neutral-fixed": {
    "value": "var(--iwiKYD)",
    "variable": "var(--iwiKYD)"
  },
  "colors.icon.transparent.neutral-fixed-faint": {
    "value": "var(--etVtaS)",
    "variable": "var(--etVtaS)"
  },
  "colors.icon.transparent.action.neutral-fixed.default": {
    "value": "var(--beanfC)",
    "variable": "var(--beanfC)"
  },
  "colors.icon.transparent.action.neutral-fixed.hover": {
    "value": "var(--iKjqlH)",
    "variable": "var(--iKjqlH)"
  },
  "colors.icon.transparent.action.neutral-fixed.pressed": {
    "value": "var(--eYgUYv)",
    "variable": "var(--eYgUYv)"
  },
  "colors.icon.transparent.onImpact.neutral-fixed": {
    "value": "var(--jdzHRF)",
    "variable": "var(--jdzHRF)"
  },
  "colors.icon.transparent.onInverse.neutral-fixed": {
    "value": "var(--jAFHIH)",
    "variable": "var(--jAFHIH)"
  },
  "colors.icon.onHero.action.neutral.default": {
    "value": "var(--kuWGla)",
    "variable": "var(--kuWGla)"
  },
  "colors.icon.onHero.action.neutral.hover": {
    "value": "var(--etQaqX)",
    "variable": "var(--etQaqX)"
  },
  "colors.icon.onHero.action.neutral.pressed": {
    "value": "var(--hWxScj)",
    "variable": "var(--hWxScj)"
  },
  "colors.icon.onHero.express.empower.hero": {
    "value": "var(--dHVNCH)",
    "variable": "var(--dHVNCH)"
  },
  "colors.icon.onHero.express.insight.hero": {
    "value": "var(--jTHMFe)",
    "variable": "var(--jTHMFe)"
  },
  "colors.icon.onHero.express.inspire.hero": {
    "value": "var(--eZEOSC)",
    "variable": "var(--eZEOSC)"
  },
  "colors.icon.onHero.express.trust.hero": {
    "value": "var(--jfgflw)",
    "variable": "var(--jfgflw)"
  },
  "colors.icon.onHero.neutral": {
    "value": "var(--etCEcb)",
    "variable": "var(--etCEcb)"
  },
  "colors.icon.onHero.neutral-fixed": {
    "value": "var(--jgdgjE)",
    "variable": "var(--jgdgjE)"
  },
  "colors.icon.onHero.link.default": {
    "value": "var(--fjgswc)",
    "variable": "var(--fjgswc)"
  },
  "colors.icon.onHero.link.hover": {
    "value": "var(--irCDll)",
    "variable": "var(--irCDll)"
  },
  "colors.icon.onHero.link.pressed": {
    "value": "var(--hROECh)",
    "variable": "var(--hROECh)"
  },
  "colors.icon.onImpact.action.neutral.default": {
    "value": "var(--dvpplc)",
    "variable": "var(--dvpplc)"
  },
  "colors.icon.onImpact.action.neutral.hover": {
    "value": "var(--bYDAYB)",
    "variable": "var(--bYDAYB)"
  },
  "colors.icon.onImpact.action.neutral.pressed": {
    "value": "var(--fEIJNh)",
    "variable": "var(--fEIJNh)"
  },
  "colors.icon.onImpact.action.neutral-fixed.default": {
    "value": "var(--fELNXX)",
    "variable": "var(--fELNXX)"
  },
  "colors.icon.onImpact.action.neutral-fixed.hover": {
    "value": "var(--eUzvdS)",
    "variable": "var(--eUzvdS)"
  },
  "colors.icon.onImpact.action.neutral-fixed.pressed": {
    "value": "var(--dkuEIq)",
    "variable": "var(--dkuEIq)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.default": {
    "value": "var(--exZSKH)",
    "variable": "var(--exZSKH)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.hover": {
    "value": "var(--gPbDcK)",
    "variable": "var(--gPbDcK)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.pressed": {
    "value": "var(--bMBocu)",
    "variable": "var(--bMBocu)"
  },
  "colors.icon.onImpact.action.hero.default": {
    "value": "var(--huNuqR)",
    "variable": "var(--huNuqR)"
  },
  "colors.icon.onImpact.action.hero.hover": {
    "value": "var(--bGmbco)",
    "variable": "var(--bGmbco)"
  },
  "colors.icon.onImpact.action.hero.pressed": {
    "value": "var(--Kwfxk)",
    "variable": "var(--Kwfxk)"
  },
  "colors.icon.onImpact.action.critical.hero.default": {
    "value": "var(--gbJnlb)",
    "variable": "var(--gbJnlb)"
  },
  "colors.icon.onImpact.action.critical.hero.hover": {
    "value": "var(--bGOyYy)",
    "variable": "var(--bGOyYy)"
  },
  "colors.icon.onImpact.action.critical.hero.pressed": {
    "value": "var(--lmfsbS)",
    "variable": "var(--lmfsbS)"
  },
  "colors.icon.onImpact.express.empower.hero": {
    "value": "var(--cyvqQl)",
    "variable": "var(--cyvqQl)"
  },
  "colors.icon.onImpact.express.insight.hero": {
    "value": "var(--jccypw)",
    "variable": "var(--jccypw)"
  },
  "colors.icon.onImpact.express.inspire.hero": {
    "value": "var(--jxPQFY)",
    "variable": "var(--jxPQFY)"
  },
  "colors.icon.onImpact.express.trust.hero": {
    "value": "var(--hFeDfC)",
    "variable": "var(--hFeDfC)"
  },
  "colors.icon.onImpact.feedback.critical.strong": {
    "value": "var(--bXLNIh)",
    "variable": "var(--bXLNIh)"
  },
  "colors.icon.onImpact.feedback.critical.hero": {
    "value": "var(--lcjPtq)",
    "variable": "var(--lcjPtq)"
  },
  "colors.icon.onImpact.feedback.critical.hero-alt": {
    "value": "var(--jZjlpm)",
    "variable": "var(--jZjlpm)"
  },
  "colors.icon.onImpact.feedback.info.strong": {
    "value": "var(--buLCEc)",
    "variable": "var(--buLCEc)"
  },
  "colors.icon.onImpact.feedback.info.hero": {
    "value": "var(--knTXcb)",
    "variable": "var(--knTXcb)"
  },
  "colors.icon.onImpact.feedback.notify.strong": {
    "value": "var(--glWVEp)",
    "variable": "var(--glWVEp)"
  },
  "colors.icon.onImpact.feedback.notify.hero": {
    "value": "var(--hbwVWe)",
    "variable": "var(--hbwVWe)"
  },
  "colors.icon.onImpact.feedback.notify.hero-alt": {
    "value": "var(--jwfruG)",
    "variable": "var(--jwfruG)"
  },
  "colors.icon.onImpact.feedback.success.strong": {
    "value": "var(--aKRqN)",
    "variable": "var(--aKRqN)"
  },
  "colors.icon.onImpact.feedback.success.hero": {
    "value": "var(--SJPnG)",
    "variable": "var(--SJPnG)"
  },
  "colors.icon.onImpact.feedback.success.hero-alt": {
    "value": "var(--bHZsi)",
    "variable": "var(--bHZsi)"
  },
  "colors.icon.onImpact.feedback.warning.strong": {
    "value": "var(--cFLGVs)",
    "variable": "var(--cFLGVs)"
  },
  "colors.icon.onImpact.feedback.warning.hero": {
    "value": "var(--jLMDQf)",
    "variable": "var(--jLMDQf)"
  },
  "colors.icon.onImpact.neutral": {
    "value": "var(--gzDIbh)",
    "variable": "var(--gzDIbh)"
  },
  "colors.icon.onImpact.neutral-fixed": {
    "value": "var(--dnRqq)",
    "variable": "var(--dnRqq)"
  },
  "colors.icon.onImpact.subtle": {
    "value": "var(--kitEIp)",
    "variable": "var(--kitEIp)"
  },
  "colors.icon.onImpact.link.default": {
    "value": "var(--gDqdkq)",
    "variable": "var(--gDqdkq)"
  },
  "colors.icon.onImpact.link.hover": {
    "value": "var(--epLYMT)",
    "variable": "var(--epLYMT)"
  },
  "colors.icon.onImpact.link.pressed": {
    "value": "var(--gTEziv)",
    "variable": "var(--gTEziv)"
  },
  "colors.icon.onImpact.link.fixed.default": {
    "value": "var(--jBXjSZ)",
    "variable": "var(--jBXjSZ)"
  },
  "colors.icon.onImpact.link.fixed.hover": {
    "value": "var(--fsivlY)",
    "variable": "var(--fsivlY)"
  },
  "colors.icon.onImpact.link.fixed.pressed": {
    "value": "var(--hbLkZc)",
    "variable": "var(--hbLkZc)"
  },
  "colors.icon.onImpact.link.fixed.selected.default": {
    "value": "var(--kZhXCx)",
    "variable": "var(--kZhXCx)"
  },
  "colors.icon.onImpact.link.fixed.selected.hover": {
    "value": "var(--guYPUs)",
    "variable": "var(--guYPUs)"
  },
  "colors.icon.onImpact.link.fixed.selected.pressed": {
    "value": "var(--kxVALw)",
    "variable": "var(--kxVALw)"
  },
  "colors.text.onHero.action.neutral.default": {
    "value": "var(--fMTknM)",
    "variable": "var(--fMTknM)"
  },
  "colors.text.onHero.action.neutral.hover": {
    "value": "var(--kAwDNR)",
    "variable": "var(--kAwDNR)"
  },
  "colors.text.onHero.action.neutral.pressed": {
    "value": "var(--cNIMah)",
    "variable": "var(--cNIMah)"
  },
  "colors.text.onHero.express.empower.hero": {
    "value": "var(--iacqSN)",
    "variable": "var(--iacqSN)"
  },
  "colors.text.onHero.express.insight.hero": {
    "value": "var(--XGvGw)",
    "variable": "var(--XGvGw)"
  },
  "colors.text.onHero.express.inspire.hero": {
    "value": "var(--jSxcnw)",
    "variable": "var(--jSxcnw)"
  },
  "colors.text.onHero.express.trust.hero": {
    "value": "var(--ksPezG)",
    "variable": "var(--ksPezG)"
  },
  "colors.text.onHero.neutral": {
    "value": "var(--iiAkgh)",
    "variable": "var(--iiAkgh)"
  },
  "colors.text.onHero.neutral-fixed": {
    "value": "var(--SQwfG)",
    "variable": "var(--SQwfG)"
  },
  "colors.text.onHero.link.default": {
    "value": "var(--bziKxG)",
    "variable": "var(--bziKxG)"
  },
  "colors.text.onHero.link.hover": {
    "value": "var(--cQBuyH)",
    "variable": "var(--cQBuyH)"
  },
  "colors.text.onHero.link.pressed": {
    "value": "var(--cqNvPD)",
    "variable": "var(--cqNvPD)"
  },
  "colors.text.onHero.link.fixed.default": {
    "value": "var(--hRkCjJ)",
    "variable": "var(--hRkCjJ)"
  },
  "colors.text.onHero.link.fixed.hover": {
    "value": "var(--jxiuJE)",
    "variable": "var(--jxiuJE)"
  },
  "colors.text.onHero.link.fixed.pressed": {
    "value": "var(--boLOMc)",
    "variable": "var(--boLOMc)"
  },
  "colors.text.onImpact.action.neutral.default": {
    "value": "var(--iWWjAG)",
    "variable": "var(--iWWjAG)"
  },
  "colors.text.onImpact.action.neutral.hover": {
    "value": "var(--bzWyYn)",
    "variable": "var(--bzWyYn)"
  },
  "colors.text.onImpact.action.neutral.pressed": {
    "value": "var(--fgbHMT)",
    "variable": "var(--fgbHMT)"
  },
  "colors.text.onImpact.action.hero.default": {
    "value": "var(--fqKiUL)",
    "variable": "var(--fqKiUL)"
  },
  "colors.text.onImpact.action.hero.hover": {
    "value": "var(--fzGRjm)",
    "variable": "var(--fzGRjm)"
  },
  "colors.text.onImpact.action.hero.pressed": {
    "value": "var(--eDQVEi)",
    "variable": "var(--eDQVEi)"
  },
  "colors.text.onImpact.action.critical.hero.default": {
    "value": "var(--jixXXx)",
    "variable": "var(--jixXXx)"
  },
  "colors.text.onImpact.action.critical.hero.hover": {
    "value": "var(--cXESzc)",
    "variable": "var(--cXESzc)"
  },
  "colors.text.onImpact.action.critical.hero.pressed": {
    "value": "var(--bnAcdA)",
    "variable": "var(--bnAcdA)"
  },
  "colors.text.onImpact.express.energy.hero": {
    "value": "var(--fYPVEi)",
    "variable": "var(--fYPVEi)"
  },
  "colors.text.onImpact.express.insight.hero": {
    "value": "var(--kpLxDG)",
    "variable": "var(--kpLxDG)"
  },
  "colors.text.onImpact.express.inspire.hero": {
    "value": "var(--ewnPtC)",
    "variable": "var(--ewnPtC)"
  },
  "colors.text.onImpact.express.trust.hero": {
    "value": "var(--jYyVFQ)",
    "variable": "var(--jYyVFQ)"
  },
  "colors.text.onImpact.feedback.critical.strong": {
    "value": "var(--ZZHbf)",
    "variable": "var(--ZZHbf)"
  },
  "colors.text.onImpact.feedback.critical.hero": {
    "value": "var(--gugtwc)",
    "variable": "var(--gugtwc)"
  },
  "colors.text.onImpact.feedback.info.strong": {
    "value": "var(--jajEeC)",
    "variable": "var(--jajEeC)"
  },
  "colors.text.onImpact.feedback.info.hero": {
    "value": "var(--dPZSGV)",
    "variable": "var(--dPZSGV)"
  },
  "colors.text.onImpact.feedback.notify.strong": {
    "value": "var(--KVMRL)",
    "variable": "var(--KVMRL)"
  },
  "colors.text.onImpact.feedback.notify.hero": {
    "value": "var(--jfAhsk)",
    "variable": "var(--jfAhsk)"
  },
  "colors.text.onImpact.feedback.success.strong": {
    "value": "var(--gPfsdf)",
    "variable": "var(--gPfsdf)"
  },
  "colors.text.onImpact.feedback.success.hero": {
    "value": "var(--kYnXYk)",
    "variable": "var(--kYnXYk)"
  },
  "colors.text.onImpact.feedback.warning.strong": {
    "value": "var(--iTFphS)",
    "variable": "var(--iTFphS)"
  },
  "colors.text.onImpact.feedback.warning.hero": {
    "value": "var(--dKSZV)",
    "variable": "var(--dKSZV)"
  },
  "colors.text.onImpact.neutral": {
    "value": "var(--gkawLP)",
    "variable": "var(--gkawLP)"
  },
  "colors.text.onImpact.neutral-fixed": {
    "value": "var(--buekQU)",
    "variable": "var(--buekQU)"
  },
  "colors.text.onImpact.subtle": {
    "value": "var(--eHsvVL)",
    "variable": "var(--eHsvVL)"
  },
  "colors.text.onImpact.link.default": {
    "value": "var(--bhZPrA)",
    "variable": "var(--bhZPrA)"
  },
  "colors.text.onImpact.link.hover": {
    "value": "var(--cTlHtN)",
    "variable": "var(--cTlHtN)"
  },
  "colors.text.onImpact.link.pressed": {
    "value": "var(--fxehPp)",
    "variable": "var(--fxehPp)"
  },
  "colors.text.onImpact.link.last-visited": {
    "value": "var(--kKKuxw)",
    "variable": "var(--kKKuxw)"
  },
  "colors.text.onImpact.link.fixed.default": {
    "value": "var(--bvkknH)",
    "variable": "var(--bvkknH)"
  },
  "colors.text.onImpact.link.fixed.hover": {
    "value": "var(--jbCPkq)",
    "variable": "var(--jbCPkq)"
  },
  "colors.text.onImpact.link.fixed.pressed": {
    "value": "var(--kLfEXu)",
    "variable": "var(--kLfEXu)"
  },
  "colors.text.onImpact.link.fixed.last-visited": {
    "value": "var(--PCPOj)",
    "variable": "var(--PCPOj)"
  },
  "colors.text.accent.brand.hero": {
    "value": "var(--giufph)",
    "variable": "var(--giufph)"
  },
  "colors.text.accent.brand.hero-fixed": {
    "value": "var(--gfyXoW)",
    "variable": "var(--gfyXoW)"
  },
  "colors.text.accent.aqua.strong": {
    "value": "var(--cHXMbR)",
    "variable": "var(--cHXMbR)"
  },
  "colors.text.accent.aqua.hero": {
    "value": "var(--eOkuiC)",
    "variable": "var(--eOkuiC)"
  },
  "colors.text.accent.blue.strong": {
    "value": "var(--gFrexz)",
    "variable": "var(--gFrexz)"
  },
  "colors.text.accent.blue.strong-fixed": {
    "value": "var(--eJDQjQ)",
    "variable": "var(--eJDQjQ)"
  },
  "colors.text.accent.blue.hero": {
    "value": "var(--vIjhk)",
    "variable": "var(--vIjhk)"
  },
  "colors.text.accent.gray.strong": {
    "value": "var(--hVNyTs)",
    "variable": "var(--hVNyTs)"
  },
  "colors.text.accent.gray.hero": {
    "value": "var(--iSEcqv)",
    "variable": "var(--iSEcqv)"
  },
  "colors.text.accent.green.strong": {
    "value": "var(--jRvNEy)",
    "variable": "var(--jRvNEy)"
  },
  "colors.text.accent.green.hero": {
    "value": "var(--dRJmxx)",
    "variable": "var(--dRJmxx)"
  },
  "colors.text.accent.orange.strong": {
    "value": "var(--jnbvKR)",
    "variable": "var(--jnbvKR)"
  },
  "colors.text.accent.orange.hero": {
    "value": "var(--jDSEDe)",
    "variable": "var(--jDSEDe)"
  },
  "colors.text.accent.purple.strong": {
    "value": "var(--kvWeVP)",
    "variable": "var(--kvWeVP)"
  },
  "colors.text.accent.purple.hero": {
    "value": "var(--jGMmkU)",
    "variable": "var(--jGMmkU)"
  },
  "colors.text.accent.red.strong": {
    "value": "var(--enlGtm)",
    "variable": "var(--enlGtm)"
  },
  "colors.text.accent.red.hero": {
    "value": "var(--bJjGMt)",
    "variable": "var(--bJjGMt)"
  },
  "colors.text.accent.teal.strong": {
    "value": "var(--fcBJbJ)",
    "variable": "var(--fcBJbJ)"
  },
  "colors.text.accent.teal.hero": {
    "value": "var(--cehSDG)",
    "variable": "var(--cehSDG)"
  },
  "colors.text.accent.yellow.strong": {
    "value": "var(--eavyNt)",
    "variable": "var(--eavyNt)"
  },
  "colors.text.accent.yellow.hero": {
    "value": "var(--ctFjIe)",
    "variable": "var(--ctFjIe)"
  },
  "colors.text.action.disabled": {
    "value": "var(--jEsexP)",
    "variable": "var(--jEsexP)"
  },
  "colors.text.action.disabled-alt": {
    "value": "var(--igETxL)",
    "variable": "var(--igETxL)"
  },
  "colors.text.action.neutral.default": {
    "value": "var(--hehuSM)",
    "variable": "var(--hehuSM)"
  },
  "colors.text.action.neutral.hover": {
    "value": "var(--bLqvTh)",
    "variable": "var(--bLqvTh)"
  },
  "colors.text.action.neutral.pressed": {
    "value": "var(--hEHvjx)",
    "variable": "var(--hEHvjx)"
  },
  "colors.text.action.neutral-fixed.default": {
    "value": "var(--cNGQQL)",
    "variable": "var(--cNGQQL)"
  },
  "colors.text.action.neutral-fixed.hover": {
    "value": "var(--fptLIO)",
    "variable": "var(--fptLIO)"
  },
  "colors.text.action.neutral-fixed.pressed": {
    "value": "var(--etDQdK)",
    "variable": "var(--etDQdK)"
  },
  "colors.text.action.hero.default": {
    "value": "var(--fifHgR)",
    "variable": "var(--fifHgR)"
  },
  "colors.text.action.hero.hover": {
    "value": "var(--hhkgHQ)",
    "variable": "var(--hhkgHQ)"
  },
  "colors.text.action.hero.pressed": {
    "value": "var(--gHwhYM)",
    "variable": "var(--gHwhYM)"
  },
  "colors.text.action.hero.selected.default": {
    "value": "var(--lBaYV)",
    "variable": "var(--lBaYV)"
  },
  "colors.text.action.hero.selected.hover": {
    "value": "var(--fkBjpE)",
    "variable": "var(--fkBjpE)"
  },
  "colors.text.action.hero.selected.pressed": {
    "value": "var(--eoLnKA)",
    "variable": "var(--eoLnKA)"
  },
  "colors.text.action.strong.default": {
    "value": "var(--exbPaa)",
    "variable": "var(--exbPaa)"
  },
  "colors.text.action.strong.hover": {
    "value": "var(--XgXBr)",
    "variable": "var(--XgXBr)"
  },
  "colors.text.action.strong.pressed": {
    "value": "var(--dAZxWT)",
    "variable": "var(--dAZxWT)"
  },
  "colors.text.action.critical.strong.default": {
    "value": "var(--ichUfY)",
    "variable": "var(--ichUfY)"
  },
  "colors.text.action.critical.strong.hover": {
    "value": "var(--bcoCKR)",
    "variable": "var(--bcoCKR)"
  },
  "colors.text.action.critical.strong.pressed": {
    "value": "var(--fnEyCl)",
    "variable": "var(--fnEyCl)"
  },
  "colors.text.action.critical.hero.default": {
    "value": "var(--jMvByf)",
    "variable": "var(--jMvByf)"
  },
  "colors.text.action.critical.hero.hover": {
    "value": "var(--egIVRm)",
    "variable": "var(--egIVRm)"
  },
  "colors.text.action.critical.hero.pressed": {
    "value": "var(--dkTami)",
    "variable": "var(--dkTami)"
  },
  "colors.text.express.empower.strong": {
    "value": "var(--imiPuO)",
    "variable": "var(--imiPuO)"
  },
  "colors.text.express.empower.hero": {
    "value": "var(--jsrjOB)",
    "variable": "var(--jsrjOB)"
  },
  "colors.text.express.insight.strong": {
    "value": "var(--iSlGRD)",
    "variable": "var(--iSlGRD)"
  },
  "colors.text.express.insight.hero": {
    "value": "var(--kqGagI)",
    "variable": "var(--kqGagI)"
  },
  "colors.text.express.inspire.strong": {
    "value": "var(--hfiWKv)",
    "variable": "var(--hfiWKv)"
  },
  "colors.text.express.inspire.hero": {
    "value": "var(--keTDAo)",
    "variable": "var(--keTDAo)"
  },
  "colors.text.express.trust.strong": {
    "value": "var(--kPgwBV)",
    "variable": "var(--kPgwBV)"
  },
  "colors.text.express.trust.hero": {
    "value": "var(--cpeGOO)",
    "variable": "var(--cpeGOO)"
  },
  "colors.text.feedback.critical.strong": {
    "value": "var(--bGHUkF)",
    "variable": "var(--bGHUkF)"
  },
  "colors.text.feedback.critical.hero": {
    "value": "var(--OounG)",
    "variable": "var(--OounG)"
  },
  "colors.text.feedback.info.strong": {
    "value": "var(--joskac)",
    "variable": "var(--joskac)"
  },
  "colors.text.feedback.info.hero": {
    "value": "var(--FABDn)",
    "variable": "var(--FABDn)"
  },
  "colors.text.feedback.notify.strong": {
    "value": "var(--fTgsJt)",
    "variable": "var(--fTgsJt)"
  },
  "colors.text.feedback.notify.hero": {
    "value": "var(--fqYKYK)",
    "variable": "var(--fqYKYK)"
  },
  "colors.text.feedback.success.strong": {
    "value": "var(--dYBseF)",
    "variable": "var(--dYBseF)"
  },
  "colors.text.feedback.success.hero": {
    "value": "var(--kxVKou)",
    "variable": "var(--kxVKou)"
  },
  "colors.text.feedback.warning.strong": {
    "value": "var(--kPpkIE)",
    "variable": "var(--kPpkIE)"
  },
  "colors.text.feedback.warning.hero": {
    "value": "var(--ceOkrX)",
    "variable": "var(--ceOkrX)"
  },
  "colors.text.neutral": {
    "value": "var(--fCJfxh)",
    "variable": "var(--fCJfxh)"
  },
  "colors.text.neutral-fixed": {
    "value": "var(--kFikXK)",
    "variable": "var(--kFikXK)"
  },
  "colors.text.subtle": {
    "value": "var(--eGXgJt)",
    "variable": "var(--eGXgJt)"
  },
  "colors.text.invisible": {
    "value": "var(--rqiVt)",
    "variable": "var(--rqiVt)"
  },
  "colors.text.link.default": {
    "value": "var(--lhZwGq)",
    "variable": "var(--lhZwGq)"
  },
  "colors.text.link.hover": {
    "value": "var(--bmhdtr)",
    "variable": "var(--bmhdtr)"
  },
  "colors.text.link.pressed": {
    "value": "var(--ejcOgL)",
    "variable": "var(--ejcOgL)"
  },
  "colors.text.link.last-visited": {
    "value": "var(--gfRwdW)",
    "variable": "var(--gfRwdW)"
  },
  "colors.Accordion.bg.hover": {
    "value": "var(--HdMfX)",
    "variable": "var(--HdMfX)"
  },
  "colors.Accordion.bg.pressed": {
    "value": "var(--cLtNVz)",
    "variable": "var(--cLtNVz)"
  },
  "colors.Accordion.bg.selectedPressed": {
    "value": "var(--dRfpSC)",
    "variable": "var(--dRfpSC)"
  },
  "colors.Accordion.border.default": {
    "value": "var(--hRHzOb)",
    "variable": "var(--hRHzOb)"
  },
  "colors.Accordion.Header.bg.hover": {
    "value": "var(--OmrYp)",
    "variable": "var(--OmrYp)"
  },
  "colors.Accordion.Header.bg.pressed": {
    "value": "var(--gHDroF)",
    "variable": "var(--gHDroF)"
  },
  "colors.Accordion.Header.bg.selected": {
    "value": "var(--cibXqy)",
    "variable": "var(--cibXqy)"
  },
  "colors.Accordion.Header.bg.selectedHover": {
    "value": "var(--lesKkg)",
    "variable": "var(--lesKkg)"
  },
  "colors.Accordion.Header.bg.selectedPressed": {
    "value": "var(--eamWCE)",
    "variable": "var(--eamWCE)"
  },
  "colors.Accordion.Header.border.default": {
    "value": "var(--cMcptx)",
    "variable": "var(--cMcptx)"
  },
  "colors.Accordion.Panel.bg": {
    "value": "var(--kUEYev)",
    "variable": "var(--kUEYev)"
  },
  "colors.Accordion.Panel.border": {
    "value": "var(--QZFbi)",
    "variable": "var(--QZFbi)"
  },
  "colors.AdornedInput.Adornment.default": {
    "value": "var(--xlGOO)",
    "variable": "var(--xlGOO)"
  },
  "colors.AdornedInput.Input.placeholder": {
    "value": "var(--oRAqY)",
    "variable": "var(--oRAqY)"
  },
  "colors.AdornedInput.bg.default": {
    "value": "var(--fuiwTL)",
    "variable": "var(--fuiwTL)"
  },
  "colors.AdornedInput.bg.error": {
    "value": "var(--fGtyCk)",
    "variable": "var(--fGtyCk)"
  },
  "colors.AdornedInput.bg.errorHover": {
    "value": "var(--fMGHQe)",
    "variable": "var(--fMGHQe)"
  },
  "colors.AdornedInput.bg.hover": {
    "value": "var(--dZtKoS)",
    "variable": "var(--dZtKoS)"
  },
  "colors.AdornedInput.border.default": {
    "value": "var(--dLwete)",
    "variable": "var(--dLwete)"
  },
  "colors.AdornedInput.border.error": {
    "value": "var(--crPzmZ)",
    "variable": "var(--crPzmZ)"
  },
  "colors.AdornedInput.border.errorActive": {
    "value": "var(--gnHCTB)",
    "variable": "var(--gnHCTB)"
  },
  "colors.AdornedInput.border.errorHover": {
    "value": "var(--jnXmrH)",
    "variable": "var(--jnXmrH)"
  },
  "colors.AdornedInput.border.hover": {
    "value": "var(--gsPCwv)",
    "variable": "var(--gsPCwv)"
  },
  "colors.Alert.critical.bg": {
    "value": "var(--jViHSg)",
    "variable": "var(--jViHSg)"
  },
  "colors.Alert.critical.border": {
    "value": "var(--gtWZJd)",
    "variable": "var(--gtWZJd)"
  },
  "colors.Alert.critical.icon": {
    "value": "var(--eYWXyy)",
    "variable": "var(--eYWXyy)"
  },
  "colors.Alert.info.bg": {
    "value": "var(--jVIgXp)",
    "variable": "var(--jVIgXp)"
  },
  "colors.Alert.info.border": {
    "value": "var(--dgLYfg)",
    "variable": "var(--dgLYfg)"
  },
  "colors.Alert.info.icon": {
    "value": "var(--bLMieD)",
    "variable": "var(--bLMieD)"
  },
  "colors.Alert.notify.bg": {
    "value": "var(--dmSKTQ)",
    "variable": "var(--dmSKTQ)"
  },
  "colors.Alert.notify.border": {
    "value": "var(--qhqBl)",
    "variable": "var(--qhqBl)"
  },
  "colors.Alert.success.bg": {
    "value": "var(--gqFZQw)",
    "variable": "var(--gqFZQw)"
  },
  "colors.Alert.success.border": {
    "value": "var(--ZMrIV)",
    "variable": "var(--ZMrIV)"
  },
  "colors.Alert.warning.bg": {
    "value": "var(--lbQiBR)",
    "variable": "var(--lbQiBR)"
  },
  "colors.Alert.warning.border": {
    "value": "var(--btoIIg)",
    "variable": "var(--btoIIg)"
  },
  "colors.Alert.warning.icon": {
    "value": "var(--eUoqvL)",
    "variable": "var(--eUoqvL)"
  },
  "colors.Anchor.onImpact.pressed": {
    "value": "var(--jeSLJo)",
    "variable": "var(--jeSLJo)"
  },
  "colors.Avatar.Icon.default": {
    "value": "var(--ibxgjd)",
    "variable": "var(--ibxgjd)"
  },
  "colors.Avatar.Root.bg": {
    "value": "var(--gpSJkC)",
    "variable": "var(--gpSJkC)"
  },
  "colors.Avatar.Root.border": {
    "value": "var(--jyDjOn)",
    "variable": "var(--jyDjOn)"
  },
  "colors.Avatar.Root.accent.2.bg": {
    "value": "var(--inJMVm)",
    "variable": "var(--inJMVm)"
  },
  "colors.Avatar.Root.accent.3.bg": {
    "value": "var(--gAVKCj)",
    "variable": "var(--gAVKCj)"
  },
  "colors.Avatar.Root.accent.4.bg": {
    "value": "var(--bZxfpI)",
    "variable": "var(--bZxfpI)"
  },
  "colors.Banner.critical.bg": {
    "value": "var(--hRlntq)",
    "variable": "var(--hRlntq)"
  },
  "colors.Banner.critical.icon": {
    "value": "var(--iXmYpg)",
    "variable": "var(--iXmYpg)"
  },
  "colors.Banner.info.bg": {
    "value": "var(--copSbf)",
    "variable": "var(--copSbf)"
  },
  "colors.Banner.info.icon": {
    "value": "var(--hDAnfJ)",
    "variable": "var(--hDAnfJ)"
  },
  "colors.Banner.success.bg": {
    "value": "var(--gXNTUm)",
    "variable": "var(--gXNTUm)"
  },
  "colors.Banner.success.icon": {
    "value": "var(--gzfxgs)",
    "variable": "var(--gzfxgs)"
  },
  "colors.Banner.warning.bg": {
    "value": "var(--gzNdDP)",
    "variable": "var(--gzNdDP)"
  },
  "colors.Banner.warning.icon": {
    "value": "var(--kcdTFx)",
    "variable": "var(--kcdTFx)"
  },
  "colors.Button.filled.critical.label.pressed": {
    "value": "var(--eIfIVj)",
    "variable": "var(--eIfIVj)"
  },
  "colors.Button.filled.critical.icon.pressed": {
    "value": "var(--yZxdS)",
    "variable": "var(--yZxdS)"
  },
  "colors.Button.filled.critical.border.pressed": {
    "value": "var(--cSfDlZ)",
    "variable": "var(--cSfDlZ)"
  },
  "colors.Button.outlined.neutral.bg.default": {
    "value": "var(--feWlDB)",
    "variable": "var(--feWlDB)"
  },
  "colors.Button.outlined.neutral.border.selectedPressed": {
    "value": "var(--chNBPE)",
    "variable": "var(--chNBPE)"
  },
  "colors.Calendar.DayOfWeek.border.default": {
    "value": "var(--JDmYp)",
    "variable": "var(--JDmYp)"
  },
  "colors.Calendar.Day.bg.selected": {
    "value": "var(--loHGLf)",
    "variable": "var(--loHGLf)"
  },
  "colors.Calendar.Day.bg.selectedHover": {
    "value": "var(--ipWezB)",
    "variable": "var(--ipWezB)"
  },
  "colors.Calendar.Day.bg.selectedPressed": {
    "value": "var(--kdEjCV)",
    "variable": "var(--kdEjCV)"
  },
  "colors.Calendar.Root.bg.default": {
    "value": "var(--hzPDdL)",
    "variable": "var(--hzPDdL)"
  },
  "colors.Card.Root.neutral.border": {
    "value": "var(--fSBtrC)",
    "variable": "var(--fSBtrC)"
  },
  "colors.Card.Root.neutral.elevated.bg": {
    "value": "var(--fYYnRE)",
    "variable": "var(--fYYnRE)"
  },
  "colors.Card.Root.soft.bg": {
    "value": "var(--iHCyis)",
    "variable": "var(--iHCyis)"
  },
  "colors.Card.Root.soft.border": {
    "value": "var(--koJkul)",
    "variable": "var(--koJkul)"
  },
  "colors.Card.Root.interactive.neutral.bg.default": {
    "value": "var(--bmjcIc)",
    "variable": "var(--bmjcIc)"
  },
  "colors.Card.Root.interactive.neutral.bg.hover": {
    "value": "var(--gTZytR)",
    "variable": "var(--gTZytR)"
  },
  "colors.Card.Root.interactive.neutral.bg.pressed": {
    "value": "var(--hsjyZR)",
    "variable": "var(--hsjyZR)"
  },
  "colors.Card.Root.interactive.neutral.border.default": {
    "value": "var(--jXfJsl)",
    "variable": "var(--jXfJsl)"
  },
  "colors.Card.Root.interactive.neutral.border.hover": {
    "value": "var(--erwEmE)",
    "variable": "var(--erwEmE)"
  },
  "colors.Card.Root.interactive.neutral.border.pressed": {
    "value": "var(--PCCpI)",
    "variable": "var(--PCCpI)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.default": {
    "value": "var(--fymRSP)",
    "variable": "var(--fymRSP)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.hover": {
    "value": "var(--gjlYDG)",
    "variable": "var(--gjlYDG)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.pressed": {
    "value": "var(--eNeJEC)",
    "variable": "var(--eNeJEC)"
  },
  "colors.Card.Root.interactive.soft.bg.default": {
    "value": "var(--eTTvRf)",
    "variable": "var(--eTTvRf)"
  },
  "colors.Card.Root.interactive.soft.bg.hover": {
    "value": "var(--eJqHtq)",
    "variable": "var(--eJqHtq)"
  },
  "colors.Card.Root.interactive.soft.bg.pressed": {
    "value": "var(--lewusu)",
    "variable": "var(--lewusu)"
  },
  "colors.Card.Root.interactive.soft.border.default": {
    "value": "var(--bhjXHu)",
    "variable": "var(--bhjXHu)"
  },
  "colors.Card.Root.interactive.soft.border.hover": {
    "value": "var(--djKeUD)",
    "variable": "var(--djKeUD)"
  },
  "colors.Card.Root.interactive.soft.border.pressed": {
    "value": "var(--hmGPLH)",
    "variable": "var(--hmGPLH)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.default": {
    "value": "var(--byKiVM)",
    "variable": "var(--byKiVM)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.hover": {
    "value": "var(--cdXJXB)",
    "variable": "var(--cdXJXB)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.pressed": {
    "value": "var(--dkaKRd)",
    "variable": "var(--dkaKRd)"
  },
  "colors.Checkbox.border.hover": {
    "value": "var(--htrHRt)",
    "variable": "var(--htrHRt)"
  },
  "colors.Checkbox.border.pressed": {
    "value": "var(--itXWgN)",
    "variable": "var(--itXWgN)"
  },
  "colors.Chip.bg.elevated.hover": {
    "value": "var(--jpfpRi)",
    "variable": "var(--jpfpRi)"
  },
  "colors.Chip.bg.elevated.pressed": {
    "value": "var(--iPrrie)",
    "variable": "var(--iPrrie)"
  },
  "colors.Chip.border.selectedHover": {
    "value": "var(--jDISsV)",
    "variable": "var(--jDISsV)"
  },
  "colors.Chip.border.selectedPressed": {
    "value": "var(--ehEikp)",
    "variable": "var(--ehEikp)"
  },
  "colors.CloseButton.icon.onImpact.default": {
    "value": "var(--ewCsYa)",
    "variable": "var(--ewCsYa)"
  },
  "colors.Combobox.Heading.bg": {
    "value": "var(--iLZmvU)",
    "variable": "var(--iLZmvU)"
  },
  "colors.Combobox.Adornment.icon.trailing.default": {
    "value": "var(--edsAHL)",
    "variable": "var(--edsAHL)"
  },
  "colors.Combobox.bg.default": {
    "value": "var(--cLeLKr)",
    "variable": "var(--cLeLKr)"
  },
  "colors.Combobox.bg.hover": {
    "value": "var(--dqaFJq)",
    "variable": "var(--dqaFJq)"
  },
  "colors.Combobox.bg.error": {
    "value": "var(--jpBRQQ)",
    "variable": "var(--jpBRQQ)"
  },
  "colors.Combobox.bg.errorHover": {
    "value": "var(--cWUpLq)",
    "variable": "var(--cWUpLq)"
  },
  "colors.Combobox.border.default": {
    "value": "var(--cCzWOy)",
    "variable": "var(--cCzWOy)"
  },
  "colors.Combobox.border.hover": {
    "value": "var(--cLrKTX)",
    "variable": "var(--cLrKTX)"
  },
  "colors.Combobox.border.active": {
    "value": "var(--RBKoN)",
    "variable": "var(--RBKoN)"
  },
  "colors.Combobox.border.activeHover": {
    "value": "var(--AdoOz)",
    "variable": "var(--AdoOz)"
  },
  "colors.Combobox.border.error": {
    "value": "var(--fAzCFF)",
    "variable": "var(--fAzCFF)"
  },
  "colors.Combobox.border.errorHover": {
    "value": "var(--hCmKLj)",
    "variable": "var(--hCmKLj)"
  },
  "colors.Combobox.border.errorActive": {
    "value": "var(--hHrxZB)",
    "variable": "var(--hHrxZB)"
  },
  "colors.Combobox.icon.clearButton.pressed": {
    "value": "var(--fpInMi)",
    "variable": "var(--fpInMi)"
  },
  "colors.Combobox.icon.trailing.default": {
    "value": "var(--knvkTm)",
    "variable": "var(--knvkTm)"
  },
  "colors.Combobox.icon.trailing.readOnly": {
    "value": "var(--bfJDin)",
    "variable": "var(--bfJDin)"
  },
  "colors.Combobox.text.placeholder": {
    "value": "var(--lkxWWH)",
    "variable": "var(--lkxWWH)"
  },
  "colors.Combobox.Group.border": {
    "value": "var(--hpAlFW)",
    "variable": "var(--hpAlFW)"
  },
  "colors.Combobox.Input.text.placeholder": {
    "value": "var(--iKFxsc)",
    "variable": "var(--iKFxsc)"
  },
  "colors.Combobox.Trigger.bg.default": {
    "value": "var(--fRzRnq)",
    "variable": "var(--fRzRnq)"
  },
  "colors.Combobox.Trigger.bg.hover": {
    "value": "var(--jhZCZT)",
    "variable": "var(--jhZCZT)"
  },
  "colors.Combobox.Trigger.bg.error": {
    "value": "var(--ikxSvZ)",
    "variable": "var(--ikxSvZ)"
  },
  "colors.Combobox.Trigger.bg.errorHover": {
    "value": "var(--tRmcP)",
    "variable": "var(--tRmcP)"
  },
  "colors.Combobox.Trigger.border.default": {
    "value": "var(--kJWqVH)",
    "variable": "var(--kJWqVH)"
  },
  "colors.Combobox.Trigger.border.hover": {
    "value": "var(--iCjWbm)",
    "variable": "var(--iCjWbm)"
  },
  "colors.Combobox.Trigger.border.activeHover": {
    "value": "var(--llJdfy)",
    "variable": "var(--llJdfy)"
  },
  "colors.Combobox.Trigger.border.error": {
    "value": "var(--lfpNiU)",
    "variable": "var(--lfpNiU)"
  },
  "colors.Combobox.Trigger.border.errorHover": {
    "value": "var(--dkCEiy)",
    "variable": "var(--dkCEiy)"
  },
  "colors.Combobox.Trigger.border.errorActive": {
    "value": "var(--Ivdgk)",
    "variable": "var(--Ivdgk)"
  },
  "colors.DateInput.bg.autofill": {
    "value": "var(--gegLQP)",
    "variable": "var(--gegLQP)"
  },
  "colors.DateInput.bg.default": {
    "value": "var(--jcIbIY)",
    "variable": "var(--jcIbIY)"
  },
  "colors.DateInput.bg.error": {
    "value": "var(--BMXkb)",
    "variable": "var(--BMXkb)"
  },
  "colors.DateInput.bg.errorHover": {
    "value": "var(--gDYjJt)",
    "variable": "var(--gDYjJt)"
  },
  "colors.DateInput.bg.hover": {
    "value": "var(--jboeex)",
    "variable": "var(--jboeex)"
  },
  "colors.DateInput.border.default": {
    "value": "var(--gyPiYB)",
    "variable": "var(--gyPiYB)"
  },
  "colors.DateInput.border.error": {
    "value": "var(--bGoLHS)",
    "variable": "var(--bGoLHS)"
  },
  "colors.DateInput.border.errorActive": {
    "value": "var(--gwiJnO)",
    "variable": "var(--gwiJnO)"
  },
  "colors.DateInput.border.errorHover": {
    "value": "var(--bVieIU)",
    "variable": "var(--bVieIU)"
  },
  "colors.DateInput.border.hover": {
    "value": "var(--bEvXcw)",
    "variable": "var(--bEvXcw)"
  },
  "colors.DateInput.icon.leading.default": {
    "value": "var(--cWdCRP)",
    "variable": "var(--cWdCRP)"
  },
  "colors.DateInput.icon.leading.readOnly": {
    "value": "var(--ffJoMW)",
    "variable": "var(--ffJoMW)"
  },
  "colors.DateInput.icon.trailing.default": {
    "value": "var(--iErTSR)",
    "variable": "var(--iErTSR)"
  },
  "colors.DateInput.icon.trailing.readOnly": {
    "value": "var(--fiCJKM)",
    "variable": "var(--fiCJKM)"
  },
  "colors.DateInput.text.adornment.default": {
    "value": "var(--dNEjEt)",
    "variable": "var(--dNEjEt)"
  },
  "colors.DateInput.text.adornment.readOnly": {
    "value": "var(--byInPY)",
    "variable": "var(--byInPY)"
  },
  "colors.DateInput.text.placeholder": {
    "value": "var(--fCWOTw)",
    "variable": "var(--fCWOTw)"
  },
  "colors.DatePicker.Backdrop.bg": {
    "value": "var(--gETnzp)",
    "variable": "var(--gETnzp)"
  },
  "colors.DatePicker.Content.bg": {
    "value": "var(--hRnwkW)",
    "variable": "var(--hRnwkW)"
  },
  "colors.DatePicker.InputGroup.bg.default": {
    "value": "var(--eaGyWE)",
    "variable": "var(--eaGyWE)"
  },
  "colors.DatePicker.InputGroup.bg.hover": {
    "value": "var(--krZAKJ)",
    "variable": "var(--krZAKJ)"
  },
  "colors.DatePicker.InputGroup.bg.error": {
    "value": "var(--gTIain)",
    "variable": "var(--gTIain)"
  },
  "colors.DatePicker.InputGroup.bg.errorHover": {
    "value": "var(--bthYot)",
    "variable": "var(--bthYot)"
  },
  "colors.DatePicker.InputGroup.border.default": {
    "value": "var(--lfPrjt)",
    "variable": "var(--lfPrjt)"
  },
  "colors.DatePicker.InputGroup.border.hover": {
    "value": "var(--hWbFiQ)",
    "variable": "var(--hWbFiQ)"
  },
  "colors.DatePicker.InputGroup.border.active": {
    "value": "var(--exdLzS)",
    "variable": "var(--exdLzS)"
  },
  "colors.DatePicker.InputGroup.border.activeHover": {
    "value": "var(--iRjjGM)",
    "variable": "var(--iRjjGM)"
  },
  "colors.DatePicker.InputGroup.border.error": {
    "value": "var(--hrBSzW)",
    "variable": "var(--hrBSzW)"
  },
  "colors.DatePicker.InputGroup.border.errorActive": {
    "value": "var(--brSBPe)",
    "variable": "var(--brSBPe)"
  },
  "colors.DatePicker.InputGroup.border.errorHover": {
    "value": "var(--clgTwA)",
    "variable": "var(--clgTwA)"
  },
  "colors.DatePicker.InputGroup.text.placeholder": {
    "value": "var(--ldKtNY)",
    "variable": "var(--ldKtNY)"
  },
  "colors.Divider.muted.bg": {
    "value": "var(--eTqrmV)",
    "variable": "var(--eTqrmV)"
  },
  "colors.Divider.emphasized.bg": {
    "value": "var(--loSvXo)",
    "variable": "var(--loSvXo)"
  },
  "colors.Dropdown.Content.bg": {
    "value": "var(--jYAGkP)",
    "variable": "var(--jYAGkP)"
  },
  "colors.Dropdown.Heading.bg": {
    "value": "var(--fDaqpK)",
    "variable": "var(--fDaqpK)"
  },
  "colors.FieldSet.HelperArea.icon.default": {
    "value": "var(--hrqSrg)",
    "variable": "var(--hrqSrg)"
  },
  "colors.FieldSet.HelperArea.icon.error": {
    "value": "var(--eghtvv)",
    "variable": "var(--eghtvv)"
  },
  "colors.FieldSet.HelperArea.text.default": {
    "value": "var(--isXJdG)",
    "variable": "var(--isXJdG)"
  },
  "colors.FieldSet.HelperArea.text.error": {
    "value": "var(--bFFtWV)",
    "variable": "var(--bFFtWV)"
  },
  "colors.FieldSet.LabelArea.indicator.required": {
    "value": "var(--fnBrAA)",
    "variable": "var(--fnBrAA)"
  },
  "colors.FormField.HelperArea.icon.default": {
    "value": "var(--hfgYkM)",
    "variable": "var(--hfgYkM)"
  },
  "colors.FormField.HelperArea.icon.error": {
    "value": "var(--hlarSD)",
    "variable": "var(--hlarSD)"
  },
  "colors.FormField.HelperArea.text.default": {
    "value": "var(--fSBGKi)",
    "variable": "var(--fSBGKi)"
  },
  "colors.FormField.HelperArea.text.error": {
    "value": "var(--enGqvh)",
    "variable": "var(--enGqvh)"
  },
  "colors.FormField.HelperArea.text.readOnly": {
    "value": "var(--kFGivr)",
    "variable": "var(--kFGivr)"
  },
  "colors.FormField.LabelArea.indicator.readOnly": {
    "value": "var(--kEMtcX)",
    "variable": "var(--kEMtcX)"
  },
  "colors.FormField.LabelArea.indicator.required": {
    "value": "var(--boSLPI)",
    "variable": "var(--boSLPI)"
  },
  "colors.Gleam.new.bg": {
    "value": "var(--bGRRQL)",
    "variable": "var(--bGRRQL)"
  },
  "colors.Gleam.new.text": {
    "value": "var(--bGGMHX)",
    "variable": "var(--bGGMHX)"
  },
  "colors.Gleam.onImpact.new.text": {
    "value": "var(--jOmhyB)",
    "variable": "var(--jOmhyB)"
  },
  "colors.IconButton.filled.critical.icon.pressed": {
    "value": "var(--fUCmfp)",
    "variable": "var(--fUCmfp)"
  },
  "colors.IconButton.filled.critical.border.pressed": {
    "value": "var(--kHfooC)",
    "variable": "var(--kHfooC)"
  },
  "colors.IconButton.outlined.neutral.bg.default": {
    "value": "var(--deHLOu)",
    "variable": "var(--deHLOu)"
  },
  "colors.IconButton.outlined.neutral.border.selectedPressed": {
    "value": "var(--hHsAuz)",
    "variable": "var(--hHsAuz)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.default": {
    "value": "var(--kTXJaK)",
    "variable": "var(--kTXJaK)"
  },
  "colors.Icon.TopAgent.brand-fixed": {
    "value": "var(--gFADUx)",
    "variable": "var(--gFADUx)"
  },
  "colors.Icon.TopAgent.brand-alt-fixed": {
    "value": "var(--fUxHpV)",
    "variable": "var(--fUxHpV)"
  },
  "colors.Icon.TopAgent.accent-fixed": {
    "value": "var(--kglkMI)",
    "variable": "var(--kglkMI)"
  },
  "colors.Icon.TopAgent.white-fixed": {
    "value": "var(--QHiyd)",
    "variable": "var(--QHiyd)"
  },
  "colors.InlineFeedback.critical.icon": {
    "value": "var(--bxPeZQ)",
    "variable": "var(--bxPeZQ)"
  },
  "colors.InlineFeedback.critical.text": {
    "value": "var(--fwPeNK)",
    "variable": "var(--fwPeNK)"
  },
  "colors.InlineFeedback.info.icon": {
    "value": "var(--ieWlTV)",
    "variable": "var(--ieWlTV)"
  },
  "colors.InlineFeedback.transient.icon": {
    "value": "var(--YUNLn)",
    "variable": "var(--YUNLn)"
  },
  "colors.InlineFeedback.warning.icon": {
    "value": "var(--gqOPtB)",
    "variable": "var(--gqOPtB)"
  },
  "colors.Input.HelperArea.icon.default": {
    "value": "var(--bQcTpq)",
    "variable": "var(--bQcTpq)"
  },
  "colors.Input.HelperArea.icon.error": {
    "value": "var(--eLgmMh)",
    "variable": "var(--eLgmMh)"
  },
  "colors.Input.HelperArea.text.default": {
    "value": "var(--dAigKk)",
    "variable": "var(--dAigKk)"
  },
  "colors.Input.HelperArea.text.error": {
    "value": "var(--fOqIyP)",
    "variable": "var(--fOqIyP)"
  },
  "colors.Input.HelperArea.text.readOnly": {
    "value": "var(--goMhnJ)",
    "variable": "var(--goMhnJ)"
  },
  "colors.Input.bg.active": {
    "value": "var(--hglhTL)",
    "variable": "var(--hglhTL)"
  },
  "colors.Input.bg.autofill": {
    "value": "var(--eokPZj)",
    "variable": "var(--eokPZj)"
  },
  "colors.Input.bg.default": {
    "value": "var(--OCtIg)",
    "variable": "var(--OCtIg)"
  },
  "colors.Input.bg.error": {
    "value": "var(--kwaLaD)",
    "variable": "var(--kwaLaD)"
  },
  "colors.Input.bg.errorActive": {
    "value": "var(--hgBcTD)",
    "variable": "var(--hgBcTD)"
  },
  "colors.Input.bg.errorHover": {
    "value": "var(--PzODN)",
    "variable": "var(--PzODN)"
  },
  "colors.Input.bg.hover": {
    "value": "var(--brKooB)",
    "variable": "var(--brKooB)"
  },
  "colors.Input.border.default": {
    "value": "var(--lhtgsV)",
    "variable": "var(--lhtgsV)"
  },
  "colors.Input.border.error": {
    "value": "var(--oKXSe)",
    "variable": "var(--oKXSe)"
  },
  "colors.Input.border.errorActive": {
    "value": "var(--kUoYOi)",
    "variable": "var(--kUoYOi)"
  },
  "colors.Input.border.errorHover": {
    "value": "var(--iEVrhM)",
    "variable": "var(--iEVrhM)"
  },
  "colors.Input.border.hover": {
    "value": "var(--jqYOeQ)",
    "variable": "var(--jqYOeQ)"
  },
  "colors.Input.icon.leading.default": {
    "value": "var(--kKBDKX)",
    "variable": "var(--kKBDKX)"
  },
  "colors.Input.icon.leading.readOnly": {
    "value": "var(--ffTBdW)",
    "variable": "var(--ffTBdW)"
  },
  "colors.Input.icon.trailing.default": {
    "value": "var(--jwgxPB)",
    "variable": "var(--jwgxPB)"
  },
  "colors.Input.icon.trailing.readOnly": {
    "value": "var(--inIHms)",
    "variable": "var(--inIHms)"
  },
  "colors.Input.text.adornment.default": {
    "value": "var(--eIYqTR)",
    "variable": "var(--eIYqTR)"
  },
  "colors.Input.text.adornment.readOnly": {
    "value": "var(--fKzadg)",
    "variable": "var(--fKzadg)"
  },
  "colors.Input.text.placeholder": {
    "value": "var(--eaVZGE)",
    "variable": "var(--eaVZGE)"
  },
  "colors.Input.LabelArea.indicator.readOnly": {
    "value": "var(--kHUmId)",
    "variable": "var(--kHUmId)"
  },
  "colors.Input.LabelArea.indicator.required": {
    "value": "var(--cpUVhi)",
    "variable": "var(--cpUVhi)"
  },
  "colors.Label.indicator.required": {
    "value": "var(--jllKtm)",
    "variable": "var(--jllKtm)"
  },
  "colors.Label.indicator.readOnly": {
    "value": "var(--Jwwmx)",
    "variable": "var(--Jwwmx)"
  },
  "colors.Legend.indicator.required": {
    "value": "var(--nzWVd)",
    "variable": "var(--nzWVd)"
  },
  "colors.Menu.Heading.bg": {
    "value": "var(--dVaeXK)",
    "variable": "var(--dVaeXK)"
  },
  "colors.Menu.Heading.icon": {
    "value": "var(--hYEgmg)",
    "variable": "var(--hYEgmg)"
  },
  "colors.Menu.Heading.label": {
    "value": "var(--fnZllp)",
    "variable": "var(--fnZllp)"
  },
  "colors.Menu.Group.border": {
    "value": "var(--bOHJQo)",
    "variable": "var(--bOHJQo)"
  },
  "colors.Page.bg": {
    "value": "var(--bLpYgL)",
    "variable": "var(--bLpYgL)"
  },
  "colors.PhotoCarousel.Dots.bg.default": {
    "value": "var(--hqfquf)",
    "variable": "var(--hqfquf)"
  },
  "colors.Popover.Divider.bg.default": {
    "value": "var(--jNHZef)",
    "variable": "var(--jNHZef)"
  },
  "colors.Popover.Divider.bg.critical": {
    "value": "var(--fNFbav)",
    "variable": "var(--fNFbav)"
  },
  "colors.Popover.Divider.bg.success": {
    "value": "var(--jzzSFH)",
    "variable": "var(--jzzSFH)"
  },
  "colors.Popover.Divider.bg.info": {
    "value": "var(--dlWraq)",
    "variable": "var(--dlWraq)"
  },
  "colors.Popover.Divider.bg.warning": {
    "value": "var(--kKLPcS)",
    "variable": "var(--kKLPcS)"
  },
  "colors.Popover.Header.bg.critical": {
    "value": "var(--ftBzOl)",
    "variable": "var(--ftBzOl)"
  },
  "colors.Popover.Header.bg.success": {
    "value": "var(--kUfKmd)",
    "variable": "var(--kUfKmd)"
  },
  "colors.Popover.Header.bg.info": {
    "value": "var(--jgRbQg)",
    "variable": "var(--jgRbQg)"
  },
  "colors.Popover.Header.bg.warning": {
    "value": "var(--buTRwY)",
    "variable": "var(--buTRwY)"
  },
  "colors.Popover.Header.icon.critical": {
    "value": "var(--gGRhYD)",
    "variable": "var(--gGRhYD)"
  },
  "colors.Popover.Header.icon.info": {
    "value": "var(--kCvFVu)",
    "variable": "var(--kCvFVu)"
  },
  "colors.Popover.Header.icon.warning": {
    "value": "var(--hUbaAm)",
    "variable": "var(--hUbaAm)"
  },
  "colors.ProgressIndicator.bar.track.bg.default": {
    "value": "var(--iziakc)",
    "variable": "var(--iziakc)"
  },
  "colors.ProgressIndicator.bar.track.bg.active": {
    "value": "var(--gdzTkv)",
    "variable": "var(--gdzTkv)"
  },
  "colors.ProgressIndicator.bar.track.bg.complete": {
    "value": "var(--iuvRUG)",
    "variable": "var(--iuvRUG)"
  },
  "colors.ProgressMeter.Label.metaText": {
    "value": "var(--gNzIug)",
    "variable": "var(--gNzIug)"
  },
  "colors.ProgressMeter.Label.interactive.default": {
    "value": "var(--bwBHRm)",
    "variable": "var(--bwBHRm)"
  },
  "colors.ProgressMeter.Label.interactive.hover": {
    "value": "var(--ldySyv)",
    "variable": "var(--ldySyv)"
  },
  "colors.ProgressMeter.Label.interactive.pressed": {
    "value": "var(--fXkDWL)",
    "variable": "var(--fXkDWL)"
  },
  "colors.ProgressMeter.Label.static.complete": {
    "value": "var(--cvwRaA)",
    "variable": "var(--cvwRaA)"
  },
  "colors.ProgressMeter.Label.static.error": {
    "value": "var(--eRYGqB)",
    "variable": "var(--eRYGqB)"
  },
  "colors.ProgressMeter.Label.static.incomplete": {
    "value": "var(--ijLAvP)",
    "variable": "var(--ijLAvP)"
  },
  "colors.ProgressMeter.Label.static.success": {
    "value": "var(--deZCtK)",
    "variable": "var(--deZCtK)"
  },
  "colors.ProgressMeter.Label.static.warning": {
    "value": "var(--xXLdD)",
    "variable": "var(--xXLdD)"
  },
  "colors.ProgressMeter.Node.active.bg": {
    "value": "var(--idPRUS)",
    "variable": "var(--idPRUS)"
  },
  "colors.ProgressMeter.Node.active.border": {
    "value": "var(--iPtMCn)",
    "variable": "var(--iPtMCn)"
  },
  "colors.ProgressMeter.Node.active.icon": {
    "value": "var(--jWvxhE)",
    "variable": "var(--jWvxhE)"
  },
  "colors.ProgressMeter.Node.complete.bg": {
    "value": "var(--dggYXD)",
    "variable": "var(--dggYXD)"
  },
  "colors.ProgressMeter.Node.complete.icon": {
    "value": "var(--CYCzR)",
    "variable": "var(--CYCzR)"
  },
  "colors.ProgressMeter.Node.error.bg": {
    "value": "var(--eOwDcO)",
    "variable": "var(--eOwDcO)"
  },
  "colors.ProgressMeter.Node.error.icon": {
    "value": "var(--jmuxoM)",
    "variable": "var(--jmuxoM)"
  },
  "colors.ProgressMeter.Node.focusRing.bg": {
    "value": "var(--YEhbc)",
    "variable": "var(--YEhbc)"
  },
  "colors.ProgressMeter.Node.inactive.icon": {
    "value": "var(--iKRdfj)",
    "variable": "var(--iKRdfj)"
  },
  "colors.ProgressMeter.Node.incomplete.bg": {
    "value": "var(--HNqYo)",
    "variable": "var(--HNqYo)"
  },
  "colors.ProgressMeter.Node.incomplete.icon": {
    "value": "var(--bySdUW)",
    "variable": "var(--bySdUW)"
  },
  "colors.ProgressMeter.Node.success.bg": {
    "value": "var(--kLaSgd)",
    "variable": "var(--kLaSgd)"
  },
  "colors.ProgressMeter.Node.success.icon": {
    "value": "var(--hUdLtj)",
    "variable": "var(--hUdLtj)"
  },
  "colors.ProgressMeter.Node.warning.bg": {
    "value": "var(--jHVPEk)",
    "variable": "var(--jHVPEk)"
  },
  "colors.ProgressMeter.Node.warning.icon": {
    "value": "var(--bFEMLy)",
    "variable": "var(--bFEMLy)"
  },
  "colors.ProgressMeter.Track.active": {
    "value": "var(--ffwZid)",
    "variable": "var(--ffwZid)"
  },
  "colors.ProgressMeter.Track.default": {
    "value": "var(--cPPYJy)",
    "variable": "var(--cPPYJy)"
  },
  "colors.PropertyCard.PhotoFallback.bg": {
    "value": "var(--dOLVEi)",
    "variable": "var(--dOLVEi)"
  },
  "colors.PropertyCard.PhotoFallback.icon": {
    "value": "var(--gaMBEw)",
    "variable": "var(--gaMBEw)"
  },
  "colors.PropertyCard.Badge.buyAbility.bg": {
    "value": "var(--caSNtO)",
    "variable": "var(--caSNtO)"
  },
  "colors.PropertyCard.Badge.buyAbility.icon": {
    "value": "var(--CXik)",
    "variable": "var(--CXik)"
  },
  "colors.PropertyCard.Badge.buyAbility.label": {
    "value": "var(--gAvhZR)",
    "variable": "var(--gAvhZR)"
  },
  "colors.PropertyCard.Body.bg.default": {
    "value": "var(--dlguJk)",
    "variable": "var(--dlguJk)"
  },
  "colors.PropertyCard.Body.bg.hover": {
    "value": "var(--ftLLQt)",
    "variable": "var(--ftLLQt)"
  },
  "colors.PropertyCard.Body.bg.pressed": {
    "value": "var(--hfvKaR)",
    "variable": "var(--hfvKaR)"
  },
  "colors.Radio.border.hover": {
    "value": "var(--btPnnj)",
    "variable": "var(--btPnnj)"
  },
  "colors.Radio.border.pressed": {
    "value": "var(--dyfpcL)",
    "variable": "var(--dyfpcL)"
  },
  "colors.Range.Track.bg.default": {
    "value": "var(--CZXqL)",
    "variable": "var(--CZXqL)"
  },
  "colors.Range.Handle.bg.default": {
    "value": "var(--fGIQNK)",
    "variable": "var(--fGIQNK)"
  },
  "colors.Range.Handle.bg.hover": {
    "value": "var(--dbcdzz)",
    "variable": "var(--dbcdzz)"
  },
  "colors.Range.Handle.bg.pressed": {
    "value": "var(--ebIrOT)",
    "variable": "var(--ebIrOT)"
  },
  "colors.Range.Handle.bg.active": {
    "value": "var(--cbJvih)",
    "variable": "var(--cbJvih)"
  },
  "colors.Range.Handle.bg.activeHover": {
    "value": "var(--biVlqH)",
    "variable": "var(--biVlqH)"
  },
  "colors.Range.Handle.border.default": {
    "value": "var(--dtBogH)",
    "variable": "var(--dtBogH)"
  },
  "colors.Range.Handle.border.hover": {
    "value": "var(--brVsnq)",
    "variable": "var(--brVsnq)"
  },
  "colors.Range.Handle.border.active": {
    "value": "var(--aRoRI)",
    "variable": "var(--aRoRI)"
  },
  "colors.Range.Handle.border.pressed": {
    "value": "var(--hlmrDG)",
    "variable": "var(--hlmrDG)"
  },
  "colors.Range.Handle.border.activeHover": {
    "value": "var(--kusmi)",
    "variable": "var(--kusmi)"
  },
  "colors.RatingStars.icon.empty": {
    "value": "var(--dHeuIW)",
    "variable": "var(--dHeuIW)"
  },
  "colors.ShowHide.icon.default": {
    "value": "var(--emNfDr)",
    "variable": "var(--emNfDr)"
  },
  "colors.ShowHide.icon.hover": {
    "value": "var(--eiIJzK)",
    "variable": "var(--eiIJzK)"
  },
  "colors.ShowHide.icon.pressed": {
    "value": "var(--fgrLYW)",
    "variable": "var(--fgrLYW)"
  },
  "colors.ShowHide.label.default": {
    "value": "var(--bisxIq)",
    "variable": "var(--bisxIq)"
  },
  "colors.ShowHide.label.hover": {
    "value": "var(--jDTjpj)",
    "variable": "var(--jDTjpj)"
  },
  "colors.ShowHide.label.pressed": {
    "value": "var(--hkSKTb)",
    "variable": "var(--hkSKTb)"
  },
  "colors.Slider.Handle.bg.default": {
    "value": "var(--bYfyAc)",
    "variable": "var(--bYfyAc)"
  },
  "colors.Slider.Handle.bg.hover": {
    "value": "var(--kMPiCx)",
    "variable": "var(--kMPiCx)"
  },
  "colors.Slider.Handle.bg.pressed": {
    "value": "var(--knbjTt)",
    "variable": "var(--knbjTt)"
  },
  "colors.Slider.Handle.bg.active": {
    "value": "var(--cXQhSn)",
    "variable": "var(--cXQhSn)"
  },
  "colors.Slider.Handle.bg.activeHover": {
    "value": "var(--fwPveR)",
    "variable": "var(--fwPveR)"
  },
  "colors.Slider.Handle.bg.activePressed": {
    "value": "var(--iDOyGl)",
    "variable": "var(--iDOyGl)"
  },
  "colors.Slider.Handle.border.default": {
    "value": "var(--hZmgtN)",
    "variable": "var(--hZmgtN)"
  },
  "colors.Slider.Handle.border.hover": {
    "value": "var(--dmGSPA)",
    "variable": "var(--dmGSPA)"
  },
  "colors.Slider.Handle.border.active": {
    "value": "var(--hNBNly)",
    "variable": "var(--hNBNly)"
  },
  "colors.Slider.Handle.border.pressed": {
    "value": "var(--eYqQZY)",
    "variable": "var(--eYqQZY)"
  },
  "colors.Slider.Handle.border.activeHover": {
    "value": "var(--dqAxTo)",
    "variable": "var(--dqAxTo)"
  },
  "colors.Slider.Handle.border.activePressed": {
    "value": "var(--gTipEA)",
    "variable": "var(--gTipEA)"
  },
  "colors.Switch.Track.bg.default": {
    "value": "var(--dIODgW)",
    "variable": "var(--dIODgW)"
  },
  "colors.Switch.Track.bg.hover": {
    "value": "var(--gqdWqv)",
    "variable": "var(--gqdWqv)"
  },
  "colors.Switch.Track.bg.pressed": {
    "value": "var(--hqKkFP)",
    "variable": "var(--hqKkFP)"
  },
  "colors.Switch.Handle.default": {
    "value": "var(--kkhxuv)",
    "variable": "var(--kkhxuv)"
  },
  "colors.Switch.Handle.hover": {
    "value": "var(--gyUBqi)",
    "variable": "var(--gyUBqi)"
  },
  "colors.Switch.Handle.pressed": {
    "value": "var(--hwDDPu)",
    "variable": "var(--hwDDPu)"
  },
  "colors.Switch.Handle.selected": {
    "value": "var(--cepvqh)",
    "variable": "var(--cepvqh)"
  },
  "colors.Switch.Handle.selectedHover": {
    "value": "var(--jHRAub)",
    "variable": "var(--jHRAub)"
  },
  "colors.Switch.Handle.selectedPressed": {
    "value": "var(--keDXGH)",
    "variable": "var(--keDXGH)"
  },
  "colors.Table.Cell.bg.selected": {
    "value": "var(--dwWytd)",
    "variable": "var(--dwWytd)"
  },
  "colors.Table.Cell.bg.zebra": {
    "value": "var(--eCSyFm)",
    "variable": "var(--eCSyFm)"
  },
  "colors.Tabs.default.bg.indicator.default": {
    "value": "var(--gFySIE)",
    "variable": "var(--gFySIE)"
  },
  "colors.Tabs.default.bg.indicator.hover": {
    "value": "var(--gOGsWl)",
    "variable": "var(--gOGsWl)"
  },
  "colors.Tabs.default.bg.indicator.pressed": {
    "value": "var(--fSQxrh)",
    "variable": "var(--fSQxrh)"
  },
  "colors.Tabs.default.label.hover": {
    "value": "var(--jlNpkS)",
    "variable": "var(--jlNpkS)"
  },
  "colors.Tabs.default.label.pressed": {
    "value": "var(--Akghy)",
    "variable": "var(--Akghy)"
  },
  "colors.Tabs.default.label.selected.pressed": {
    "value": "var(--iRGRma)",
    "variable": "var(--iRGRma)"
  },
  "colors.Tabs.default.border.track": {
    "value": "var(--jyckBl)",
    "variable": "var(--jyckBl)"
  },
  "colors.Tabs.default.border.tab.default": {
    "value": "var(--jFYiWz)",
    "variable": "var(--jFYiWz)"
  },
  "colors.Tabs.default.border.tab.hover": {
    "value": "var(--cjoAPa)",
    "variable": "var(--cjoAPa)"
  },
  "colors.Tabs.default.border.tab.pressed": {
    "value": "var(--dWWFSu)",
    "variable": "var(--dWWFSu)"
  },
  "colors.Tabs.default.border.tab.active": {
    "value": "var(--emyaSU)",
    "variable": "var(--emyaSU)"
  },
  "colors.Tabs.default.icon.hover": {
    "value": "var(--DQBJD)",
    "variable": "var(--DQBJD)"
  },
  "colors.Tabs.default.icon.pressed": {
    "value": "var(--gQoMtT)",
    "variable": "var(--gQoMtT)"
  },
  "colors.Tabs.file.bg.indicator.default": {
    "value": "var(--iAxkUt)",
    "variable": "var(--iAxkUt)"
  },
  "colors.Tabs.file.bg.indicator.hover": {
    "value": "var(--jWFQrY)",
    "variable": "var(--jWFQrY)"
  },
  "colors.Tabs.file.bg.indicator.pressed": {
    "value": "var(--bOjkuw)",
    "variable": "var(--bOjkuw)"
  },
  "colors.Tabs.file.border.hover": {
    "value": "var(--kRgUzV)",
    "variable": "var(--kRgUzV)"
  },
  "colors.Tabs.file.border.pressed": {
    "value": "var(--krsVQR)",
    "variable": "var(--krsVQR)"
  },
  "colors.Tag.aqua.icon": {
    "value": "var(--hRsOVV)",
    "variable": "var(--hRsOVV)"
  },
  "colors.Tag.aqua.text": {
    "value": "var(--eAKXPj)",
    "variable": "var(--eAKXPj)"
  },
  "colors.Tag.blue.icon": {
    "value": "var(--iAwazT)",
    "variable": "var(--iAwazT)"
  },
  "colors.Tag.blue.text": {
    "value": "var(--iZtlwV)",
    "variable": "var(--iZtlwV)"
  },
  "colors.Tag.critical.bg": {
    "value": "var(--ikkSwc)",
    "variable": "var(--ikkSwc)"
  },
  "colors.Tag.critical.icon": {
    "value": "var(--gbVYqu)",
    "variable": "var(--gbVYqu)"
  },
  "colors.Tag.critical.text": {
    "value": "var(--evgaKs)",
    "variable": "var(--evgaKs)"
  },
  "colors.Tag.gray.icon": {
    "value": "var(--imrcQk)",
    "variable": "var(--imrcQk)"
  },
  "colors.Tag.gray.text": {
    "value": "var(--hERBxi)",
    "variable": "var(--hERBxi)"
  },
  "colors.Tag.green.icon": {
    "value": "var(--ccVHPa)",
    "variable": "var(--ccVHPa)"
  },
  "colors.Tag.green.text": {
    "value": "var(--dIsPLE)",
    "variable": "var(--dIsPLE)"
  },
  "colors.Tag.info.bg": {
    "value": "var(--cNhqNZ)",
    "variable": "var(--cNhqNZ)"
  },
  "colors.Tag.info.icon": {
    "value": "var(--hztXIz)",
    "variable": "var(--hztXIz)"
  },
  "colors.Tag.info.text": {
    "value": "var(--idlwjt)",
    "variable": "var(--idlwjt)"
  },
  "colors.Tag.orange.icon": {
    "value": "var(--moeFd)",
    "variable": "var(--moeFd)"
  },
  "colors.Tag.orange.text": {
    "value": "var(--cwOdQH)",
    "variable": "var(--cwOdQH)"
  },
  "colors.Tag.purple.icon": {
    "value": "var(--gNmDRL)",
    "variable": "var(--gNmDRL)"
  },
  "colors.Tag.purple.text": {
    "value": "var(--iQLDqx)",
    "variable": "var(--iQLDqx)"
  },
  "colors.Tag.red.icon": {
    "value": "var(--gukCaS)",
    "variable": "var(--gukCaS)"
  },
  "colors.Tag.red.text": {
    "value": "var(--csoOKQ)",
    "variable": "var(--csoOKQ)"
  },
  "colors.Tag.success.bg": {
    "value": "var(--bHzDGI)",
    "variable": "var(--bHzDGI)"
  },
  "colors.Tag.success.icon": {
    "value": "var(--fVboRG)",
    "variable": "var(--fVboRG)"
  },
  "colors.Tag.success.text": {
    "value": "var(--fxkLrM)",
    "variable": "var(--fxkLrM)"
  },
  "colors.Tag.teal.bg": {
    "value": "var(--cjucin)",
    "variable": "var(--cjucin)"
  },
  "colors.Tag.teal.icon": {
    "value": "var(--QQoZh)",
    "variable": "var(--QQoZh)"
  },
  "colors.Tag.teal.text": {
    "value": "var(--hovNHX)",
    "variable": "var(--hovNHX)"
  },
  "colors.Tag.warning.icon": {
    "value": "var(--hYiJVz)",
    "variable": "var(--hYiJVz)"
  },
  "colors.Tag.warning.text": {
    "value": "var(--ftPdTV)",
    "variable": "var(--ftPdTV)"
  },
  "colors.Tag.yellow.icon": {
    "value": "var(--hDhRDN)",
    "variable": "var(--hDhRDN)"
  },
  "colors.Tag.yellow.text": {
    "value": "var(--cycoFb)",
    "variable": "var(--cycoFb)"
  },
  "colors.TextButton.brand.label.default": {
    "value": "var(--iomHnc)",
    "variable": "var(--iomHnc)"
  },
  "colors.TextButton.brand.label.hover": {
    "value": "var(--iLtNoZ)",
    "variable": "var(--iLtNoZ)"
  },
  "colors.TextButton.brand.label.pressed": {
    "value": "var(--CXhrx)",
    "variable": "var(--CXhrx)"
  },
  "colors.TextButton.brand.icon.default": {
    "value": "var(--lnEPEZ)",
    "variable": "var(--lnEPEZ)"
  },
  "colors.TextButton.brand.icon.hover": {
    "value": "var(--goXzWM)",
    "variable": "var(--goXzWM)"
  },
  "colors.TextButton.brand.icon.pressed": {
    "value": "var(--gLJXjs)",
    "variable": "var(--gLJXjs)"
  },
  "colors.Toast.critical.bg": {
    "value": "var(--iLaoqv)",
    "variable": "var(--iLaoqv)"
  },
  "colors.Toast.critical.icon-leading": {
    "value": "var(--kMQaCQ)",
    "variable": "var(--kMQaCQ)"
  },
  "colors.Toast.info.bg": {
    "value": "var(--cTJZoi)",
    "variable": "var(--cTJZoi)"
  },
  "colors.Toast.info.icon-leading": {
    "value": "var(--lgxNGp)",
    "variable": "var(--lgxNGp)"
  },
  "colors.Toast.notify.bg": {
    "value": "var(--ccKrsf)",
    "variable": "var(--ccKrsf)"
  },
  "colors.Toast.notify.icon-leading": {
    "value": "var(--bfVZRM)",
    "variable": "var(--bfVZRM)"
  },
  "colors.Toast.success.bg": {
    "value": "var(--fgxGoL)",
    "variable": "var(--fgxGoL)"
  },
  "colors.Toast.success.icon-leading": {
    "value": "var(--gUkKUA)",
    "variable": "var(--gUkKUA)"
  },
  "colors.Toast.warning.bg": {
    "value": "var(--ecsEdy)",
    "variable": "var(--ecsEdy)"
  },
  "colors.Toast.warning.icon-leading": {
    "value": "var(--iJBzoZ)",
    "variable": "var(--iJBzoZ)"
  },
  "colors.ToggleButton.border.selectedHover": {
    "value": "var(--dabetf)",
    "variable": "var(--dabetf)"
  },
  "colors.ToggleButton.border.selectedPressed": {
    "value": "var(--hlrakz)",
    "variable": "var(--hlrakz)"
  },
  "colors.ToggleCard.Footer.border": {
    "value": "var(--ddLdHf)",
    "variable": "var(--ddLdHf)"
  },
  "colors.ToggleCard.Header.border": {
    "value": "var(--cbsYHF)",
    "variable": "var(--cbsYHF)"
  },
  "colors.ToggleCard.Root.neutral.bg.default": {
    "value": "var(--fAVrCD)",
    "variable": "var(--fAVrCD)"
  },
  "colors.ToggleCard.Root.neutral.bg.hover": {
    "value": "var(--eZLdEi)",
    "variable": "var(--eZLdEi)"
  },
  "colors.ToggleCard.Root.neutral.bg.pressed": {
    "value": "var(--iCsVpu)",
    "variable": "var(--iCsVpu)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.default": {
    "value": "var(--eWqipT)",
    "variable": "var(--eWqipT)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.hover": {
    "value": "var(--wPAXa)",
    "variable": "var(--wPAXa)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.pressed": {
    "value": "var(--aRaIS)",
    "variable": "var(--aRaIS)"
  },
  "colors.ToggleCard.Root.neutral.border.default": {
    "value": "var(--jOfbHW)",
    "variable": "var(--jOfbHW)"
  },
  "colors.ToggleCard.Root.neutral.border.hover": {
    "value": "var(--cBrLRT)",
    "variable": "var(--cBrLRT)"
  },
  "colors.ToggleCard.Root.neutral.border.pressed": {
    "value": "var(--kEzjGP)",
    "variable": "var(--kEzjGP)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.default": {
    "value": "var(--fNshEw)",
    "variable": "var(--fNshEw)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.hover": {
    "value": "var(--gLquJ)",
    "variable": "var(--gLquJ)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.pressed": {
    "value": "var(--KMQgB)",
    "variable": "var(--KMQgB)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.default": {
    "value": "var(--gtOKOA)",
    "variable": "var(--gtOKOA)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.hover": {
    "value": "var(--dsLJRl)",
    "variable": "var(--dsLJRl)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.pressed": {
    "value": "var(--glpuQV)",
    "variable": "var(--glpuQV)"
  },
  "colors.ToggleCard.Root.soft.bg.default": {
    "value": "var(--tBVjc)",
    "variable": "var(--tBVjc)"
  },
  "colors.ToggleCard.Root.soft.bg.hover": {
    "value": "var(--ijWbPh)",
    "variable": "var(--ijWbPh)"
  },
  "colors.ToggleCard.Root.soft.bg.pressed": {
    "value": "var(--jXEgSB)",
    "variable": "var(--jXEgSB)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.default": {
    "value": "var(--fYtbIQ)",
    "variable": "var(--fYtbIQ)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.hover": {
    "value": "var(--cHZAAh)",
    "variable": "var(--cHZAAh)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.pressed": {
    "value": "var(--dgjBgh)",
    "variable": "var(--dgjBgh)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.default": {
    "value": "var(--djnNhj)",
    "variable": "var(--djnNhj)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.hover": {
    "value": "var(--hRspre)",
    "variable": "var(--hRspre)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.pressed": {
    "value": "var(--ipCpXe)",
    "variable": "var(--ipCpXe)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.default": {
    "value": "var(--dwYnDn)",
    "variable": "var(--dwYnDn)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.hover": {
    "value": "var(--CSbzi)",
    "variable": "var(--CSbzi)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.pressed": {
    "value": "var(--kwgvZa)",
    "variable": "var(--kwgvZa)"
  },
  "colors.Tooltip.impact.bg": {
    "value": "var(--ewVNiK)",
    "variable": "var(--ewVNiK)"
  },
  "colors.TriggerText.border.default": {
    "value": "var(--kulyzW)",
    "variable": "var(--kulyzW)"
  },
  "colors.TriggerText.border.hover": {
    "value": "var(--liMlvv)",
    "variable": "var(--liMlvv)"
  },
  "colors.TriggerText.border.pressed": {
    "value": "var(--cxjcsb)",
    "variable": "var(--cxjcsb)"
  },
  "colors.UpsellBanner.Media.hero.icon": {
    "value": "var(--hufJtN)",
    "variable": "var(--hufJtN)"
  },
  "colors.UpsellBanner.Media.impact.icon": {
    "value": "var(--dhmCFv)",
    "variable": "var(--dhmCFv)"
  },
  "colors.UpsellBanner.Media.neutral.icon": {
    "value": "var(--egGtTI)",
    "variable": "var(--egGtTI)"
  },
  "colors.UpsellBanner.Media.soft.icon": {
    "value": "var(--ecmaMv)",
    "variable": "var(--ecmaMv)"
  },
  "colors.UpsellBanner.Root.hero.bg": {
    "value": "var(--dVEyiF)",
    "variable": "var(--dVEyiF)"
  },
  "colors.UpsellBanner.Root.soft.bg": {
    "value": "var(--kOgulf)",
    "variable": "var(--kOgulf)"
  },
  "colors.Upsell.Body.hero.text": {
    "value": "var(--csRIWL)",
    "variable": "var(--csRIWL)"
  },
  "colors.Upsell.Header.hero.text": {
    "value": "var(--bpRquA)",
    "variable": "var(--bpRquA)"
  },
  "colors.Upsell.Legal.hero.text-legal": {
    "value": "var(--bwTwdC)",
    "variable": "var(--bwTwdC)"
  },
  "colors.Upsell.Media.hero.icon": {
    "value": "var(--jgWcsF)",
    "variable": "var(--jgWcsF)"
  },
  "colors.Upsell.Media.impact.icon": {
    "value": "var(--hRyuXb)",
    "variable": "var(--hRyuXb)"
  },
  "colors.Upsell.Media.neutral.icon": {
    "value": "var(--fpkbxM)",
    "variable": "var(--fpkbxM)"
  },
  "colors.Upsell.Media.soft.icon": {
    "value": "var(--bRTojL)",
    "variable": "var(--bRTojL)"
  },
  "colors.Upsell.Root.hero.bg": {
    "value": "var(--cyfnkt)",
    "variable": "var(--cyfnkt)"
  },
  "colors.Upsell.Root.neutral.border": {
    "value": "var(--eMjaex)",
    "variable": "var(--eMjaex)"
  },
  "colors.Upsell.Root.neutral.elevated.bg": {
    "value": "var(--kSfVEf)",
    "variable": "var(--kSfVEf)"
  },
  "colors.Upsell.Root.neutral.elevated.border": {
    "value": "var(--iZlxau)",
    "variable": "var(--iZlxau)"
  },
  "colors.Upsell.Root.soft.bg": {
    "value": "var(--eSVKlz)",
    "variable": "var(--eSVKlz)"
  },
  "colors.ZillowLogo.brand-mark": {
    "value": "var(--kstXgG)",
    "variable": "var(--kstXgG)"
  },
  "colors.ZillowLogo.brand-text": {
    "value": "var(--irhiCq)",
    "variable": "var(--irhiCq)"
  },
  "colors.ZillowLogo.onImpact.brand-mark": {
    "value": "var(--kyjzjc)",
    "variable": "var(--kyjzjc)"
  },
  "colors.ZillowLogo.onImpact.brand-text": {
    "value": "var(--ZmWQg)",
    "variable": "var(--ZmWQg)"
  },
  "colors.ZillowLogo.legacy.brand-mark": {
    "value": "var(--jcQeUy)",
    "variable": "var(--jcQeUy)"
  },
  "colors.ZillowLogo.legacy.brand-text": {
    "value": "var(--bfTMzK)",
    "variable": "var(--bfTMzK)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-mark": {
    "value": "var(--brYIbQ)",
    "variable": "var(--brYIbQ)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-text": {
    "value": "var(--exftig)",
    "variable": "var(--exftig)"
  },
  "colors.transparent": {
    "value": "var(--edNtiq)",
    "variable": "var(--edNtiq)"
  },
  "colors.brand": {
    "value": "var(--hiaXtX)",
    "variable": "var(--hiaXtX)"
  },
  "colors.brandSecondary": {
    "value": "var(--hmKHmN)",
    "variable": "var(--hmKHmN)"
  },
  "colors.backgroundBrand": {
    "value": "var(--kldixN)",
    "variable": "var(--kldixN)"
  },
  "colors.textWhite": {
    "value": "var(--knlIAu)",
    "variable": "var(--knlIAu)"
  },
  "colors.textLight": {
    "value": "var(--fjTYzX)",
    "variable": "var(--fjTYzX)"
  },
  "colors.textMedium": {
    "value": "var(--fQDgBQ)",
    "variable": "var(--fQDgBQ)"
  },
  "colors.textDark": {
    "value": "var(--dHjKfd)",
    "variable": "var(--dHjKfd)"
  },
  "colors.link": {
    "value": "var(--fYfGw)",
    "variable": "var(--fYfGw)"
  },
  "colors.linkFocus": {
    "value": "var(--gBpyMs)",
    "variable": "var(--gBpyMs)"
  },
  "colors.linkInverse": {
    "value": "var(--iUVNvI)",
    "variable": "var(--iUVNvI)"
  },
  "colors.linkVisited": {
    "value": "var(--cYNNEU)",
    "variable": "var(--cYNNEU)"
  },
  "colors.linkHover": {
    "value": "var(--eKipSG)",
    "variable": "var(--eKipSG)"
  },
  "colors.linkActive": {
    "value": "var(--cPTyAI)",
    "variable": "var(--cPTyAI)"
  },
  "colors.backgroundAqua": {
    "value": "var(--cxnbem)",
    "variable": "var(--cxnbem)"
  },
  "colors.backgroundBlue": {
    "value": "var(--ibbYAU)",
    "variable": "var(--ibbYAU)"
  },
  "colors.backgroundGreen": {
    "value": "var(--jkGXUl)",
    "variable": "var(--jkGXUl)"
  },
  "colors.backgroundOrange": {
    "value": "var(--fflzqi)",
    "variable": "var(--fflzqi)"
  },
  "colors.backgroundOrangeRed": {
    "value": "var(--fKHctV)",
    "variable": "var(--fKHctV)"
  },
  "colors.backgroundPurple": {
    "value": "var(--iGoLvs)",
    "variable": "var(--iGoLvs)"
  },
  "colors.backgroundRed": {
    "value": "var(--hMmWiB)",
    "variable": "var(--hMmWiB)"
  },
  "colors.backgroundYellow": {
    "value": "var(--btfngK)",
    "variable": "var(--btfngK)"
  },
  "colors.backgroundDarkAqua": {
    "value": "var(--iRnQOq)",
    "variable": "var(--iRnQOq)"
  },
  "colors.backgroundDarkBlue": {
    "value": "var(--ldLWfM)",
    "variable": "var(--ldLWfM)"
  },
  "colors.backgroundDarkGreen": {
    "value": "var(--hempVt)",
    "variable": "var(--hempVt)"
  },
  "colors.backgroundDarkOrange": {
    "value": "var(--klIFOu)",
    "variable": "var(--klIFOu)"
  },
  "colors.backgroundDarkOrangeRed": {
    "value": "var(--glwVVB)",
    "variable": "var(--glwVVB)"
  },
  "colors.backgroundDarkPurple": {
    "value": "var(--iKaMpU)",
    "variable": "var(--iKaMpU)"
  },
  "colors.backgroundDarkRed": {
    "value": "var(--cHtJAp)",
    "variable": "var(--cHtJAp)"
  },
  "colors.backgroundDarkYellow": {
    "value": "var(--etCcJu)",
    "variable": "var(--etCcJu)"
  },
  "colors.backgroundWhite": {
    "value": "var(--hAUCbB)",
    "variable": "var(--hAUCbB)"
  },
  "colors.backgroundLight": {
    "value": "var(--kpIPsE)",
    "variable": "var(--kpIPsE)"
  },
  "colors.backgroundDark": {
    "value": "var(--frUaVO)",
    "variable": "var(--frUaVO)"
  },
  "colors.borderAqua": {
    "value": "var(--fEVneo)",
    "variable": "var(--fEVneo)"
  },
  "colors.borderBlue": {
    "value": "var(--bbPXxy)",
    "variable": "var(--bbPXxy)"
  },
  "colors.borderGreen": {
    "value": "var(--eZuzBL)",
    "variable": "var(--eZuzBL)"
  },
  "colors.borderOrange": {
    "value": "var(--jTvAKQ)",
    "variable": "var(--jTvAKQ)"
  },
  "colors.borderOrangeRed": {
    "value": "var(--iHVNKP)",
    "variable": "var(--iHVNKP)"
  },
  "colors.borderPurple": {
    "value": "var(--cBAHFi)",
    "variable": "var(--cBAHFi)"
  },
  "colors.borderRed": {
    "value": "var(--chxKZD)",
    "variable": "var(--chxKZD)"
  },
  "colors.borderYellow": {
    "value": "var(--httwpc)",
    "variable": "var(--httwpc)"
  },
  "colors.borderLight": {
    "value": "var(--dImOBy)",
    "variable": "var(--dImOBy)"
  },
  "colors.borderDark": {
    "value": "var(--ifVnKw)",
    "variable": "var(--ifVnKw)"
  },
  "colors.error.background": {
    "value": "var(--hFjlAf)",
    "variable": "var(--hFjlAf)"
  },
  "colors.error.border": {
    "value": "var(--jadEjl)",
    "variable": "var(--jadEjl)"
  },
  "colors.error.foreground": {
    "value": "var(--fKPBwG)",
    "variable": "var(--fKPBwG)"
  },
  "colors.error.fontColor": {
    "value": "var(--fhxUNr)",
    "variable": "var(--fhxUNr)"
  },
  "colors.error.darkBackground": {
    "value": "var(--kLqJsP)",
    "variable": "var(--kLqJsP)"
  },
  "colors.info.background": {
    "value": "var(--buksQJ)",
    "variable": "var(--buksQJ)"
  },
  "colors.info.border": {
    "value": "var(--gXApob)",
    "variable": "var(--gXApob)"
  },
  "colors.info.foreground": {
    "value": "var(--kByfIM)",
    "variable": "var(--kByfIM)"
  },
  "colors.info.fontColor": {
    "value": "var(--cFJHkt)",
    "variable": "var(--cFJHkt)"
  },
  "colors.info.darkBackground": {
    "value": "var(--dsqZqh)",
    "variable": "var(--dsqZqh)"
  },
  "colors.success.background": {
    "value": "var(--hWSJgE)",
    "variable": "var(--hWSJgE)"
  },
  "colors.success.border": {
    "value": "var(--byEAfG)",
    "variable": "var(--byEAfG)"
  },
  "colors.success.foreground": {
    "value": "var(--iWSXLF)",
    "variable": "var(--iWSXLF)"
  },
  "colors.success.fontColor": {
    "value": "var(--gubvTY)",
    "variable": "var(--gubvTY)"
  },
  "colors.success.darkBackground": {
    "value": "var(--guTiiA)",
    "variable": "var(--guTiiA)"
  },
  "colors.warning.background": {
    "value": "var(--hexVsx)",
    "variable": "var(--hexVsx)"
  },
  "colors.warning.border": {
    "value": "var(--jLpRzP)",
    "variable": "var(--jLpRzP)"
  },
  "colors.warning.foreground": {
    "value": "var(--bfegDw)",
    "variable": "var(--bfegDw)"
  },
  "colors.warning.fontColor": {
    "value": "var(--eNKoDl)",
    "variable": "var(--eNKoDl)"
  },
  "colors.warning.darkBackground": {
    "value": "var(--gXAwyt)",
    "variable": "var(--gXAwyt)"
  },
  "colors.transient.foreground": {
    "value": "var(--ikWdeC)",
    "variable": "var(--ikWdeC)"
  },
  "borderWidths.Chip.default": {
    "value": "var(--aLCbr)",
    "variable": "var(--aLCbr)"
  },
  "borderWidths.Input.active": {
    "value": "var(--kaSSkE)",
    "variable": "var(--kaSSkE)"
  },
  "borderWidths.Input.default": {
    "value": "var(--kEPqMP)",
    "variable": "var(--kEPqMP)"
  },
  "borderWidths.Range.Handle": {
    "value": "var(--cfgqVD)",
    "variable": "var(--cfgqVD)"
  },
  "borderWidths.Slider.Handle": {
    "value": "var(--cteWqt)",
    "variable": "var(--cteWqt)"
  },
  "borderWidths.ToggleCard.Root.selected": {
    "value": "var(--ktUXXu)",
    "variable": "var(--ktUXXu)"
  },
  "borderWidths.control.selected": {
    "value": "var(--kbWFes)",
    "variable": "var(--kbWFes)"
  },
  "borderWidths.default": {
    "value": "var(--lpfEoc)",
    "variable": "var(--lpfEoc)"
  },
  "borderWidths.none": {
    "value": "var(--dsAOAt)",
    "variable": "var(--dsAOAt)"
  },
  "borderWidths.thick": {
    "value": "var(--hiYFxW)",
    "variable": "var(--hiYFxW)"
  },
  "borderWidths.thicker": {
    "value": "var(--kXAhp)",
    "variable": "var(--kXAhp)"
  },
  "borderWidths.selected": {
    "value": "var(--eiLDDe)",
    "variable": "var(--eiLDDe)"
  },
  "borderWidths.xs": {
    "value": "var(--kYFOek)",
    "variable": "var(--kYFOek)"
  },
  "borderWidths.sm": {
    "value": "var(--cjTwZZ)",
    "variable": "var(--cjTwZZ)"
  },
  "borderWidths.md": {
    "value": "var(--dvTIcW)",
    "variable": "var(--dvTIcW)"
  },
  "borderWidths.lg": {
    "value": "var(--jBUvqk)",
    "variable": "var(--jBUvqk)"
  },
  "borderWidths.xl": {
    "value": "var(--hRTFLr)",
    "variable": "var(--hRTFLr)"
  },
  "radii.AdornedInput.md.messaging": {
    "value": "var(--fTGSrL)",
    "variable": "var(--fTGSrL)"
  },
  "radii.AdornedInput.lg.messaging": {
    "value": "var(--jSbJBp)",
    "variable": "var(--jSbJBp)"
  },
  "radii.Checkbox.box": {
    "value": "var(--jalZgm)",
    "variable": "var(--jalZgm)"
  },
  "radii.Input.md.messaging": {
    "value": "var(--eGquJs)",
    "variable": "var(--eGquJs)"
  },
  "radii.Input.lg.messaging": {
    "value": "var(--kIfwaS)",
    "variable": "var(--kIfwaS)"
  },
  "radii.Range.Handle": {
    "value": "var(--FzQWN)",
    "variable": "var(--FzQWN)"
  },
  "radii.Range.Track": {
    "value": "var(--fjlSyc)",
    "variable": "var(--fjlSyc)"
  },
  "radii.Tabs.indicator": {
    "value": "var(--ccRGcV)",
    "variable": "var(--ccRGcV)"
  },
  "radii.Tabs.panel": {
    "value": "var(--dfndQi)",
    "variable": "var(--dfndQi)"
  },
  "radii.Tag.sm": {
    "value": "var(--jmyGEM)",
    "variable": "var(--jmyGEM)"
  },
  "radii.Tag.md": {
    "value": "var(--fSJOMr)",
    "variable": "var(--fSJOMr)"
  },
  "radii.Tooltip": {
    "value": "var(--jtueqk)",
    "variable": "var(--jtueqk)"
  },
  "radii.none": {
    "value": "var(--dbrZvb)",
    "variable": "var(--dbrZvb)"
  },
  "radii.obj.sharp": {
    "value": "var(--fpBHJH)",
    "variable": "var(--fpBHJH)"
  },
  "radii.obj.default": {
    "value": "var(--jHyVPA)",
    "variable": "var(--jHyVPA)"
  },
  "radii.obj.soft": {
    "value": "var(--fCmAMJ)",
    "variable": "var(--fCmAMJ)"
  },
  "radii.obj.fullWidth": {
    "value": "var(--gZLdZu)",
    "variable": "var(--gZLdZu)"
  },
  "radii.obj.conjoined": {
    "value": "var(--cwEiYm)",
    "variable": "var(--cwEiYm)"
  },
  "radii.shape.capsule": {
    "value": "var(--dQcoKq)",
    "variable": "var(--dQcoKq)"
  },
  "radii.shape.ellipse": {
    "value": "var(--jrpiuh)",
    "variable": "var(--jrpiuh)"
  },
  "radii.shape.flexCapsule.md": {
    "value": "var(--WBpth)",
    "variable": "var(--WBpth)"
  },
  "radii.shape.flexCapsule.lg": {
    "value": "var(--esHWWX)",
    "variable": "var(--esHWWX)"
  },
  "radii.sheets.sharp": {
    "value": "var(--cvwjjs)",
    "variable": "var(--cvwjjs)"
  },
  "radii.sheets.default": {
    "value": "var(--fbfnkT)",
    "variable": "var(--fbfnkT)"
  },
  "radii.sm": {
    "value": "var(--bewZvn)",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "var(--kLOfAE)",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "var(--dxfumK)",
    "variable": "var(--dxfumK)"
  },
  "radii.pill": {
    "value": "var(--SqnIo)",
    "variable": "var(--SqnIo)"
  },
  "spacing.Accordion.Panel.padding.top": {
    "value": "var(--bZoLmy)",
    "variable": "var(--bZoLmy)"
  },
  "spacing.AdornedInput.sm.padding.vert": {
    "value": "var(--kwodqp)",
    "variable": "var(--kwodqp)"
  },
  "spacing.AdornedInput.md.padding.vert": {
    "value": "var(--hZgzVm)",
    "variable": "var(--hZgzVm)"
  },
  "spacing.Alert.gap.message.toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Alert.CloseButton.margin.top": {
    "value": "var(--gmvJmF)",
    "variable": "var(--gmvJmF)"
  },
  "spacing.Alert.CloseButton.margin.right": {
    "value": "var(--hCMzIC)",
    "variable": "var(--hCMzIC)"
  },
  "spacing.Avatar.Badge.padding.sm.default": {
    "value": "var(--iDvLBT)",
    "variable": "var(--iDvLBT)"
  },
  "spacing.Avatar.Badge.padding.md.default": {
    "value": "var(--gSeFVY)",
    "variable": "var(--gSeFVY)"
  },
  "spacing.Avatar.Badge.padding.md.bare": {
    "value": "var(--koIlbn)",
    "variable": "var(--koIlbn)"
  },
  "spacing.Avatar.Badge.padding.lg.default": {
    "value": "var(--vMQFG)",
    "variable": "var(--vMQFG)"
  },
  "spacing.Avatar.Badge.padding.lg.bare": {
    "value": "var(--KhwPF)",
    "variable": "var(--KhwPF)"
  },
  "spacing.Banner.CloseButton.margin.top": {
    "value": "var(--SaYWL)",
    "variable": "var(--SaYWL)"
  },
  "spacing.Banner.CloseButton.margin.right": {
    "value": "var(--hsjrNs)",
    "variable": "var(--hsjrNs)"
  },
  "spacing.ButtonGroup.gap.vert": {
    "value": "var(--hdUbmd)",
    "variable": "var(--hdUbmd)"
  },
  "spacing.ButtonGroup.textButton.padding.horz": {
    "value": "var(--hXLxzu)",
    "variable": "var(--hXLxzu)"
  },
  "spacing.ButtonGroup.textButton.padding.vert": {
    "value": "var(--gihyzU)",
    "variable": "var(--gihyzU)"
  },
  "spacing.Button.xs.padding.horz": {
    "value": "var(--evDSnJ)",
    "variable": "var(--evDSnJ)"
  },
  "spacing.Button.xs.padding.vert": {
    "value": "var(--krIemT)",
    "variable": "var(--krIemT)"
  },
  "spacing.Button.sm.padding.bare.horz": {
    "value": "var(--ldipmR)",
    "variable": "var(--ldipmR)"
  },
  "spacing.Button.sm.padding.vert": {
    "value": "var(--eoWFjK)",
    "variable": "var(--eoWFjK)"
  },
  "spacing.Button.md.padding.bare.horz": {
    "value": "var(--hHWvke)",
    "variable": "var(--hHWvke)"
  },
  "spacing.Button.md.padding.vert": {
    "value": "var(--hUZAHR)",
    "variable": "var(--hUZAHR)"
  },
  "spacing.Button.lg.padding.bare.horz": {
    "value": "var(--kxVnxc)",
    "variable": "var(--kxVnxc)"
  },
  "spacing.Carousel.Heading.gap.betweenNav": {
    "value": "var(--brfXwr)",
    "variable": "var(--brfXwr)"
  },
  "spacing.Chip.padding.horz": {
    "value": "var(--fTmwWf)",
    "variable": "var(--fTmwWf)"
  },
  "spacing.Chip.padding.vert": {
    "value": "var(--dgnWVZ)",
    "variable": "var(--dgnWVZ)"
  },
  "spacing.Chip.gap.inputChip-trailing": {
    "value": "var(--dLTNDs)",
    "variable": "var(--dLTNDs)"
  },
  "spacing.Chip.Close.padding": {
    "value": "var(--jdixam)",
    "variable": "var(--jdixam)"
  },
  "spacing.CloseButton.padding": {
    "value": "var(--hIkYOv)",
    "variable": "var(--hIkYOv)"
  },
  "spacing.CloseButton.margin": {
    "value": "var(--ioAyOA)",
    "variable": "var(--ioAyOA)"
  },
  "spacing.DateInput.sm.padding.vert": {
    "value": "var(--eiKHUu)",
    "variable": "var(--eiKHUu)"
  },
  "spacing.DateInput.md.gap.input-toAdornment": {
    "value": "var(--dZYgxr)",
    "variable": "var(--dZYgxr)"
  },
  "spacing.DateInput.md.padding.vert": {
    "value": "var(--iTcIJp)",
    "variable": "var(--iTcIJp)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.inner": {
    "value": "var(--buLcuL)",
    "variable": "var(--buLcuL)"
  },
  "spacing.FormField.HelperArea.gap.text-toCharCount": {
    "value": "var(--gKblKh)",
    "variable": "var(--gKblKh)"
  },
  "spacing.IconButton.xs.padding": {
    "value": "var(--gCvLoM)",
    "variable": "var(--gCvLoM)"
  },
  "spacing.IconButton.sm.padding": {
    "value": "var(--gCGMel)",
    "variable": "var(--gCGMel)"
  },
  "spacing.IconButton.md.padding": {
    "value": "var(--exmvqC)",
    "variable": "var(--exmvqC)"
  },
  "spacing.Input.sm.padding.vert": {
    "value": "var(--pVTga)",
    "variable": "var(--pVTga)"
  },
  "spacing.Input.md.padding.vert": {
    "value": "var(--jeiKV)",
    "variable": "var(--jeiKV)"
  },
  "spacing.LabeledControl.padding.vert.label": {
    "value": "var(--jjDwWg)",
    "variable": "var(--jjDwWg)"
  },
  "spacing.LabeledControl.padding.vert.switch.md": {
    "value": "var(--IfNwo)",
    "variable": "var(--IfNwo)"
  },
  "spacing.LabeledControl.padding.vert.switch.lg": {
    "value": "var(--jgSjDG)",
    "variable": "var(--jgSjDG)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.horz": {
    "value": "var(--jUawSX)",
    "variable": "var(--jUawSX)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.vert": {
    "value": "var(--lgwPIJ)",
    "variable": "var(--lgwPIJ)"
  },
  "spacing.Page.padding.horz.desktop": {
    "value": "var(--hnYpHx)",
    "variable": "var(--hnYpHx)"
  },
  "spacing.Page.padding.horz.tablet": {
    "value": "var(--iFMWbV)",
    "variable": "var(--iFMWbV)"
  },
  "spacing.Page.padding.horz.mobile": {
    "value": "var(--geTjSP)",
    "variable": "var(--geTjSP)"
  },
  "spacing.Page.Breadcrumb.margin.top.desktop": {
    "value": "var(--ifRZDY)",
    "variable": "var(--ifRZDY)"
  },
  "spacing.Page.Breadcrumb.margin.top.tablet": {
    "value": "var(--keLiNY)",
    "variable": "var(--keLiNY)"
  },
  "spacing.Page.Breadcrumb.margin.top.mobile": {
    "value": "var(--ejkCRy)",
    "variable": "var(--ejkCRy)"
  },
  "spacing.Page.Content.margin.vert.desktop": {
    "value": "var(--hMBFQY)",
    "variable": "var(--hMBFQY)"
  },
  "spacing.Page.Content.margin.vert.tablet": {
    "value": "var(--gIawWs)",
    "variable": "var(--gIawWs)"
  },
  "spacing.Page.Content.margin.vert.mobile": {
    "value": "var(--eNPPne)",
    "variable": "var(--eNPPne)"
  },
  "spacing.Page.Header.margin.bottom.desktop": {
    "value": "var(--kAkcVA)",
    "variable": "var(--kAkcVA)"
  },
  "spacing.Page.Header.margin.bottom.tablet": {
    "value": "var(--bzYExs)",
    "variable": "var(--bzYExs)"
  },
  "spacing.Page.Header.margin.bottom.mobile": {
    "value": "var(--fsQubG)",
    "variable": "var(--fsQubG)"
  },
  "spacing.Page.Header.margin.top.desktop": {
    "value": "var(--ifTgwQ)",
    "variable": "var(--ifTgwQ)"
  },
  "spacing.Page.Header.margin.top.tablet": {
    "value": "var(--hQAGNU)",
    "variable": "var(--hQAGNU)"
  },
  "spacing.Page.Header.margin.top.mobile": {
    "value": "var(--eeatXS)",
    "variable": "var(--eeatXS)"
  },
  "spacing.Pagination.JumpItem.padding.vert": {
    "value": "var(--cQtiUd)",
    "variable": "var(--cQtiUd)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.default": {
    "value": "var(--bTLfsn)",
    "variable": "var(--bTLfsn)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toIcon": {
    "value": "var(--hDVbwX)",
    "variable": "var(--hDVbwX)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.horz": {
    "value": "var(--gnCbqQ)",
    "variable": "var(--gnCbqQ)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.top": {
    "value": "var(--bsXpWo)",
    "variable": "var(--bsXpWo)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.bottom": {
    "value": "var(--iKVqPg)",
    "variable": "var(--iKVqPg)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.default": {
    "value": "var(--bdBQll)",
    "variable": "var(--bdBQll)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toIcon": {
    "value": "var(--hnhnEZ)",
    "variable": "var(--hnhnEZ)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.horz": {
    "value": "var(--bblBne)",
    "variable": "var(--bblBne)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.top": {
    "value": "var(--fppvLi)",
    "variable": "var(--fppvLi)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.bottom": {
    "value": "var(--cRlyXe)",
    "variable": "var(--cRlyXe)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.default": {
    "value": "var(--daEFPI)",
    "variable": "var(--daEFPI)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.horz": {
    "value": "var(--cTilsH)",
    "variable": "var(--cTilsH)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.top": {
    "value": "var(--eEJIpr)",
    "variable": "var(--eEJIpr)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.bottom": {
    "value": "var(--ZnlKz)",
    "variable": "var(--ZnlKz)"
  },
  "spacing.PropertyCard.FlexArea.padding.horz": {
    "value": "var(--gDXDFn)",
    "variable": "var(--gDXDFn)"
  },
  "spacing.PropertyCard.FlexArea.padding.vert": {
    "value": "var(--iBIBiJ)",
    "variable": "var(--iBIBiJ)"
  },
  "spacing.Range.Root.margin.vert": {
    "value": "var(--ebimgE)",
    "variable": "var(--ebimgE)"
  },
  "spacing.Range.Handle.margin.top": {
    "value": "var(--ckWLMC)",
    "variable": "var(--ckWLMC)"
  },
  "spacing.ShowHide.gap.label-toIcon": {
    "value": "var(--jjEfAp)",
    "variable": "var(--jjEfAp)"
  },
  "spacing.ShowHide.gap.button-toContent": {
    "value": "var(--ekXPFz)",
    "variable": "var(--ekXPFz)"
  },
  "spacing.Switch.Handle.lg.position.top": {
    "value": "var(--bnQnIW)",
    "variable": "var(--bnQnIW)"
  },
  "spacing.Tabs.padding.vert": {
    "value": "var(--khVvNT)",
    "variable": "var(--khVvNT)"
  },
  "spacing.Textarea.padding.vert": {
    "value": "var(--kVwiEp)",
    "variable": "var(--kVwiEp)"
  },
  "spacing.Toast.CloseButton.margin.top": {
    "value": "var(--gGJMCC)",
    "variable": "var(--gGJMCC)"
  },
  "spacing.Toast.CloseButton.margin.right": {
    "value": "var(--euRCSx)",
    "variable": "var(--euRCSx)"
  },
  "spacing.ToggleButton.sm.padding.vert": {
    "value": "var(--jNnzUs)",
    "variable": "var(--jNnzUs)"
  },
  "spacing.ToggleButton.md.padding.vert": {
    "value": "var(--dKVsMv)",
    "variable": "var(--dKVsMv)"
  },
  "spacing.UpsellBanner.CloseButton.margin.top": {
    "value": "var(--hJHynY)",
    "variable": "var(--hJHynY)"
  },
  "spacing.UpsellBanner.CloseButton.margin.right": {
    "value": "var(--cZWSCT)",
    "variable": "var(--cZWSCT)"
  },
  "spacing.Upsell.CloseButton.margin.top": {
    "value": "var(--wsvUA)",
    "variable": "var(--wsvUA)"
  },
  "spacing.Upsell.CloseButton.margin.right": {
    "value": "var(--bpUfxn)",
    "variable": "var(--bpUfxn)"
  },
  "spacing.device.margin.mobile": {
    "value": "var(--dPWswx)",
    "variable": "var(--dPWswx)"
  },
  "spacing.device.margin.tablet": {
    "value": "var(--cVXwjX)",
    "variable": "var(--cVXwjX)"
  },
  "spacing.device.margin.desktop": {
    "value": "var(--jMivYf)",
    "variable": "var(--jMivYf)"
  },
  "spacing.tightest": {
    "value": "var(--gOoWtX)",
    "variable": "var(--gOoWtX)"
  },
  "spacing.tighter": {
    "value": "var(--hLkrWi)",
    "variable": "var(--hLkrWi)"
  },
  "spacing.tight": {
    "value": "var(--jKknzl)",
    "variable": "var(--jKknzl)"
  },
  "spacing.default": {
    "value": "var(--hRrfDo)",
    "variable": "var(--hRrfDo)"
  },
  "spacing.loose": {
    "value": "var(--dmLIIl)",
    "variable": "var(--dmLIIl)"
  },
  "spacing.looser": {
    "value": "var(--bqtQgP)",
    "variable": "var(--bqtQgP)"
  },
  "spacing.none": {
    "value": "var(--jWXhYR)",
    "variable": "var(--jWXhYR)"
  },
  "spacing.conjoined-offsetBorder": {
    "value": "var(--gYvjwC)",
    "variable": "var(--gYvjwC)"
  },
  "spacing.layout.tightest": {
    "value": "var(--gilTII)",
    "variable": "var(--gilTII)"
  },
  "spacing.layout.tighter": {
    "value": "var(--icAmQN)",
    "variable": "var(--icAmQN)"
  },
  "spacing.layout.tight": {
    "value": "var(--btpFxC)",
    "variable": "var(--btpFxC)"
  },
  "spacing.layout.default": {
    "value": "var(--bArDtj)",
    "variable": "var(--bArDtj)"
  },
  "spacing.layout.loose": {
    "value": "var(--fgohXG)",
    "variable": "var(--fgohXG)"
  },
  "spacing.layout.looser": {
    "value": "var(--fpICwE)",
    "variable": "var(--fpICwE)"
  },
  "spacing.layout.loosest": {
    "value": "var(--fxUeRh)",
    "variable": "var(--fxUeRh)"
  },
  "spacing.layout.vast.default": {
    "value": "var(--dGXRfu)",
    "variable": "var(--dGXRfu)"
  },
  "spacing.layout.vast.loose": {
    "value": "var(--lfGjAb)",
    "variable": "var(--lfGjAb)"
  },
  "spacing.layout.vast.looser": {
    "value": "var(--ibzIPx)",
    "variable": "var(--ibzIPx)"
  },
  "spacing.micro.tight": {
    "value": "var(--gYfDtm)",
    "variable": "var(--gYfDtm)"
  },
  "spacing.micro.default": {
    "value": "var(--kbxbWf)",
    "variable": "var(--kbxbWf)"
  },
  "spacing.xxs": {
    "value": "var(--eooIFU)",
    "variable": "var(--eooIFU)"
  },
  "spacing.xs": {
    "value": "var(--icrUDE)",
    "variable": "var(--icrUDE)"
  },
  "spacing.sm": {
    "value": "var(--jolVMp)",
    "variable": "var(--jolVMp)"
  },
  "spacing.md": {
    "value": "var(--eEeglK)",
    "variable": "var(--eEeglK)"
  },
  "spacing.lg": {
    "value": "var(--fFUZAQ)",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.xl": {
    "value": "var(--gvVjyT)",
    "variable": "var(--gvVjyT)"
  },
  "sizes.Avatar.Icon.xs": {
    "value": "var(--ewEddJ)",
    "variable": "var(--ewEddJ)"
  },
  "sizes.Avatar.Icon.sm": {
    "value": "var(--khcRxE)",
    "variable": "var(--khcRxE)"
  },
  "sizes.Avatar.Icon.md": {
    "value": "var(--hWBBLz)",
    "variable": "var(--hWBBLz)"
  },
  "sizes.Avatar.Icon.lg": {
    "value": "var(--cWDtPR)",
    "variable": "var(--cWDtPR)"
  },
  "sizes.Avatar.Icon.xl": {
    "value": "var(--dshawy)",
    "variable": "var(--dshawy)"
  },
  "sizes.Avatar.Icon.xxl": {
    "value": "var(--lcJBNS)",
    "variable": "var(--lcJBNS)"
  },
  "sizes.Carousel.SkipLink.height": {
    "value": "var(--kXgqKa)",
    "variable": "var(--kXgqKa)"
  },
  "sizes.Checkbox.box": {
    "value": "var(--jbUpgn)",
    "variable": "var(--jbUpgn)"
  },
  "sizes.Checkbox.frame": {
    "value": "var(--hBAPyn)",
    "variable": "var(--hBAPyn)"
  },
  "sizes.Combobox.InputGroup.height.min": {
    "value": "var(--gOksDY)",
    "variable": "var(--gOksDY)"
  },
  "sizes.DatePicker.Trigger.icon.sm.width": {
    "value": "var(--bJDUoV)",
    "variable": "var(--bJDUoV)"
  },
  "sizes.DatePicker.Trigger.icon.sm.height": {
    "value": "var(--efyvIg)",
    "variable": "var(--efyvIg)"
  },
  "sizes.DatePicker.Trigger.icon.md.width": {
    "value": "var(--ekZyBu)",
    "variable": "var(--ekZyBu)"
  },
  "sizes.DatePicker.Trigger.icon.md.height": {
    "value": "var(--hyEPZD)",
    "variable": "var(--hyEPZD)"
  },
  "sizes.DatePicker.Trigger.icon.lg.width": {
    "value": "var(--hOPIlw)",
    "variable": "var(--hOPIlw)"
  },
  "sizes.DatePicker.Trigger.icon.lg.height": {
    "value": "var(--PwLKl)",
    "variable": "var(--PwLKl)"
  },
  "sizes.FieldSet.HelperArea.icon": {
    "value": "var(--bkAUeu)",
    "variable": "var(--bkAUeu)"
  },
  "sizes.ProgressIndicator.bar.sm.height": {
    "value": "var(--fhnQMh)",
    "variable": "var(--fhnQMh)"
  },
  "sizes.ProgressMeter.Node.default": {
    "value": "var(--ggItEB)",
    "variable": "var(--ggItEB)"
  },
  "sizes.ProgressMeter.Node.marker.notStarted": {
    "value": "var(--kwkVzV)",
    "variable": "var(--kwkVzV)"
  },
  "sizes.ProgressMeter.Node.focusRing.active": {
    "value": "var(--iRFNKx)",
    "variable": "var(--iRFNKx)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.hover": {
    "value": "var(--eDQhuB)",
    "variable": "var(--eDQhuB)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.pressed": {
    "value": "var(--fhRHgt)",
    "variable": "var(--fhRHgt)"
  },
  "sizes.ProgressMeter.Track.weight": {
    "value": "var(--eqycEp)",
    "variable": "var(--eqycEp)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.height": {
    "value": "var(--cihHaA)",
    "variable": "var(--cihHaA)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.width": {
    "value": "var(--cNIbLF)",
    "variable": "var(--cNIbLF)"
  },
  "sizes.PropertyCard.PhotoWrapper.large.minHeight": {
    "value": "var(--RlzHZ)",
    "variable": "var(--RlzHZ)"
  },
  "sizes.PropertyCard.PhotoWrapper.horizontal.minHeight": {
    "value": "var(--cntGKe)",
    "variable": "var(--cntGKe)"
  },
  "sizes.Radio.ring.height": {
    "value": "var(--gtIrDo)",
    "variable": "var(--gtIrDo)"
  },
  "sizes.Radio.ring.width": {
    "value": "var(--bgjqHN)",
    "variable": "var(--bgjqHN)"
  },
  "sizes.Range.Track.height": {
    "value": "var(--kbhKlv)",
    "variable": "var(--kbhKlv)"
  },
  "sizes.Range.Handle": {
    "value": "var(--CGjYo)",
    "variable": "var(--CGjYo)"
  },
  "sizes.Slider.Track.height": {
    "value": "var(--hbbpYZ)",
    "variable": "var(--hbbpYZ)"
  },
  "sizes.Switch.Track.md.width": {
    "value": "var(--bEARdv)",
    "variable": "var(--bEARdv)"
  },
  "sizes.Switch.Track.lg.height": {
    "value": "var(--bwJBOQ)",
    "variable": "var(--bwJBOQ)"
  },
  "sizes.Switch.Track.lg.width": {
    "value": "var(--ietjYl)",
    "variable": "var(--ietjYl)"
  },
  "sizes.action.xxs": {
    "value": "var(--llENfQ)",
    "variable": "var(--llENfQ)"
  },
  "sizes.action.xs": {
    "value": "var(--fgCUtQ)",
    "variable": "var(--fgCUtQ)"
  },
  "sizes.action.sm": {
    "value": "var(--kGaGYR)",
    "variable": "var(--kGaGYR)"
  },
  "sizes.action.md": {
    "value": "var(--fyDbHa)",
    "variable": "var(--fyDbHa)"
  },
  "sizes.action.lg": {
    "value": "var(--dJRBFQ)",
    "variable": "var(--dJRBFQ)"
  },
  "sizes.handle.xs": {
    "value": "var(--joRNEQ)",
    "variable": "var(--joRNEQ)"
  },
  "sizes.handle.sm": {
    "value": "var(--gUerdB)",
    "variable": "var(--gUerdB)"
  },
  "sizes.handle.md": {
    "value": "var(--gNFvIy)",
    "variable": "var(--gNFvIy)"
  },
  "sizes.handle.lg": {
    "value": "var(--hSguQQ)",
    "variable": "var(--hSguQQ)"
  },
  "sizes.handle.xl": {
    "value": "var(--fCZxcv)",
    "variable": "var(--fCZxcv)"
  },
  "sizes.icon.xs": {
    "value": "var(--giGyLp)",
    "variable": "var(--giGyLp)"
  },
  "sizes.icon.sm": {
    "value": "var(--crmrmM)",
    "variable": "var(--crmrmM)"
  },
  "sizes.icon.md": {
    "value": "var(--vmplf)",
    "variable": "var(--vmplf)"
  },
  "sizes.icon.lg": {
    "value": "var(--bVuKlx)",
    "variable": "var(--bVuKlx)"
  },
  "sizes.icon.xl": {
    "value": "var(--hhdBum)",
    "variable": "var(--hhdBum)"
  },
  "sizes.icon.xxl": {
    "value": "var(--cUyVZi)",
    "variable": "var(--cUyVZi)"
  },
  "sizes.indicator.xxs": {
    "value": "var(--kDfPQj)",
    "variable": "var(--kDfPQj)"
  },
  "sizes.indicator.xs": {
    "value": "var(--VdhvL)",
    "variable": "var(--VdhvL)"
  },
  "sizes.indicator.sm": {
    "value": "var(--gsYVrO)",
    "variable": "var(--gsYVrO)"
  },
  "sizes.indicator.md": {
    "value": "var(--bvLNhF)",
    "variable": "var(--bvLNhF)"
  },
  "sizes.indicator.lg": {
    "value": "var(--kNwmUb)",
    "variable": "var(--kNwmUb)"
  },
  "sizes.indicator.xl": {
    "value": "var(--coHsag)",
    "variable": "var(--coHsag)"
  },
  "sizes.obj.xxs": {
    "value": "var(--bDvoOh)",
    "variable": "var(--bDvoOh)"
  },
  "sizes.obj.xs": {
    "value": "var(--ciKIep)",
    "variable": "var(--ciKIep)"
  },
  "sizes.obj.sm": {
    "value": "var(--hQZIgs)",
    "variable": "var(--hQZIgs)"
  },
  "sizes.obj.md": {
    "value": "var(--cgsOGD)",
    "variable": "var(--cgsOGD)"
  },
  "sizes.obj.lg": {
    "value": "var(--iUaELB)",
    "variable": "var(--iUaELB)"
  },
  "sizes.obj.xl": {
    "value": "var(--evVWEO)",
    "variable": "var(--evVWEO)"
  },
  "sizes.obj.xxl": {
    "value": "var(--iWxXXu)",
    "variable": "var(--iWxXXu)"
  },
  "sizes.pipe.weight.default": {
    "value": "var(--htAnLf)",
    "variable": "var(--htAnLf)"
  },
  "sizes.pipe.weight.thick": {
    "value": "var(--WvteV)",
    "variable": "var(--WvteV)"
  },
  "sizes.pipe.weight.thicker": {
    "value": "var(--cAJcPK)",
    "variable": "var(--cAJcPK)"
  },
  "sizes.pipe.weight.thickest": {
    "value": "var(--bVWMaT)",
    "variable": "var(--bVWMaT)"
  },
  "sizes.tapArea.mobile.min": {
    "value": "var(--dXOMRQ)",
    "variable": "var(--dXOMRQ)"
  },
  "sizes.tapArea.mobile.sm": {
    "value": "var(--eJoNfE)",
    "variable": "var(--eJoNfE)"
  },
  "sizes.tapArea.mobile.default": {
    "value": "var(--hKlJFl)",
    "variable": "var(--hKlJFl)"
  },
  "sizes.tapArea.mobile.lg": {
    "value": "var(--hOxqih)",
    "variable": "var(--hOxqih)"
  },
  "sizes.xs": {
    "value": "var(--izvCpj)",
    "variable": "var(--izvCpj)"
  },
  "sizes.sm": {
    "value": "var(--aTIGG)",
    "variable": "var(--aTIGG)"
  },
  "sizes.md": {
    "value": "var(--kMQJUV)",
    "variable": "var(--kMQJUV)"
  },
  "sizes.lg": {
    "value": "var(--dyNKmL)",
    "variable": "var(--dyNKmL)"
  },
  "shadows.Card.Root.elevated.default": {
    "value": "var(--itMXXd)",
    "variable": "var(--itMXXd)"
  },
  "shadows.Card.Root.interactive.default": {
    "value": "var(--eeeUur)",
    "variable": "var(--eeeUur)"
  },
  "shadows.Card.Root.interactive.hover": {
    "value": "var(--btuNku)",
    "variable": "var(--btuNku)"
  },
  "shadows.Chip.elevated.hover": {
    "value": "var(--kGyefd)",
    "variable": "var(--kGyefd)"
  },
  "shadows.PhotoCarousel.NavControls": {
    "value": "var(--eCUnUz)",
    "variable": "var(--eCUnUz)"
  },
  "shadows.Popover.Content": {
    "value": "var(--bnEqCi)",
    "variable": "var(--bnEqCi)"
  },
  "shadows.PropertyCard.Body.default": {
    "value": "var(--bVmCBz)",
    "variable": "var(--bVmCBz)"
  },
  "shadows.PropertyCard.Body.hover": {
    "value": "var(--ZosNm)",
    "variable": "var(--ZosNm)"
  },
  "shadows.PropertyCard.SaveButton": {
    "value": "var(--iKRGbG)",
    "variable": "var(--iKRGbG)"
  },
  "shadows.Range.Handle.default": {
    "value": "var(--XGfNh)",
    "variable": "var(--XGfNh)"
  },
  "shadows.Range.Handle.hover": {
    "value": "var(--bEAhJI)",
    "variable": "var(--bEAhJI)"
  },
  "shadows.Range.Handle.pressed": {
    "value": "var(--cCjkiU)",
    "variable": "var(--cCjkiU)"
  },
  "shadows.Slider.Handle.default": {
    "value": "var(--fDASKP)",
    "variable": "var(--fDASKP)"
  },
  "shadows.Slider.Handle.hover": {
    "value": "var(--cHPzwS)",
    "variable": "var(--cHPzwS)"
  },
  "shadows.Slider.Handle.pressed": {
    "value": "var(--oPbaK)",
    "variable": "var(--oPbaK)"
  },
  "shadows.Toast": {
    "value": "var(--fLuEBe)",
    "variable": "var(--fLuEBe)"
  },
  "shadows.ToggleCard.Root.default": {
    "value": "var(--jhajuw)",
    "variable": "var(--jhajuw)"
  },
  "shadows.ToggleCard.Root.hover": {
    "value": "var(--iFqDKB)",
    "variable": "var(--iFqDKB)"
  },
  "shadows.Tooltip": {
    "value": "var(--guDbxS)",
    "variable": "var(--guDbxS)"
  },
  "shadows.Upsell.Root": {
    "value": "var(--eWnEfH)",
    "variable": "var(--eWnEfH)"
  },
  "transitions.ProgressMeter.Node.focusRing": {
    "value": "var(--dhpAGC)",
    "variable": "var(--dhpAGC)"
  },
  "opacity.invisible": {
    "value": "var(--cfgyPe)",
    "variable": "var(--cfgyPe)"
  },
  "opacity.disabled": {
    "value": "var(--kOrReb)",
    "variable": "var(--kOrReb)"
  },
  "opacity.dialogScrim": {
    "value": "var(--dhIIHR)",
    "variable": "var(--dhIIHR)"
  },
  "opacity.loadingMask": {
    "value": "var(--bjybDp)",
    "variable": "var(--bjybDp)"
  },
  "opacity.action.default": {
    "value": "var(--ZPhyz)",
    "variable": "var(--ZPhyz)"
  },
  "opacity.action.hover": {
    "value": "var(--bpPRxO)",
    "variable": "var(--bpPRxO)"
  },
  "opacity.action.pressed": {
    "value": "var(--flROfa)",
    "variable": "var(--flROfa)"
  },
  "opacity.action.active": {
    "value": "var(--bpTwww)",
    "variable": "var(--bpTwww)"
  },
  "opacity.action.focus": {
    "value": "var(--hKVYjA)",
    "variable": "var(--hKVYjA)"
  },
  "opacity.action.disabled": {
    "value": "var(--lfkYYk)",
    "variable": "var(--lfkYYk)"
  },
  "opacity.opacity100": {
    "value": "var(--iMbrnL)",
    "variable": "var(--iMbrnL)"
  },
  "opacity.opacity200": {
    "value": "var(--bKSpSA)",
    "variable": "var(--bKSpSA)"
  },
  "opacity.opacity300": {
    "value": "var(--lozTiR)",
    "variable": "var(--lozTiR)"
  },
  "opacity.opacity400": {
    "value": "var(--cUKiCm)",
    "variable": "var(--cUKiCm)"
  },
  "opacity.opacity500": {
    "value": "var(--biWctH)",
    "variable": "var(--biWctH)"
  },
  "opacity.mask": {
    "value": "var(--eDUDTr)",
    "variable": "var(--eDUDTr)"
  },
  "fonts.heading": {
    "value": "var(--bTZOq)",
    "variable": "var(--bTZOq)"
  },
  "fonts.heading-alt": {
    "value": "var(--eeBaXG)",
    "variable": "var(--eeBaXG)"
  },
  "fonts.default": {
    "value": "var(--faGMXV)",
    "variable": "var(--faGMXV)"
  },
  "fonts.sansSerif": {
    "value": "var(--gXAUcK)",
    "variable": "var(--gXAUcK)"
  },
  "fonts.serif": {
    "value": "var(--guQdxN)",
    "variable": "var(--guQdxN)"
  },
  "lineHeights.ProgressMeter.Label.default": {
    "value": "var(--iSveYP)",
    "variable": "var(--iSveYP)"
  },
  "lineHeights.heading-xl": {
    "value": "var(--dpmFeB)",
    "variable": "var(--dpmFeB)"
  },
  "lineHeights.heading-lg": {
    "value": "var(--jDQva)",
    "variable": "var(--jDQva)"
  },
  "lineHeights.heading-md": {
    "value": "var(--ikpxsU)",
    "variable": "var(--ikpxsU)"
  },
  "lineHeights.heading-sm": {
    "value": "var(--ggWjEj)",
    "variable": "var(--ggWjEj)"
  },
  "lineHeights.heading-xs": {
    "value": "var(--hnMgsC)",
    "variable": "var(--hnMgsC)"
  },
  "lineHeights.body-lg": {
    "value": "var(--knSypq)",
    "variable": "var(--knSypq)"
  },
  "lineHeights.body": {
    "value": "var(--jazbJU)",
    "variable": "var(--jazbJU)"
  },
  "lineHeights.body-sm": {
    "value": "var(--gfWCcb)",
    "variable": "var(--gfWCcb)"
  },
  "lineHeights.body-xs": {
    "value": "var(--bvvfpa)",
    "variable": "var(--bvvfpa)"
  },
  "lineHeights.fineprint": {
    "value": "var(--exfYFZ)",
    "variable": "var(--exfYFZ)"
  },
  "lineHeights.fineprint-sm": {
    "value": "var(--chYLmm)",
    "variable": "var(--chYLmm)"
  },
  "lineHeights.responsive.heading-xl.mobile": {
    "value": "var(--hQXSIF)",
    "variable": "var(--hQXSIF)"
  },
  "lineHeights.responsive.heading-xl.tablet": {
    "value": "var(--bidYkL)",
    "variable": "var(--bidYkL)"
  },
  "lineHeights.responsive.heading-xl.desktop": {
    "value": "var(--dFqQzH)",
    "variable": "var(--dFqQzH)"
  },
  "lineHeights.responsive.heading-lg.mobile": {
    "value": "var(--kzGagG)",
    "variable": "var(--kzGagG)"
  },
  "lineHeights.responsive.heading-lg.tablet": {
    "value": "var(--eAPGDU)",
    "variable": "var(--eAPGDU)"
  },
  "lineHeights.responsive.heading-lg.desktop": {
    "value": "var(--bfJCQc)",
    "variable": "var(--bfJCQc)"
  },
  "lineHeights.responsive.heading-md.mobile": {
    "value": "var(--kabIwI)",
    "variable": "var(--kabIwI)"
  },
  "lineHeights.responsive.heading-md.tablet": {
    "value": "var(--eqMJHm)",
    "variable": "var(--eqMJHm)"
  },
  "lineHeights.responsive.heading-md.desktop": {
    "value": "var(--ldjPvu)",
    "variable": "var(--ldjPvu)"
  },
  "lineHeights.responsive.heading-sm.mobile": {
    "value": "var(--XYQDP)",
    "variable": "var(--XYQDP)"
  },
  "lineHeights.responsive.heading-sm.tablet": {
    "value": "var(--bmAidl)",
    "variable": "var(--bmAidl)"
  },
  "lineHeights.responsive.heading-sm.desktop": {
    "value": "var(--fYFtpd)",
    "variable": "var(--fYFtpd)"
  },
  "lineHeights.responsive.heading-xs.mobile": {
    "value": "var(--lggUwa)",
    "variable": "var(--lggUwa)"
  },
  "lineHeights.responsive.heading-xs.tablet": {
    "value": "var(--fhqATo)",
    "variable": "var(--fhqATo)"
  },
  "lineHeights.responsive.heading-xs.desktop": {
    "value": "var(--hFfjYs)",
    "variable": "var(--hFfjYs)"
  },
  "lineHeights.responsive.body-lg.mobile": {
    "value": "var(--dUKSRe)",
    "variable": "var(--dUKSRe)"
  },
  "lineHeights.responsive.body-lg.tablet": {
    "value": "var(--exRiGk)",
    "variable": "var(--exRiGk)"
  },
  "lineHeights.responsive.body-lg.desktop": {
    "value": "var(--kBWicQ)",
    "variable": "var(--kBWicQ)"
  },
  "lineHeights.responsive.body.mobile": {
    "value": "var(--eABQhA)",
    "variable": "var(--eABQhA)"
  },
  "lineHeights.responsive.body.tablet": {
    "value": "var(--lokavO)",
    "variable": "var(--lokavO)"
  },
  "lineHeights.responsive.body.desktop": {
    "value": "var(--gjmpiK)",
    "variable": "var(--gjmpiK)"
  },
  "lineHeights.responsive.body-sm.mobile": {
    "value": "var(--jyshnb)",
    "variable": "var(--jyshnb)"
  },
  "lineHeights.responsive.body-sm.tablet": {
    "value": "var(--iduAgh)",
    "variable": "var(--iduAgh)"
  },
  "lineHeights.responsive.body-sm.desktop": {
    "value": "var(--cdePDt)",
    "variable": "var(--cdePDt)"
  },
  "lineHeights.responsive.body-xs.mobile": {
    "value": "var(--fMPWCq)",
    "variable": "var(--fMPWCq)"
  },
  "lineHeights.responsive.body-xs.tablet": {
    "value": "var(--gpWmrw)",
    "variable": "var(--gpWmrw)"
  },
  "lineHeights.responsive.body-xs.desktop": {
    "value": "var(--hxNKBw)",
    "variable": "var(--hxNKBw)"
  },
  "lineHeights.responsive.fineprint.mobile": {
    "value": "var(--eNRxEB)",
    "variable": "var(--eNRxEB)"
  },
  "lineHeights.responsive.fineprint.tablet": {
    "value": "var(--dmiIkb)",
    "variable": "var(--dmiIkb)"
  },
  "lineHeights.responsive.fineprint.desktop": {
    "value": "var(--xMjqH)",
    "variable": "var(--xMjqH)"
  },
  "lineHeights.responsive.fineprint-sm.mobile": {
    "value": "var(--iPmoLm)",
    "variable": "var(--iPmoLm)"
  },
  "lineHeights.responsive.fineprint-sm.tablet": {
    "value": "var(--bPlRcI)",
    "variable": "var(--bPlRcI)"
  },
  "lineHeights.responsive.fineprint-sm.desktop": {
    "value": "var(--bRNBaY)",
    "variable": "var(--bRNBaY)"
  },
  "lineHeights.h1": {
    "value": "var(--kxZHAB)",
    "variable": "var(--kxZHAB)"
  },
  "lineHeights.h2": {
    "value": "var(--kqjwdu)",
    "variable": "var(--kqjwdu)"
  },
  "lineHeights.h3": {
    "value": "var(--iEamkP)",
    "variable": "var(--iEamkP)"
  },
  "lineHeights.h4": {
    "value": "var(--jPBVgU)",
    "variable": "var(--jPBVgU)"
  },
  "lineHeights.h5": {
    "value": "var(--idsLop)",
    "variable": "var(--idsLop)"
  },
  "lineHeights.h6": {
    "value": "var(--hVCzRi)",
    "variable": "var(--hVCzRi)"
  },
  "lineHeights.bodyHeading": {
    "value": "var(--LBZKs)",
    "variable": "var(--LBZKs)"
  },
  "lineHeights.bodySmallHeading": {
    "value": "var(--hyhyFb)",
    "variable": "var(--hyhyFb)"
  },
  "lineHeights.bodySmall": {
    "value": "var(--hXGhPb)",
    "variable": "var(--hXGhPb)"
  },
  "lineHeights.finePrintHeading": {
    "value": "var(--fSYGNl)",
    "variable": "var(--fSYGNl)"
  },
  "lineHeights.legal": {
    "value": "var(--bHjNsX)",
    "variable": "var(--bHjNsX)"
  },
  "translate.Switch.Handle.md.x": {
    "value": "var(--hNpAdU)",
    "variable": "var(--hNpAdU)"
  },
  "translate.Switch.Handle.lg.x": {
    "value": "var(--cCdyhC)",
    "variable": "var(--cCdyhC)"
  },
  "fontSizes.heading-xl": {
    "value": "var(--jkUKjO)",
    "variable": "var(--jkUKjO)"
  },
  "fontSizes.heading-lg": {
    "value": "var(--wODFN)",
    "variable": "var(--wODFN)"
  },
  "fontSizes.heading-md": {
    "value": "var(--jlRGvD)",
    "variable": "var(--jlRGvD)"
  },
  "fontSizes.heading-sm": {
    "value": "var(--fJEwns)",
    "variable": "var(--fJEwns)"
  },
  "fontSizes.heading-xs": {
    "value": "var(--bWPmTF)",
    "variable": "var(--bWPmTF)"
  },
  "fontSizes.body-lg": {
    "value": "var(--knxioJ)",
    "variable": "var(--knxioJ)"
  },
  "fontSizes.body": {
    "value": "var(--jbcuDz)",
    "variable": "var(--jbcuDz)"
  },
  "fontSizes.body-sm": {
    "value": "var(--hMAEYg)",
    "variable": "var(--hMAEYg)"
  },
  "fontSizes.body-xs": {
    "value": "var(--eQVust)",
    "variable": "var(--eQVust)"
  },
  "fontSizes.fineprint": {
    "value": "var(--iYvKHe)",
    "variable": "var(--iYvKHe)"
  },
  "fontSizes.fineprint-sm": {
    "value": "var(--giwSB)",
    "variable": "var(--giwSB)"
  },
  "fontSizes.responsive.heading-xl.mobile": {
    "value": "var(--kRxMJK)",
    "variable": "var(--kRxMJK)"
  },
  "fontSizes.responsive.heading-xl.tablet": {
    "value": "var(--eRKlgc)",
    "variable": "var(--eRKlgc)"
  },
  "fontSizes.responsive.heading-xl.desktop": {
    "value": "var(--mSEbE)",
    "variable": "var(--mSEbE)"
  },
  "fontSizes.responsive.heading-lg.mobile": {
    "value": "var(--iYIkoh)",
    "variable": "var(--iYIkoh)"
  },
  "fontSizes.responsive.heading-lg.tablet": {
    "value": "var(--fWKNSv)",
    "variable": "var(--fWKNSv)"
  },
  "fontSizes.responsive.heading-lg.desktop": {
    "value": "var(--bjDorz)",
    "variable": "var(--bjDorz)"
  },
  "fontSizes.responsive.heading-md.mobile": {
    "value": "var(--lasoYv)",
    "variable": "var(--lasoYv)"
  },
  "fontSizes.responsive.heading-md.tablet": {
    "value": "var(--ixrhUp)",
    "variable": "var(--ixrhUp)"
  },
  "fontSizes.responsive.heading-md.desktop": {
    "value": "var(--bIAPMh)",
    "variable": "var(--bIAPMh)"
  },
  "fontSizes.responsive.heading-sm.mobile": {
    "value": "var(--fUIsIc)",
    "variable": "var(--fUIsIc)"
  },
  "fontSizes.responsive.heading-sm.tablet": {
    "value": "var(--dORBaq)",
    "variable": "var(--dORBaq)"
  },
  "fontSizes.responsive.heading-sm.desktop": {
    "value": "var(--dJHawG)",
    "variable": "var(--dJHawG)"
  },
  "fontSizes.responsive.heading-xs.mobile": {
    "value": "var(--cjtybl)",
    "variable": "var(--cjtybl)"
  },
  "fontSizes.responsive.heading-xs.tablet": {
    "value": "var(--kwRLev)",
    "variable": "var(--kwRLev)"
  },
  "fontSizes.responsive.heading-xs.desktop": {
    "value": "var(--bkXzof)",
    "variable": "var(--bkXzof)"
  },
  "fontSizes.responsive.body-lg.mobile": {
    "value": "var(--hiipxl)",
    "variable": "var(--hiipxl)"
  },
  "fontSizes.responsive.body-lg.tablet": {
    "value": "var(--eMnsNH)",
    "variable": "var(--eMnsNH)"
  },
  "fontSizes.responsive.body-lg.desktop": {
    "value": "var(--ajrRP)",
    "variable": "var(--ajrRP)"
  },
  "fontSizes.responsive.body.mobile": {
    "value": "var(--eZoqIz)",
    "variable": "var(--eZoqIz)"
  },
  "fontSizes.responsive.body.tablet": {
    "value": "var(--duweRp)",
    "variable": "var(--duweRp)"
  },
  "fontSizes.responsive.body.desktop": {
    "value": "var(--dxsbMl)",
    "variable": "var(--dxsbMl)"
  },
  "fontSizes.responsive.body-sm.mobile": {
    "value": "var(--drlkDU)",
    "variable": "var(--drlkDU)"
  },
  "fontSizes.responsive.body-sm.tablet": {
    "value": "var(--eRVdWi)",
    "variable": "var(--eRVdWi)"
  },
  "fontSizes.responsive.body-sm.desktop": {
    "value": "var(--fuBEWa)",
    "variable": "var(--fuBEWa)"
  },
  "fontSizes.responsive.body-xs.mobile": {
    "value": "var(--jBmgzZ)",
    "variable": "var(--jBmgzZ)"
  },
  "fontSizes.responsive.body-xs.tablet": {
    "value": "var(--hfrjQv)",
    "variable": "var(--hfrjQv)"
  },
  "fontSizes.responsive.body-xs.desktop": {
    "value": "var(--eEINdP)",
    "variable": "var(--eEINdP)"
  },
  "fontSizes.responsive.fineprint.mobile": {
    "value": "var(--hSLAUm)",
    "variable": "var(--hSLAUm)"
  },
  "fontSizes.responsive.fineprint.tablet": {
    "value": "var(--gseRFs)",
    "variable": "var(--gseRFs)"
  },
  "fontSizes.responsive.fineprint.desktop": {
    "value": "var(--cGFvRk)",
    "variable": "var(--cGFvRk)"
  },
  "fontSizes.responsive.fineprint-sm.mobile": {
    "value": "var(--boQjUV)",
    "variable": "var(--boQjUV)"
  },
  "fontSizes.responsive.fineprint-sm.tablet": {
    "value": "var(--cleidb)",
    "variable": "var(--cleidb)"
  },
  "fontSizes.responsive.fineprint-sm.desktop": {
    "value": "var(--fhrIFz)",
    "variable": "var(--fhrIFz)"
  },
  "fontSizes.h1": {
    "value": "var(--ePchQC)",
    "variable": "var(--ePchQC)"
  },
  "fontSizes.h2": {
    "value": "var(--vgpah)",
    "variable": "var(--vgpah)"
  },
  "fontSizes.h3": {
    "value": "var(--dskZkE)",
    "variable": "var(--dskZkE)"
  },
  "fontSizes.h4": {
    "value": "var(--bFpHWH)",
    "variable": "var(--bFpHWH)"
  },
  "fontSizes.h5": {
    "value": "var(--eCushe)",
    "variable": "var(--eCushe)"
  },
  "fontSizes.h6": {
    "value": "var(--iyzqJ)",
    "variable": "var(--iyzqJ)"
  },
  "fontSizes.bodyHeading": {
    "value": "var(--dFinpz)",
    "variable": "var(--dFinpz)"
  },
  "fontSizes.bodySmallHeading": {
    "value": "var(--jDYsEY)",
    "variable": "var(--jDYsEY)"
  },
  "fontSizes.bodySmall": {
    "value": "var(--esoDCI)",
    "variable": "var(--esoDCI)"
  },
  "fontSizes.finePrintHeading": {
    "value": "var(--fCZEi)",
    "variable": "var(--fCZEi)"
  },
  "fontSizes.legal": {
    "value": "var(--htyijA)",
    "variable": "var(--htyijA)"
  },
  "letterSpacings.heading-xl": {
    "value": "var(--flpzqL)",
    "variable": "var(--flpzqL)"
  },
  "letterSpacings.heading-lg": {
    "value": "var(--hqfldE)",
    "variable": "var(--hqfldE)"
  },
  "letterSpacings.heading-md": {
    "value": "var(--jxKnpS)",
    "variable": "var(--jxKnpS)"
  },
  "letterSpacings.heading-sm": {
    "value": "var(--juMFuF)",
    "variable": "var(--juMFuF)"
  },
  "letterSpacings.heading-xs": {
    "value": "var(--kyBLSQ)",
    "variable": "var(--kyBLSQ)"
  },
  "letterSpacings.body-lg": {
    "value": "var(--bbcvwk)",
    "variable": "var(--bbcvwk)"
  },
  "letterSpacings.body": {
    "value": "var(--kngkcm)",
    "variable": "var(--kngkcm)"
  },
  "letterSpacings.body-sm": {
    "value": "var(--fHcIKx)",
    "variable": "var(--fHcIKx)"
  },
  "letterSpacings.body-xs": {
    "value": "var(--ifkLtM)",
    "variable": "var(--ifkLtM)"
  },
  "letterSpacings.fineprint": {
    "value": "var(--jyIyX)",
    "variable": "var(--jyIyX)"
  },
  "letterSpacings.fineprint-sm": {
    "value": "var(--dFTYEk)",
    "variable": "var(--dFTYEk)"
  },
  "letterSpacings.responsive.heading-xl.mobile": {
    "value": "var(--kJxXVn)",
    "variable": "var(--kJxXVn)"
  },
  "letterSpacings.responsive.heading-xl.tablet": {
    "value": "var(--gicRqZ)",
    "variable": "var(--gicRqZ)"
  },
  "letterSpacings.responsive.heading-xl.desktop": {
    "value": "var(--eFqxBp)",
    "variable": "var(--eFqxBp)"
  },
  "letterSpacings.responsive.heading-lg.mobile": {
    "value": "var(--bWDTIE)",
    "variable": "var(--bWDTIE)"
  },
  "letterSpacings.responsive.heading-lg.tablet": {
    "value": "var(--jJdjBq)",
    "variable": "var(--jJdjBq)"
  },
  "letterSpacings.responsive.heading-lg.desktop": {
    "value": "var(--jCqaPW)",
    "variable": "var(--jCqaPW)"
  },
  "letterSpacings.responsive.heading-md.mobile": {
    "value": "var(--fZWwFi)",
    "variable": "var(--fZWwFi)"
  },
  "letterSpacings.responsive.heading-md.tablet": {
    "value": "var(--lgOMmU)",
    "variable": "var(--lgOMmU)"
  },
  "letterSpacings.responsive.heading-md.desktop": {
    "value": "var(--kaXXAo)",
    "variable": "var(--kaXXAo)"
  },
  "letterSpacings.responsive.heading-sm.mobile": {
    "value": "var(--bFvChx)",
    "variable": "var(--bFvChx)"
  },
  "letterSpacings.responsive.heading-sm.tablet": {
    "value": "var(--hlGFAr)",
    "variable": "var(--hlGFAr)"
  },
  "letterSpacings.responsive.heading-sm.desktop": {
    "value": "var(--eoqSYP)",
    "variable": "var(--eoqSYP)"
  },
  "letterSpacings.responsive.heading-xs.mobile": {
    "value": "var(--fKaJFA)",
    "variable": "var(--fKaJFA)"
  },
  "letterSpacings.responsive.heading-xs.tablet": {
    "value": "var(--chepZq)",
    "variable": "var(--chepZq)"
  },
  "letterSpacings.responsive.heading-xs.desktop": {
    "value": "var(--doEamu)",
    "variable": "var(--doEamu)"
  },
  "letterSpacings.responsive.body-lg.mobile": {
    "value": "var(--gvzGXA)",
    "variable": "var(--gvzGXA)"
  },
  "letterSpacings.responsive.body-lg.tablet": {
    "value": "var(--grqAJi)",
    "variable": "var(--grqAJi)"
  },
  "letterSpacings.responsive.body-lg.desktop": {
    "value": "var(--fodThG)",
    "variable": "var(--fodThG)"
  },
  "letterSpacings.responsive.body.mobile": {
    "value": "var(--LWGYa)",
    "variable": "var(--LWGYa)"
  },
  "letterSpacings.responsive.body.tablet": {
    "value": "var(--iQmDyY)",
    "variable": "var(--iQmDyY)"
  },
  "letterSpacings.responsive.body.desktop": {
    "value": "var(--jEDLpE)",
    "variable": "var(--jEDLpE)"
  },
  "letterSpacings.responsive.body-sm.mobile": {
    "value": "var(--hQWGOB)",
    "variable": "var(--hQWGOB)"
  },
  "letterSpacings.responsive.body-sm.tablet": {
    "value": "var(--gzLjRL)",
    "variable": "var(--gzLjRL)"
  },
  "letterSpacings.responsive.body-sm.desktop": {
    "value": "var(--iajRAX)",
    "variable": "var(--iajRAX)"
  },
  "letterSpacings.responsive.body-xs.mobile": {
    "value": "var(--hcaBmU)",
    "variable": "var(--hcaBmU)"
  },
  "letterSpacings.responsive.body-xs.tablet": {
    "value": "var(--gXRuYC)",
    "variable": "var(--gXRuYC)"
  },
  "letterSpacings.responsive.body-xs.desktop": {
    "value": "var(--ydQRa)",
    "variable": "var(--ydQRa)"
  },
  "letterSpacings.responsive.fineprint.mobile": {
    "value": "var(--ijLumD)",
    "variable": "var(--ijLumD)"
  },
  "letterSpacings.responsive.fineprint.tablet": {
    "value": "var(--GmMLJ)",
    "variable": "var(--GmMLJ)"
  },
  "letterSpacings.responsive.fineprint.desktop": {
    "value": "var(--bwmcEN)",
    "variable": "var(--bwmcEN)"
  },
  "letterSpacings.responsive.fineprint-sm.mobile": {
    "value": "var(--eAnWlc)",
    "variable": "var(--eAnWlc)"
  },
  "letterSpacings.responsive.fineprint-sm.tablet": {
    "value": "var(--fwQTvG)",
    "variable": "var(--fwQTvG)"
  },
  "letterSpacings.responsive.fineprint-sm.desktop": {
    "value": "var(--dXvcDO)",
    "variable": "var(--dXvcDO)"
  },
  "fontWeights.h0": {
    "value": "var(--PRIrC)",
    "variable": "var(--PRIrC)"
  },
  "fontWeights.h1": {
    "value": "var(--ktvyyX)",
    "variable": "var(--ktvyyX)"
  },
  "fontWeights.h2": {
    "value": "var(--kkImtw)",
    "variable": "var(--kkImtw)"
  },
  "fontWeights.h3": {
    "value": "var(--iyQtbV)",
    "variable": "var(--iyQtbV)"
  },
  "fontWeights.h4": {
    "value": "var(--jLRVWe)",
    "variable": "var(--jLRVWe)"
  },
  "fontWeights.h5": {
    "value": "var(--iaacED)",
    "variable": "var(--iaacED)"
  },
  "fontWeights.h6": {
    "value": "var(--hRmQzc)",
    "variable": "var(--hRmQzc)"
  },
  "fontWeights.bodyHeading": {
    "value": "var(--HVSsi)",
    "variable": "var(--HVSsi)"
  },
  "fontWeights.bodySmallHeading": {
    "value": "var(--hDaZht)",
    "variable": "var(--hDaZht)"
  },
  "fontWeights.bodySmall": {
    "value": "var(--hYHEsF)",
    "variable": "var(--hYHEsF)"
  },
  "fontWeights.finePrintHeading": {
    "value": "var(--fPHXdP)",
    "variable": "var(--fPHXdP)"
  },
  "fontWeights.legal": {
    "value": "var(--bKRNDx)",
    "variable": "var(--bKRNDx)"
  },
  "colors.dataViz.sequential.insight.onA": {
    "value": "var(--fDmbgj)",
    "variable": "var(--fDmbgj)"
  },
  "colors.dataViz.sequential.insight.onB": {
    "value": "var(--dHrhUk)",
    "variable": "var(--dHrhUk)"
  },
  "colors.dataViz.sequential.insight.onC": {
    "value": "var(--ifYNAB)",
    "variable": "var(--ifYNAB)"
  },
  "colors.dataViz.sequential.insight.onD": {
    "value": "var(--bMjbCu)",
    "variable": "var(--bMjbCu)"
  },
  "colors.dataViz.sequential.insight.onE": {
    "value": "var(--elgqAn)",
    "variable": "var(--elgqAn)"
  },
  "colors.dataViz.sequential.insight.onF": {
    "value": "var(--cplxoo)",
    "variable": "var(--cplxoo)"
  },
  "colors.dataViz.sequential.insight.onG": {
    "value": "var(--gNTcUF)",
    "variable": "var(--gNTcUF)"
  },
  "colors.dataViz.sequential.insight.onH": {
    "value": "var(--iMHmQq)",
    "variable": "var(--iMHmQq)"
  },
  "colors.dataViz.sequential.insight.onI": {
    "value": "var(--llEBOj)",
    "variable": "var(--llEBOj)"
  },
  "colors.dataViz.sequential.insight.onJ": {
    "value": "var(--jpJICk)",
    "variable": "var(--jpJICk)"
  },
  "colors.dataViz.sequential.insight.onA-hero": {
    "value": "var(--ghqkiS)",
    "variable": "var(--ghqkiS)"
  },
  "colors.dataViz.sequential.insight.onB-hero": {
    "value": "var(--gfLedt)",
    "variable": "var(--gfLedt)"
  },
  "colors.dataViz.sequential.insight.onC-hero": {
    "value": "var(--dBAfNY)",
    "variable": "var(--dBAfNY)"
  },
  "colors.dataViz.sequential.insight.onD-hero": {
    "value": "var(--kdGTej)",
    "variable": "var(--kdGTej)"
  },
  "colors.dataViz.sequential.insight.onE-hero": {
    "value": "var(--hzvUOO)",
    "variable": "var(--hzvUOO)"
  },
  "colors.dataViz.sequential.insight.onF-hero": {
    "value": "var(--hxQOJp)",
    "variable": "var(--hxQOJp)"
  },
  "colors.dataViz.sequential.insight.onG-hero": {
    "value": "var(--eTFQtU)",
    "variable": "var(--eTFQtU)"
  },
  "colors.dataViz.sequential.insight.onH-hero": {
    "value": "var(--ddiHQn)",
    "variable": "var(--ddiHQn)"
  },
  "colors.dataViz.sequential.insight.onI-hero": {
    "value": "var(--yXJAS)",
    "variable": "var(--yXJAS)"
  },
  "colors.dataViz.sequential.insight.onJ-hero": {
    "value": "var(--xsDvt)",
    "variable": "var(--xsDvt)"
  },
  "colors.border.action.disabled": {
    "value": "var(--enPcae)",
    "variable": "var(--enPcae)"
  },
  "colors.border.action.disabled-alt": {
    "value": "var(--hWqCKa)",
    "variable": "var(--hWqCKa)"
  },
  "colors.icon.onHero.link.fixed.default": {
    "value": "var(--gdDnhL)",
    "variable": "var(--gdDnhL)"
  },
  "colors.icon.onHero.link.fixed.hover": {
    "value": "var(--bJnjrO)",
    "variable": "var(--bJnjrO)"
  },
  "colors.icon.onHero.link.fixed.pressed": {
    "value": "var(--eQmmTi)",
    "variable": "var(--eQmmTi)"
  },
  "colors.icon.onImpact.express.energy.hero": {
    "value": "var(--cOQDtA)",
    "variable": "var(--cOQDtA)"
  },
  "colors.text.link.selected": {
    "value": "var(--jZEbSY)",
    "variable": "var(--jZEbSY)"
  },
  "colors.Accordion.Panel.icon.leading": {
    "value": "var(--btikik)",
    "variable": "var(--btikik)"
  },
  "colors.Accordion.Panel.icon.trailing": {
    "value": "var(--ceQZPa)",
    "variable": "var(--ceQZPa)"
  },
  "colors.Accordion.Panel.label.default": {
    "value": "var(--lidBZu)",
    "variable": "var(--lidBZu)"
  },
  "colors.Accordion.Panel.label.trailing": {
    "value": "var(--iQQUGj)",
    "variable": "var(--iQQUGj)"
  },
  "colors.DatePicker.InputGroup.bg.autofill": {
    "value": "var(--ewRzlP)",
    "variable": "var(--ewRzlP)"
  },
  "colors.DatePicker.InputGroup.text.adornment.default": {
    "value": "var(--bqXgTl)",
    "variable": "var(--bqXgTl)"
  },
  "colors.DatePicker.InputGroup.text.adornment.readOnly": {
    "value": "var(--hjjkGc)",
    "variable": "var(--hjjkGc)"
  },
  "colors.FieldSet.helperArea.icon.default": {
    "value": "var(--ghkSPg)",
    "variable": "var(--ghkSPg)"
  },
  "colors.FieldSet.helperArea.icon.error": {
    "value": "var(--gRrkQb)",
    "variable": "var(--gRrkQb)"
  },
  "colors.FieldSet.helperArea.text.default": {
    "value": "var(--kQmxXO)",
    "variable": "var(--kQmxXO)"
  },
  "colors.FieldSet.helperArea.text.error": {
    "value": "var(--enfBZZ)",
    "variable": "var(--enfBZZ)"
  },
  "colors.IconButton.onImpact.filled.critical.border.default": {
    "value": "var(--bZArWN)",
    "variable": "var(--bZArWN)"
  },
  "colors.IconButton.onImpact.filled.critical.border.hover": {
    "value": "var(--cwopHw)",
    "variable": "var(--cwopHw)"
  },
  "colors.IconButton.onImpact.bare.brand.border.default": {
    "value": "var(--ccKkIv)",
    "variable": "var(--ccKkIv)"
  },
  "colors.IconButton.onImpact.bare.brand.border.hover": {
    "value": "var(--dbrkmG)",
    "variable": "var(--dbrkmG)"
  },
  "colors.IconButton.onImpact.bare.brand.border.pressed": {
    "value": "var(--kEKyyq)",
    "variable": "var(--kEKyyq)"
  },
  "colors.Input.border.readOnly": {
    "value": "var(--fWJjLg)",
    "variable": "var(--fWJjLg)"
  },
  "colors.ProgressIndicator.circular.track.bg.default": {
    "value": "var(--FONTw)",
    "variable": "var(--FONTw)"
  },
  "colors.ProgressIndicator.circular.track.bg.active": {
    "value": "var(--dllpZH)",
    "variable": "var(--dllpZH)"
  },
  "colors.ProgressIndicator.spinner.text.default": {
    "value": "var(--mPGBG)",
    "variable": "var(--mPGBG)"
  },
  "colors.ProgressIndicator.spinner.text.onImpact": {
    "value": "var(--eClwnW)",
    "variable": "var(--eClwnW)"
  },
  "colors.ProgressMeter.Node.complete.border": {
    "value": "var(--jkYTOO)",
    "variable": "var(--jkYTOO)"
  },
  "colors.ProgressMeter.Node.incomplete.border": {
    "value": "var(--hjYVqV)",
    "variable": "var(--hjYVqV)"
  },
  "colors.Range.Track.bg.active": {
    "value": "var(--YVaYQ)",
    "variable": "var(--YVaYQ)"
  },
  "colors.Range.Handle.bg.activeActive": {
    "value": "var(--ewPRUZ)",
    "variable": "var(--ewPRUZ)"
  },
  "colors.Range.Handle.border.activeActive": {
    "value": "var(--knwxxw)",
    "variable": "var(--knwxxw)"
  },
  "colors.Tabs.file.label.hover": {
    "value": "var(--iGcKOj)",
    "variable": "var(--iGcKOj)"
  },
  "colors.Tabs.file.label.pressed": {
    "value": "var(--jGIZdD)",
    "variable": "var(--jGIZdD)"
  },
  "colors.Tabs.file.label.active": {
    "value": "var(--kqAeuZ)",
    "variable": "var(--kqAeuZ)"
  },
  "colors.Tabs.file.icon.default": {
    "value": "var(--gOceWj)",
    "variable": "var(--gOceWj)"
  },
  "colors.Tabs.file.icon.hover": {
    "value": "var(--eIhCxy)",
    "variable": "var(--eIhCxy)"
  },
  "colors.Tabs.file.icon.pressed": {
    "value": "var(--cphebq)",
    "variable": "var(--cphebq)"
  },
  "colors.Tabs.file.icon.active": {
    "value": "var(--eRznbQ)",
    "variable": "var(--eRznbQ)"
  },
  "radii.Button.xs": {
    "value": "var(--gurypJ)",
    "variable": "var(--gurypJ)"
  },
  "spacing.Accordion.Header.gap.between-tags": {
    "value": "var(--fRjuod)",
    "variable": "var(--fRjuod)"
  },
  "spacing.Accordion.Header.padding.vert": {
    "value": "var(--eyrvPl)",
    "variable": "var(--eyrvPl)"
  },
  "spacing.Alert.gap.message-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Input.sm.gap.input-toAdornment": {
    "value": "var(--hzyLYM)",
    "variable": "var(--hzyLYM)"
  },
  "spacing.Input.md.gap.input-toAdornment": {
    "value": "var(--dJoDHL)",
    "variable": "var(--dJoDHL)"
  },
  "spacing.Input.lg.gap.input-toAdornment": {
    "value": "var(--gmgJmR)",
    "variable": "var(--gmgJmR)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toSupportRows": {
    "value": "var(--fqMqrq)",
    "variable": "var(--fqMqrq)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toSupportRows": {
    "value": "var(--jZLUXs)",
    "variable": "var(--jZLUXs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.dataArea1-toSupportRows": {
    "value": "var(--gFynLZ)",
    "variable": "var(--gFynLZ)"
  },
  "sizes.DatePicker.Trigger.width": {
    "value": "var(--bRfJtM)",
    "variable": "var(--bRfJtM)"
  },
  "sizes.DatePicker.Trigger.height": {
    "value": "var(--bFDVuR)",
    "variable": "var(--bFDVuR)"
  },
  "sizes.FieldSet.helperArea.icon": {
    "value": "var(--lcRDBy)",
    "variable": "var(--lcRDBy)"
  },
  "colors.orangeRed.50": {
    "value": "var(--dpDvhr)",
    "variable": "var(--dpDvhr)"
  },
  "colors.orangeRed.100": {
    "value": "var(--GwWaz)",
    "variable": "var(--GwWaz)"
  },
  "colors.orangeRed.200": {
    "value": "var(--kpbOwc)",
    "variable": "var(--kpbOwc)"
  },
  "colors.orangeRed.300": {
    "value": "var(--ixqSBF)",
    "variable": "var(--ixqSBF)"
  },
  "colors.orangeRed.400": {
    "value": "var(--cwwyNq)",
    "variable": "var(--cwwyNq)"
  },
  "colors.orangeRed.500": {
    "value": "var(--fKtNAL)",
    "variable": "var(--fKtNAL)"
  },
  "colors.orangeRed.600": {
    "value": "var(--edCWxs)",
    "variable": "var(--edCWxs)"
  },
  "colors.orangeRed.700": {
    "value": "var(--clSaCV)",
    "variable": "var(--clSaCV)"
  },
  "colors.orangeRed.800": {
    "value": "var(--eFGYbC)",
    "variable": "var(--eFGYbC)"
  },
  "colors.orangeRed.900": {
    "value": "var(--hTEmOX)",
    "variable": "var(--hTEmOX)"
  },
  "colors.orangeRed.950": {
    "value": "var(--kquTxy)",
    "variable": "var(--kquTxy)"
  },
  "zIndex.zIndexMax": {
    "value": "var(--zKPqm)",
    "variable": "var(--zKPqm)"
  },
  "zIndex.zIndexOverLoader": {
    "value": "var(--cXYYyx)",
    "variable": "var(--cXYYyx)"
  },
  "zIndex.zIndexLoader": {
    "value": "var(--glkAWz)",
    "variable": "var(--glkAWz)"
  },
  "zIndex.zIndexOverOverlay": {
    "value": "var(--cbtuUK)",
    "variable": "var(--cbtuUK)"
  },
  "zIndex.zIndexOverlay": {
    "value": "var(--erlOIQ)",
    "variable": "var(--erlOIQ)"
  },
  "zIndex.zIndexOverParent": {
    "value": "var(--gzqnQc)",
    "variable": "var(--gzqnQc)"
  },
  "zIndex.zIndexParent": {
    "value": "var(--jNMRES)",
    "variable": "var(--jNMRES)"
  },
  "zIndex.zIndexStepOver": {
    "value": "var(--kahGnW)",
    "variable": "var(--kahGnW)"
  },
  "zIndex.zIndexStep": {
    "value": "var(--kYkWdE)",
    "variable": "var(--kYkWdE)"
  },
  "zIndex.zIndexBase": {
    "value": "var(--iAfmQv)",
    "variable": "var(--iAfmQv)"
  },
  "colors.icon.favorite.fill": {
    "value": "var(--gSbHPY)",
    "variable": "var(--gSbHPY)"
  },
  "colors.icon.favorite.stroke": {
    "value": "var(--cBRrJH)",
    "variable": "var(--cBRrJH)"
  },
  "colors.AdornedInput.bg.autofill": {
    "value": "var(--gAYaFw)",
    "variable": "var(--gAYaFw)"
  },
  "colors.Checkbox.bg.default": {
    "value": "var(--bonkpp)",
    "variable": "var(--bonkpp)"
  },
  "colors.Checkbox.bg.hover": {
    "value": "var(--kQtYjI)",
    "variable": "var(--kQtYjI)"
  },
  "colors.Checkbox.bg.pressed": {
    "value": "var(--fdcYTs)",
    "variable": "var(--fdcYTs)"
  },
  "colors.Input.bg.activeHover": {
    "value": "var(--fjalzB)",
    "variable": "var(--fjalzB)"
  },
  "colors.Tabs.default.bg.tab.default": {
    "value": "var(--gmLwi)",
    "variable": "var(--gmLwi)"
  },
  "colors.Tabs.default.bg.tab.hover": {
    "value": "var(--kFnXEv)",
    "variable": "var(--kFnXEv)"
  },
  "colors.Tabs.default.bg.tab.pressed": {
    "value": "var(--fjjnvP)",
    "variable": "var(--fjjnvP)"
  },
  "colors.Tabs.default.bg.tab.active": {
    "value": "var(--epUbPZ)",
    "variable": "var(--epUbPZ)"
  },
  "colors.Tabs.file.bg.tab.default": {
    "value": "var(--bvDSpr)",
    "variable": "var(--bvDSpr)"
  },
  "colors.Tabs.file.bg.tab.hover": {
    "value": "var(--cpjktu)",
    "variable": "var(--cpjktu)"
  },
  "colors.Tabs.file.bg.tab.pressed": {
    "value": "var(--bPvlKq)",
    "variable": "var(--bPvlKq)"
  },
  "colors.Tabs.file.bg.tab.active": {
    "value": "var(--hlLEWA)",
    "variable": "var(--hlLEWA)"
  },
  "colors.brand.primary": {
    "value": "var(--efvxBq)",
    "variable": "var(--efvxBq)"
  },
  "colors.brand.primaryHover": {
    "value": "var(--gijeAs)",
    "variable": "var(--gijeAs)"
  },
  "colors.brand.primaryActive": {
    "value": "var(--hmIkTS)",
    "variable": "var(--hmIkTS)"
  },
  "colors.error": {
    "value": "var(--bVsaMM)",
    "variable": "var(--bVsaMM)"
  },
  "colors.PropertyMap.canvas": {
    "value": "var(--dchJWO)",
    "variable": "var(--dchJWO)"
  },
  "colors.PropertyMap.unit.available": {
    "value": "var(--disiPo)",
    "variable": "var(--disiPo)"
  },
  "colors.PropertyMap.unit.hover": {
    "value": "var(--gALNZX)",
    "variable": "var(--gALNZX)"
  },
  "colors.PropertyMap.unit.current": {
    "value": "var(--cKqgVM)",
    "variable": "var(--cKqgVM)"
  },
  "colors.errorBg": {
    "value": "var(--dutAxp)",
    "variable": "var(--dutAxp)"
  },
  "colors.warningBg": {
    "value": "var(--dQwvKP)",
    "variable": "var(--dQwvKP)"
  },
  "colors.overlay": {
    "value": "var(--frzPIK)",
    "variable": "var(--frzPIK)"
  },
  "colors.focusRing": {
    "value": "var(--hHMGqy)",
    "variable": "var(--hHMGqy)"
  },
  "colors.focusRingSubtle": {
    "value": "var(--kfZJKH)",
    "variable": "var(--kfZJKH)"
  },
  "spacing.Modal.Header.padding.right": {
    "value": "var(--gfrCur)",
    "variable": "var(--gfrCur)"
  },
  "spacing.Modal.Header.padding.left": {
    "value": "var(--cZODTM)",
    "variable": "var(--cZODTM)"
  },
  "spacing.Modal.Header.padding.vert": {
    "value": "var(--eIeyvq)",
    "variable": "var(--eIeyvq)"
  },
  "spacing.Modal.Footer.padding.vert": {
    "value": "var(--kQXvXk)",
    "variable": "var(--kQXvXk)"
  },
  "sizes.listingCard.actions.backdropBlur": {
    "value": "var(--fGaYcM)",
    "variable": "var(--fGaYcM)"
  },
  "opacity.listingCardActionsBackdrop": {
    "value": "var(--fNAvyy)",
    "variable": "var(--fNAvyy)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar